webpackJsonp([0],{

/***/ 0:
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1);
	module.exports = __webpack_require__(332);


/***/ },

/***/ 332:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(333);
	//require('jquery/dist/jquery.js')
	//require('bootstrap/dist/js/bootstrap.js')
	__webpack_require__(334);
	__webpack_require__(335);

/***/ },

/***/ 333:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 335:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _reactDom = __webpack_require__(336);
	
	var _routes = __webpack_require__(500);
	
	var _routes2 = _interopRequireDefault(_routes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//Bugsnag
	Bugsnag.apiKey = 'f0cd61cb3ad78f85b48eaf5b9db76cd4';
	Bugsnag.autoNotify = true;
	Bugsnag.releaseStage =  false ? 'development' : 'production';
	Bugsnag.notifyReleaseStages = ['development', 'production'];
	Bugsnag.enableNotifyUnhandledRejections();
	Bugsnag.notifyHandler = 'xhr';
	
	var allRoutes = (0, _routes2.default)(JSON.parse(window.__DEFAULT_STATE));
	(0, _reactDom.render)(allRoutes, document.getElementById('app'));
	document.querySelector('[default-store]').remove();

/***/ },

/***/ 500:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reactRouter = __webpack_require__(501);
	
	var _reactRedux = __webpack_require__(557);
	
	var _Anonymous = __webpack_require__(592);
	
	var _Anonymous2 = _interopRequireDefault(_Anonymous);
	
	var _App = __webpack_require__(680);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _Logged = __webpack_require__(940);
	
	var _Logged2 = _interopRequireDefault(_Logged);
	
	var _Home = __webpack_require__(947);
	
	var _Home2 = _interopRequireDefault(_Home);
	
	var _Login = __webpack_require__(1270);
	
	var _Login2 = _interopRequireDefault(_Login);
	
	var _ResetPassword = __webpack_require__(1273);
	
	var _ResetPassword2 = _interopRequireDefault(_ResetPassword);
	
	var _NewPassword = __webpack_require__(1275);
	
	var _NewPassword2 = _interopRequireDefault(_NewPassword);
	
	var _SetPassword = __webpack_require__(1276);
	
	var _SetPassword2 = _interopRequireDefault(_SetPassword);
	
	var _Clients = __webpack_require__(1277);
	
	var _Clients2 = _interopRequireDefault(_Clients);
	
	var _Client = __webpack_require__(1282);
	
	var _Client2 = _interopRequireDefault(_Client);
	
	var _Hives = __webpack_require__(1297);
	
	var _Hives2 = _interopRequireDefault(_Hives);
	
	var _Users = __webpack_require__(1298);
	
	var _Users2 = _interopRequireDefault(_Users);
	
	var _User = __webpack_require__(1301);
	
	var _User2 = _interopRequireDefault(_User);
	
	var _store = __webpack_require__(1304);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _react = __webpack_require__(503);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _URLS = __webpack_require__(678);
	
	var _URLS2 = _interopRequireDefault(_URLS);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ensureSession = function ensureSession(store, ensureLogout) {
	    return function (nextState, replace, callback) {
	        var checkAuth = function checkAuth() {
	            var _store$getState = store.getState(),
	                session = _store$getState.session;
	
	            if (!ensureLogout && !session.user) replace(_URLS2.default.session.login);else if (ensureLogout && session.user) replace(_URLS2.default.home);
	            callback();
	        };
	        checkAuth();
	    };
	};
	
	exports.default = function (defaultStoreState) {
	    var store = (0, _store2.default)(defaultStoreState);
	    var routes = _react2.default.createElement(
	        _reactRedux.Provider,
	        { store: store },
	        _react2.default.createElement(
	            _reactRouter.Router,
	            { history: _reactRouter.browserHistory },
	            _react2.default.createElement(
	                _reactRouter.Route,
	                { component: _App2.default },
	                _react2.default.createElement(
	                    _reactRouter.Route,
	                    { path: _URLS2.default.session.login, component: _Anonymous2.default, onEnter: ensureSession(store, true) },
	                    _react2.default.createElement(_reactRouter.Route, { path: _URLS2.default.session.resetPassword, component: _ResetPassword2.default }),
	                    _react2.default.createElement(_reactRouter.Route, { path: _URLS2.default.session.setPassword, component: _SetPassword2.default }),
	                    _react2.default.createElement(_reactRouter.Route, { path: _URLS2.default.session.newPassword, component: _NewPassword2.default }),
	                    _react2.default.createElement(_reactRouter.IndexRoute, { component: _Login2.default })
	                ),
	                _react2.default.createElement(
	                    _reactRouter.Route,
	                    { path: _URLS2.default.home, component: _Logged2.default, onEnter: ensureSession(store) },
	                    _react2.default.createElement(
	                        _reactRouter.Route,
	                        { path: _URLS2.default.client.index, component: _Clients2.default },
	                        _react2.default.createElement(_reactRouter.Route, { path: _URLS2.default.client.show, component: _Client2.default })
	                    ),
	                    _react2.default.createElement(
	                        _reactRouter.Route,
	                        { path: _URLS2.default.users.index, component: _Users2.default },
	                        _react2.default.createElement(_reactRouter.Route, { path: _URLS2.default.users.show, component: _User2.default })
	                    ),
	                    _react2.default.createElement(_reactRouter.Route, { path: _URLS2.default.hives.index, component: _Hives2.default }),
	                    _react2.default.createElement(_reactRouter.IndexRoute, { component: _Home2.default })
	                )
	            )
	        )
	    );
	    return routes;
	};

/***/ },

/***/ 592:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(593);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(620);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(621);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(625);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(670);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(503);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(557);
	
	var _URLS = __webpack_require__(678);
	
	var _URLS2 = _interopRequireDefault(_URLS);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var logo = void 0;
	if (true) logo = __webpack_require__(679);
	
	var Anonymous = function (_Component) {
	    (0, _inherits3.default)(Anonymous, _Component);
	
	    function Anonymous() {
	        (0, _classCallCheck3.default)(this, Anonymous);
	        return (0, _possibleConstructorReturn3.default)(this, (Anonymous.__proto__ || (0, _getPrototypeOf2.default)(Anonymous)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(Anonymous, [{
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            if (this.props.session.loggingIn) this.context.router.push(_URLS2.default.home);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'text-center logo-alt-box' },
	                    _react2.default.createElement(
	                        'a',
	                        { href: _URLS2.default.home, className: 'logo' },
	                        _react2.default.createElement(
	                            'span',
	                            null,
	                            'Beeo',
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                'App'
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'h5',
	                        { className: 'text-muted m-t-0' },
	                        'Back-office'
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'wrapper-page' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'm-t-30 card-box' },
	                        this.props.children
	                    )
	                )
	            );
	        }
	    }]);
	    return Anonymous;
	}(_react.Component);
	
	Anonymous.contextTypes = {
	    router: _react.PropTypes.object.isRequired,
	    store: _react.PropTypes.object.isRequired
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	    var session = state.session;
	
	    return {
	        session: session
	    };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(Anonymous);

/***/ },

/***/ 678:
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var URLS = {
	    home: '/',
	    session: {
	        auth: '/api/auth',
	        login: '/login',
	        logout: '/logout',
	        isAuth: '/isAuth',
	        resetPassword: '/resetPassword',
	        magicLogin: '/magicLogin',
	        magicAuth: '/auth/magic',
	        updateCurrentUser: '/api/me',
	        updatePassword: '/api/password',
	        setPassword: '/setPassword',
	        forgotPassword: '/api/password/forgot',
	        newPassword: '/newPassword/:token'
	    },
	    app: {
	        data: '/api/app/data'
	    },
	    client: {
	        index: '/clients',
	        show: '/clients/:id',
	        new: '/api/clients',
	        get: '/api/clients',
	        update: '/api/clients/:id',
	        newHive: '/api/clients/:id/hives',
	        updateHive: '/api/clients/:id/hives/:hive'
	    },
	    hives: {
	        index: '/hives'
	    },
	    reports: {
	        new: '/api/reports',
	        get: '/api/reports/:id',
	        export: '/api/reports/exports'
	    },
	    users: {
	        index: '/users',
	        get: '/api/users',
	        put: '/api/users/:id',
	        show: '/users/:id',
	        new: '/users/new'
	    }
	};
	
	exports.default = URLS;

/***/ },

/***/ 679:
/***/ function(module, exports) {

	module.exports = "data:image/gif;base64,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"

/***/ },

/***/ 680:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(593);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(620);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(621);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(625);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(670);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(503);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(557);
	
	var _reactRouter = __webpack_require__(501);
	
	var _actions = __webpack_require__(681);
	
	var _sagas = __webpack_require__(716);
	
	var _Flashes = __webpack_require__(937);
	
	var _Flashes2 = _interopRequireDefault(_Flashes);
	
	var _URLS = __webpack_require__(678);
	
	var _URLS2 = _interopRequireDefault(_URLS);
	
	var _ProgressBar = __webpack_require__(939);
	
	var _ProgressBar2 = _interopRequireDefault(_ProgressBar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var App = function (_Component) {
	    (0, _inherits3.default)(App, _Component);
	
	    function App(props) {
	        (0, _classCallCheck3.default)(this, App);
	        return (0, _possibleConstructorReturn3.default)(this, (App.__proto__ || (0, _getPrototypeOf2.default)(App)).call(this, props));
	    }
	
	    (0, _createClass3.default)(App, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            //this.props.dispatch(isAuth())
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_Flashes2.default, null),
	                this.props.children,
	                _react2.default.createElement(_ProgressBar2.default, null)
	            );
	        }
	    }]);
	    return App;
	}(_react.Component);
	
	App.contextTypes = {
	    router: _react.PropTypes.object.isRequired,
	    store: _react.PropTypes.object.isRequired
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	    var session = state.session;
	
	    return {
	        session: session
	    };
	};
	
	//const preload = () => [[isomorphicAuth]]
	//App.preload = preload
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(App);

/***/ },

/***/ 681:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.socketConnection = exports.SOCKET_CONNECTION = exports.UpdatePasswordRequest = exports.ResetPasswordRequest = exports.CurrentUserRequest = exports.SetPasswordRequest = exports.LogoutRequest = exports.MagicLoginRequest = exports.LoginRequest = exports.IsAuthRequest = undefined;
	
	var _RequestsActions = __webpack_require__(682);
	
	var _RequestsActions2 = _interopRequireDefault(_RequestsActions);
	
	var _actions = __webpack_require__(683);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*isAuth: check if user is logged.*/
	var IsAuthRequest = exports.IsAuthRequest = new _RequestsActions2.default('IS_AUTH', { excludedMethods: ['post', 'put', 'delete'] });
	
	/*Login form*/
	var LoginRequest = exports.LoginRequest = new _RequestsActions2.default('LOGIN', { excludedMethods: ['get', 'put', 'delete'] });
	
	/*Magic login */
	var MagicLoginRequest = exports.MagicLoginRequest = new _RequestsActions2.default('MAGIC_LOGIN', { excludedMethods: ['get', 'put', 'delete'] });
	
	/*Logout*/
	var LogoutRequest = exports.LogoutRequest = new _RequestsActions2.default('LOGOUT', { excludedMethods: ['post', 'put', 'delete'] });
	
	var SetPasswordRequest = exports.SetPasswordRequest = new _RequestsActions2.default('SET_PASSWORD');
	
	/*Current user*/
	var CurrentUserRequest = exports.CurrentUserRequest = new _RequestsActions2.default('CURRENT_USER', { excludedMethods: ['post'] });
	
	var ResetPasswordRequest = exports.ResetPasswordRequest = new _RequestsActions2.default('RESET_PASSWORD', { excludedMethods: ['get', 'put', 'delete'] });
	
	var UpdatePasswordRequest = exports.UpdatePasswordRequest = new _RequestsActions2.default('UPDATE_PASSWORD', { excludedMethods: ['get', 'put', 'delete'] });
	
	/*Socket connection*/
	var SOCKET_CONNECTION = exports.SOCKET_CONNECTION = 'SOCKET_CONNECTION';
	var socketConnection = exports.socketConnection = function socketConnection(client) {
	  return (0, _actions.action)(SOCKET_CONNECTION, client);
	};

/***/ },

/***/ 682:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(620);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(621);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _actions = __webpack_require__(683);
	
	var _underscore = __webpack_require__(715);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var METHODS = ['get', 'post', 'put', 'delete'];
	
	/*
	    #Methods
	        ACTION: action type
	        action: Object who must be dispatched by the store
	        actions: Requests objects (REQUEST, SUCCESS, FAILURE, CANCEL)
	        types: Requests types (REQUEST, SUCCESS, FAILURE, CANCEL)
	    #OPTIONS
	        excludedMethods: ['get', 'post', 'put', 'delete']
	        moreMethods: ['method1', 'method2']                //Adds methods to defaults
	        overwrite: Boolean                                 //Overwrite defaults methods with 'moreMethods'
	        TODO: moreTypes: ['step1', 'step2']                      //Adds types to defaults (['REQUEST', 'SUCCESS', ..., 'ADDED_STEP'])
	*/
	
	var RequestsActions = function () {
	    function RequestsActions(KEY) {
	        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	        (0, _classCallCheck3.default)(this, RequestsActions);
	
	        this.KEY = KEY;
	        this.options = options;
	        this.methods = _underscore2.default.reject(METHODS, function (method) {
	            return options.excludedMethods && options.excludedMethods.indexOf(method.toLowerCase()) !== -1;
	        });
	        if (options.moreMethods && !options.overwrite) this.methods = this.methods.concat(options.moreMethods);else if (options.moreMethods) this.methods = options.moreMethods;
	        this.initMethods();
	    }
	
	    (0, _createClass3.default)(RequestsActions, [{
	        key: 'initMethods',
	        value: function initMethods() {
	            var _this = this;
	
	            this.methods.forEach(function (method) {
	                _this[method] = _this.initMethod(method);
	            });
	        }
	    }, {
	        key: 'initMethod',
	        value: function initMethod(method) {
	            var result = {};
	            result.ACTION = method.toUpperCase() + '_' + this.KEY;
	            result.TYPES = (0, _actions.createRequestTypes)(method.toUpperCase() + '_' + this.KEY, this.options.moreTypes);
	            result.actions = (0, _actions.createRequestActions)(result.TYPES, this.options.moreTypes);
	            result.action = function (payload) {
	                return (0, _actions.action)(result.ACTION, payload);
	            };
	            return result;
	        }
	    }]);
	    return RequestsActions;
	}();
	
	exports.default = RequestsActions;

/***/ },

/***/ 683:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.createRequestActions = exports.createRequestTypes = exports.socketAction = exports.action = undefined;
	
	var _extends2 = __webpack_require__(684);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _reduxSagaSc = __webpack_require__(689);
	
	var _camelCase = __webpack_require__(708);
	
	var _camelCase2 = _interopRequireDefault(_camelCase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var REQUEST = 'REQUEST';
	var SUCCESS = 'SUCCESS';
	var FAILURE = 'FAILURE';
	var CANCEL = 'CANCEL';
	var PROGRESS = 'PROGRESS';
	var TYPES = [REQUEST, SUCCESS, FAILURE, CANCEL, PROGRESS];
	
	var action = exports.action = function action(type) {
	    var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    return (0, _extends3.default)({ type: type }, payload);
	};
	
	var socketAction = exports.socketAction = function socketAction(type) {
	    var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    return (0, _reduxSagaSc.socketEmit)((0, _extends3.default)({ type: type }, payload));
	};
	
	var createRequestTypes = exports.createRequestTypes = function createRequestTypes(base) {
	    var moreTypes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	    return TYPES.concat(moreTypes).reduce(function (types, type) {
	        types[type.toUpperCase()] = base + '_' + type.toUpperCase();
	        return types;
	    }, {});
	};
	
	var createRequestActions = exports.createRequestActions = function createRequestActions(REQUEST_TYPES) {
	    var moreTypes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	    return TYPES.concat(moreTypes).reduce(function (actions, type) {
	        actions[(0, _camelCase2.default)(type)] = function (payload) {
	            return action(REQUEST_TYPES[type], { payload: payload });
	        };
	        return actions;
	    }, {});
	};

/***/ },

/***/ 716:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(717);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.isomorphicAuth = isomorphicAuth;
	
	var _flashes = __webpack_require__(719);
	
	var Flashes = _interopRequireWildcard(_flashes);
	
	var _effects = __webpack_require__(706);
	
	var _reduxForm = __webpack_require__(720);
	
	var _actions = __webpack_require__(681);
	
	var _actions2 = __webpack_require__(900);
	
	var _RequestSagas = __webpack_require__(901);
	
	var _RequestSagas2 = _interopRequireDefault(_RequestSagas);
	
	var _URLS = __webpack_require__(678);
	
	var _URLS2 = _interopRequireDefault(_URLS);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(isomorphicAuth);
	
	/*isAuth: check active session.*/
	var AuthSagas = new _RequestSagas2.default(_actions.IsAuthRequest.get, { method: 'GET', endpoint: _URLS2.default.session.isAuth });
	function isomorphicAuth(req) {
	    return _regenerator2.default.wrap(function isomorphicAuth$(_context) {
	        while (1) {
	            switch (_context.prev = _context.next) {
	                case 0:
	                    if (!req.currentUser) {
	                        _context.next = 5;
	                        break;
	                    }
	
	                    _context.next = 3;
	                    return (0, _effects.put)(_actions.IsAuthRequest.get.actions.success({ user: req.currentUser }));
	
	                case 3:
	                    _context.next = 7;
	                    break;
	
	                case 5:
	                    _context.next = 7;
	                    return (0, _effects.put)(_actions.IsAuthRequest.get.actions.failure({ error: 'session_expired_or_nonexistent', code: 401, method: 'isomorphic' }));
	
	                case 7:
	                case 'end':
	                    return _context.stop();
	            }
	        }
	    }, _marked, this);
	}
	
	/*Login*/
	var LoginSagas = new _RequestSagas2.default(_actions.LoginRequest.post, { method: 'POST', endpoint: _URLS2.default.session.login });
	LoginSagas.success = /*#__PURE__*/_regenerator2.default.mark(function _callee() {
	    return _regenerator2.default.wrap(function _callee$(_context2) {
	        while (1) {
	            switch (_context2.prev = _context2.next) {
	                case 0:
	                    _context2.next = 2;
	                    return (0, _effects.put)((0, _reduxForm.initialize)('login', {}));
	
	                case 2:
	                case 'end':
	                    return _context2.stop();
	            }
	        }
	    }, _callee, this);
	});
	LoginSagas.failure = /*#__PURE__*/_regenerator2.default.mark(function _callee2(action) {
	    return _regenerator2.default.wrap(function _callee2$(_context3) {
	        while (1) {
	            switch (_context3.prev = _context3.next) {
	                case 0:
	                    _context3.next = 2;
	                    return (0, _effects.put)((0, _actions2.flash)({ content: Flashes.loginFailure(action.payload.error) }));
	
	                case 2:
	                case 'end':
	                    return _context3.stop();
	            }
	        }
	    }, _callee2, this);
	});
	
	/*Logout*/
	var LogoutSagas = new _RequestSagas2.default(_actions.LogoutRequest.get, { method: 'GET', endpoint: _URLS2.default.session.logout });
	LogoutSagas.success = /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
	    return _regenerator2.default.wrap(function _callee3$(_context4) {
	        while (1) {
	            switch (_context4.prev = _context4.next) {
	                case 0:
	                    _context4.next = 2;
	                    return (0, _effects.put)((0, _actions2.flash)({ content: Flashes.logoutSuccess() }));
	
	                case 2:
	                    window.location = '/login';
	
	                case 3:
	                case 'end':
	                    return _context4.stop();
	            }
	        }
	    }, _callee3, this);
	});
	
	/*Magic Login*/
	var MagicLoginSagas = new _RequestSagas2.default(_actions.MagicLoginRequest.post, { method: 'POST', endpoint: _URLS2.default.session.magicLogin });
	MagicLoginSagas.success = /*#__PURE__*/_regenerator2.default.mark(function _callee4() {
	    return _regenerator2.default.wrap(function _callee4$(_context5) {
	        while (1) {
	            switch (_context5.prev = _context5.next) {
	                case 0:
	                    _context5.next = 2;
	                    return (0, _effects.put)((0, _actions2.flash)({ content: Flashes.magicLoginSuccess() }));
	
	                case 2:
	                case 'end':
	                    return _context5.stop();
	            }
	        }
	    }, _callee4, this);
	});
	
	/*Update current user*/
	var UpdateCurrentUserSagas = new _RequestSagas2.default(_actions.CurrentUserRequest.put, { method: 'PUT', endpoint: _URLS2.default.session.updateCurrentUser });
	UpdateCurrentUserSagas.success = /*#__PURE__*/_regenerator2.default.mark(function _callee5(action) {
	    return _regenerator2.default.wrap(function _callee5$(_context6) {
	        while (1) {
	            switch (_context6.prev = _context6.next) {
	                case 0:
	                    _context6.next = 2;
	                    return (0, _effects.put)((0, _actions2.flash)({ content: Flashes.updateCurrentUserSuccess(action.payload.user) }));
	
	                case 2:
	                case 'end':
	                    return _context6.stop();
	            }
	        }
	    }, _callee5, this);
	});
	
	/*Resetpassword */
	var ResetPassword = new _RequestSagas2.default(_actions.ResetPasswordRequest.post, { method: 'POST', endpoint: _URLS2.default.session.resetPassword });
	ResetPassword.success = /*#__PURE__*/_regenerator2.default.mark(function _callee6() {
	    return _regenerator2.default.wrap(function _callee6$(_context7) {
	        while (1) {
	            switch (_context7.prev = _context7.next) {
	                case 0:
	                case 'end':
	                    return _context7.stop();
	            }
	        }
	    }, _callee6, this);
	});
	
	/*Setpassword */
	var SetPassword = new _RequestSagas2.default(_actions.SetPasswordRequest.post, { method: 'POST', endpoint: _URLS2.default.session.setPassword });
	SetPassword.success = /*#__PURE__*/_regenerator2.default.mark(function _callee7() {
	    return _regenerator2.default.wrap(function _callee7$(_context8) {
	        while (1) {
	            switch (_context8.prev = _context8.next) {
	                case 0:
	                case 'end':
	                    return _context8.stop();
	            }
	        }
	    }, _callee7, this);
	});
	
	var UpdatePassword = new _RequestSagas2.default(_actions.UpdatePasswordRequest.post, { method: 'POST', endpoint: _URLS2.default.session.updatePassword });
	UpdatePassword.success = /*#__PURE__*/_regenerator2.default.mark(function _callee8() {
	    return _regenerator2.default.wrap(function _callee8$(_context9) {
	        while (1) {
	            switch (_context9.prev = _context9.next) {
	                case 0:
	                    window.location = '/';
	
	                case 1:
	                case 'end':
	                    return _context9.stop();
	            }
	        }
	    }, _callee8, this);
	});
	
	/*Export watchers sagas*/
	var sagas = [(0, _effects.fork)(AuthSagas.saga), (0, _effects.fork)(MagicLoginSagas.saga), (0, _effects.fork)(LoginSagas.saga), (0, _effects.fork)(LogoutSagas.saga), (0, _effects.fork)(UpdateCurrentUserSagas.saga), (0, _effects.fork)(ResetPassword.saga), (0, _effects.fork)(UpdatePassword.saga), (0, _effects.fork)(SetPassword.saga)];
	
	exports.default = sagas;

/***/ },

/***/ 719:
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var loginSuccess = exports.loginSuccess = function loginSuccess() {
	    return {
	        type: 'success',
	        title: 'Login success',
	        message: 'Welcome'
	    };
	};
	
	var loginFailure = exports.loginFailure = function loginFailure(error) {
	    return {
	        type: 'error',
	        title: 'Login error',
	        message: error
	    };
	};
	
	var logoutSuccess = exports.logoutSuccess = function logoutSuccess() {
	    return {
	        type: 'success',
	        title: 'Logout success',
	        message: 'Bye bye! See you soon!'
	    };
	};
	
	var magicLoginSuccess = exports.magicLoginSuccess = function magicLoginSuccess() {
	    return {
	        type: 'success',
	        title: 'Magic Login Success',
	        message: 'An email has been sent to you.'
	    };
	};
	
	var updateCurrentUserSuccess = exports.updateCurrentUserSuccess = function updateCurrentUserSuccess() {
	    return {
	        type: 'success',
	        title: 'Profile updated!'
	    };
	};

/***/ },

/***/ 900:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.flash = exports.flashes = exports.HIDE_FLASH = exports.NEW_FLASH = exports.FLASH = undefined;
	
	var _actions = __webpack_require__(683);
	
	var FLASH = exports.FLASH = 'FLASH';
	var NEW_FLASH = exports.NEW_FLASH = 'NEW_FLASH';
	var HIDE_FLASH = exports.HIDE_FLASH = 'HIDE_FLASH';
	var flashes = exports.flashes = {
	    add: function add(flash) {
	        return (0, _actions.action)(NEW_FLASH, { flash: flash });
	    },
	    hide: function hide(flash) {
	        return (0, _actions.action)(HIDE_FLASH, { flash: flash });
	    }
	};
	var flash = exports.flash = function flash(_flash) {
	    return (0, _actions.action)(FLASH, _flash);
	};

/***/ },

/***/ 901:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(717);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _classCallCheck2 = __webpack_require__(620);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(621);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _effects = __webpack_require__(706);
	
	var _api = __webpack_require__(902);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	    #Params
	        request: action request entity
	        api: function calling api
	    #Methods
	        success: generatior function
	        failure: generatior function
	*/
	
	var RequestSagas = function () {
	    function RequestSagas(request, api) {
	        (0, _classCallCheck3.default)(this, RequestSagas);
	
	        this.request = request;
	        this.api = api;
	        this.saga = this.saga.bind(this);
	        this.start = this.start.bind(this);
	        this.success = this.success.bind(this);
	        this.failure = this.failure.bind(this);
	    }
	
	    (0, _createClass3.default)(RequestSagas, [{
	        key: 'start',
	        value: /*#__PURE__*/_regenerator2.default.mark(function start(action) {
	            var endpoint, method, _ref, res, cancel, response, error, emitter;
	
	            return _regenerator2.default.wrap(function start$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            _context.next = 2;
	                            return (0, _effects.put)(this.request.actions.request());
	
	                        case 2:
	                            endpoint = (0, _api.makeEndpoint)(this.api.endpoint, action.params);
	                            method = this.api.method;
	
	                            if (!(method.toLowerCase() === 'get' || method.toLowerCase() === 'get')) {
	                                _context.next = 22;
	                                break;
	                            }
	
	                            _context.next = 7;
	                            return (0, _effects.race)({
	                                res: (0, _api.fetchApi)(endpoint, this.api.method, action.payload),
	                                cancel: (0, _effects.take)(this.request.actions.cancel().type)
	                            });
	
	                        case 7:
	                            _ref = _context.sent;
	                            res = _ref.res;
	                            cancel = _ref.cancel;
	
	                            if (!cancel) {
	                                _context.next = 12;
	                                break;
	                            }
	
	                            return _context.abrupt('return');
	
	                        case 12:
	                            response = res.response, error = res.error;
	
	                            if (!response) {
	                                _context.next = 18;
	                                break;
	                            }
	
	                            _context.next = 16;
	                            return (0, _effects.put)(this.request.actions.success(response));
	
	                        case 16:
	                            _context.next = 20;
	                            break;
	
	                        case 18:
	                            _context.next = 20;
	                            return (0, _effects.put)(this.request.actions.failure(error));
	
	                        case 20:
	                            _context.next = 25;
	                            break;
	
	                        case 22:
	                            emitter = (0, _api.callApi)(endpoint, this.api.method, action.payload, action.files, this.request.actions);
	                            _context.next = 25;
	                            return (0, _effects.fork)(this.progressListener, emitter);
	
	                        case 25:
	                        case 'end':
	                            return _context.stop();
	                    }
	                }
	            }, start, this);
	        })
	    }, {
	        key: 'success',
	        value: /*#__PURE__*/_regenerator2.default.mark(function success() {
	            return _regenerator2.default.wrap(function success$(_context2) {
	                while (1) {
	                    switch (_context2.prev = _context2.next) {
	                        case 0:
	                            if (false) console.info(this.request.TYPES.SUCCESS);
	
	                        case 1:
	                        case 'end':
	                            return _context2.stop();
	                    }
	                }
	            }, success, this);
	        })
	    }, {
	        key: 'failure',
	        value: /*#__PURE__*/_regenerator2.default.mark(function failure() {
	            return _regenerator2.default.wrap(function failure$(_context3) {
	                while (1) {
	                    switch (_context3.prev = _context3.next) {
	                        case 0:
	                            if (false) console.warn(this.request.TYPES.FAILURE);
	
	                        case 1:
	                        case 'end':
	                            return _context3.stop();
	                    }
	                }
	            }, failure, this);
	        })
	    }, {
	        key: 'progressListener',
	        value: /*#__PURE__*/_regenerator2.default.mark(function progressListener(chan) {
	            var action;
	            return _regenerator2.default.wrap(function progressListener$(_context4) {
	                while (1) {
	                    switch (_context4.prev = _context4.next) {
	                        case 0:
	                            if (false) {
	                                _context4.next = 8;
	                                break;
	                            }
	
	                            _context4.next = 3;
	                            return (0, _effects.take)(chan);
	
	                        case 3:
	                            action = _context4.sent;
	                            _context4.next = 6;
	                            return (0, _effects.put)(action);
	
	                        case 6:
	                            _context4.next = 0;
	                            break;
	
	                        case 8:
	                        case 'end':
	                            return _context4.stop();
	                    }
	                }
	            }, progressListener, this);
	        })
	    }, {
	        key: 'saga',
	        value: /*#__PURE__*/_regenerator2.default.mark(function saga() {
	            return _regenerator2.default.wrap(function saga$(_context5) {
	                while (1) {
	                    switch (_context5.prev = _context5.next) {
	                        case 0:
	                            _context5.next = 2;
	                            return [(0, _effects.takeLatest)(this.request.ACTION, this.start), (0, _effects.takeLatest)(this.request.TYPES.SUCCESS, this.success), (0, _effects.takeLatest)(this.request.TYPES.FAILURE, this.failure)];
	
	                        case 2:
	                        case 'end':
	                            return _context5.stop();
	                    }
	                }
	            }, saga, this);
	        })
	    }]);
	    return RequestSagas;
	}(); //import { fetchEntity } from 'client/core/sagas'
	
	
	exports.default = RequestSagas;

/***/ },

/***/ 902:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.makeEndpoint = exports.callApi = exports.fetchApi = undefined;
	
	var _promise = __webpack_require__(903);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _stringify = __webpack_require__(925);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _isomorphicFetch = __webpack_require__(927);
	
	var _isomorphicFetch2 = _interopRequireDefault(_isomorphicFetch);
	
	var _superagent = __webpack_require__(929);
	
	var _superagent2 = _interopRequireDefault(_superagent);
	
	var _reduxSaga = __webpack_require__(693);
	
	var _REGEXP = __webpack_require__(936);
	
	var _REGEXP2 = _interopRequireDefault(_REGEXP);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var apiHeaders = new Headers();
	apiHeaders.append('X-Requested-With', 'XMLHttpRequest');
	
	var fetchApi = exports.fetchApi = function fetchApi(endpoint) {
	    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    var options = {
	        method: 'GET',
	        mode: 'cors',
	        cache: 'default',
	        headers: apiHeaders,
	        credentials: 'include',
	        params: params
	        /*TODO PARAMS*/
	    };if (false) endpoint = 'http://127.0.0.1:' + __SERVER_PORT + endpoint;
	
	    endpoint += '?';
	    for (var i in params) {
	        endpoint += i + '=' + (0, _stringify2.default)(params[i]) + '&';
	    }
	
	    return (0, _isomorphicFetch2.default)(endpoint, options).then(function (response) {
	        return response.json().then(function (json) {
	            return { json: json, response: response };
	        });
	    }).then(function (_ref) {
	        var json = _ref.json,
	            response = _ref.response;
	
	        if (!response.ok) return _promise2.default.reject(json);
	        return json;
	    }).then(function (response) {
	        return { response: response };
	    }, function (error) {
	        return { error: error };
	    });
	};
	
	var callApi = exports.callApi = function callApi(endpoint, method, payload, files, entity) {
	    return (0, _reduxSaga.eventChannel)(function (emit) {
	        var req = _superagent2.default[method.toLowerCase()](endpoint).set('X-Requested-With', 'XMLHttpRequest');
	        //.set('Content-Type', 'application/json')
	        if (payload) {
	            for (var i in payload) {
	                if (payload[i] && i !== '_id' && i !== 'id') req.field(i, payload[i]);
	            }
	        }
	        if (files) {
	            for (var _i in files) {
	                req.attach('files', files[_i]);
	            }
	        }
	        req.on('progress', function (e) {
	            emit(entity.progress({ percent: e.percent }));
	        });
	        req.then(function (response) {
	            emit(entity.success(response.body));
	            emit(_reduxSaga.END);
	        });
	        req.catch(function (error) {
	            emit(entity.failure(error.response.body));
	            emit(_reduxSaga.END);
	        });
	        return function () {};
	    });
	};
	
	var makeEndpoint = exports.makeEndpoint = function makeEndpoint(endpoint) {
	    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    var matches = void 0;
	    while (matches = _REGEXP2.default.path.params.exec(endpoint)) {
	        var match = matches[1];
	        var param = params[match];
	        if (!param && match === 'id') param = params._id;
	        if (param) endpoint = endpoint.replace(':' + match, param);else if (false) console.warn('Make endpoint: param ' + match + ' not found.');
	    }
	    return endpoint;
	};

/***/ },

/***/ 936:
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var REGEXP = {
	    validations: {
	        email: /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,6})+$/,
	        userName: /^[a-zA-Z '"_\-.\u00E0-\u00FC]{2,}$/,
	        password: /^[a-zA-Z0-9\-\u00E0-\u00FC]{6,}$/
	    },
	    path: {
	        params: /\/:([a-z0-9]*)/gi
	    }
	};
	
	exports.default = REGEXP;

/***/ },

/***/ 937:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(593);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(620);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(621);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(625);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(670);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(503);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(557);
	
	var _Flash = __webpack_require__(938);
	
	var _Flash2 = _interopRequireDefault(_Flash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Flashes = function (_Component) {
	    (0, _inherits3.default)(Flashes, _Component);
	
	    function Flashes(props) {
	        (0, _classCallCheck3.default)(this, Flashes);
	        return (0, _possibleConstructorReturn3.default)(this, (Flashes.__proto__ || (0, _getPrototypeOf2.default)(Flashes)).call(this, props));
	    }
	
	    (0, _createClass3.default)(Flashes, [{
	        key: 'render',
	        value: function render() {
	            var flashNodes = this.props.flashes.all.map(function (flash, index) {
	                return _react2.default.createElement(_Flash2.default, { flash: flash, key: index });
	            });
	            if (!flashNodes[0]) return _react2.default.createElement('div', null);
	            return _react2.default.createElement(
	                'div',
	                { id: 'flashes-box' },
	                flashNodes
	            );
	        }
	    }]);
	    return Flashes;
	}(_react.Component);
	
	Flashes.contextTypes = {
	    store: _react.PropTypes.object.isRequired
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	    var flashes = state.flashes;
	
	    return {
	        flashes: flashes
	    };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(Flashes);

/***/ },

/***/ 938:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(593);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(620);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(621);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(625);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(670);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(503);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(557);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Flash = function (_Component) {
	    (0, _inherits3.default)(Flash, _Component);
	
	    function Flash() {
	        (0, _classCallCheck3.default)(this, Flash);
	        return (0, _possibleConstructorReturn3.default)(this, (Flash.__proto__ || (0, _getPrototypeOf2.default)(Flash)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(Flash, [{
	        key: 'render',
	        value: function render() {
	            var flash = this.props.flash;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'card-box flash flash-' + flash.type },
	                _react2.default.createElement(
	                    'h3',
	                    null,
	                    flash.title
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    flash.message
	                )
	            );
	        }
	    }]);
	    return Flash;
	}(_react.Component);
	
	Flash.propTypes = {
	    flash: _react.PropTypes.object.isRequired
	};
	
	exports.default = Flash;

/***/ },

/***/ 939:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(593);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(620);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(621);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(625);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(670);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(503);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(557);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProgressBar = function (_Component) {
	    (0, _inherits3.default)(ProgressBar, _Component);
	
	    function ProgressBar() {
	        (0, _classCallCheck3.default)(this, ProgressBar);
	        return (0, _possibleConstructorReturn3.default)(this, (ProgressBar.__proto__ || (0, _getPrototypeOf2.default)(ProgressBar)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(ProgressBar, [{
	        key: 'render',
	        value: function render() {
	            var progressBar = this.props.progressBar;
	
	            if (!progressBar.active) return _react2.default.createElement('div', null);
	            return _react2.default.createElement(
	                'div',
	                { id: 'progress-bar' },
	                _react2.default.createElement('div', { className: 'progress', style: { width: progressBar.percent + '%' } })
	            );
	        }
	    }]);
	    return ProgressBar;
	}(_react.Component);
	
	ProgressBar.propTypes = {
	    progressBar: _react.PropTypes.object.isRequired
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	    var progressBar = state.progressBar;
	
	    return {
	        progressBar: progressBar
	    };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(ProgressBar);

/***/ },

/***/ 940:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(593);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(620);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(621);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(625);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(670);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(503);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(557);
	
	var _Header = __webpack_require__(941);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _URLS = __webpack_require__(678);
	
	var _URLS2 = _interopRequireDefault(_URLS);
	
	var _actions = __webpack_require__(681);
	
	var _UpdatePassword = __webpack_require__(944);
	
	var _UpdatePassword2 = _interopRequireDefault(_UpdatePassword);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Logged = function (_Component) {
	    (0, _inherits3.default)(Logged, _Component);
	
	    function Logged() {
	        (0, _classCallCheck3.default)(this, Logged);
	        return (0, _possibleConstructorReturn3.default)(this, (Logged.__proto__ || (0, _getPrototypeOf2.default)(Logged)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(Logged, [{
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            //if (!this.props.session.loggingIn) this.context.router.push(URLS.session.login)
	        }
	    }, {
	        key: 'logout',
	        value: function logout() {
	            this.props.dispatch(_actions.LogoutRequest.get.action());
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_Header2.default, { logout: this.logout.bind(this), user: this.props.session.user }),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'wrapper' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'container' },
	                        !this.props.session.user || this.props.session.user.validated ? this.props.children : _react2.default.createElement(_UpdatePassword2.default, null)
	                    )
	                )
	            );
	        }
	    }]);
	    return Logged;
	}(_react.Component);
	
	Logged.contextTypes = {
	    router: _react.PropTypes.object.isRequired,
	    store: _react.PropTypes.object.isRequired,
	    session: _react.PropTypes.object
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	    var session = state.session;
	
	    return { session: session };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(Logged);

/***/ },

/***/ 941:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(593);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(620);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(621);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(625);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(670);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(503);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(501);
	
	var _URLS = __webpack_require__(678);
	
	var _URLS2 = _interopRequireDefault(_URLS);
	
	var _reactFontawesome = __webpack_require__(942);
	
	var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Header = function (_Component) {
	    (0, _inherits3.default)(Header, _Component);
	
	    function Header() {
	        (0, _classCallCheck3.default)(this, Header);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (Header.__proto__ || (0, _getPrototypeOf2.default)(Header)).call(this));
	
	        _this.state = {
	            navOpen: false
	        };
	        return _this;
	    }
	
	    (0, _createClass3.default)(Header, [{
	        key: 'isActiveNav',
	        value: function isActiveNav(urls) {
	            if (!_reactRouter.browserHistory) return;
	            return urls.indexOf(_reactRouter.browserHistory.getCurrentLocation().pathname) >= 0 ? 'active' : null;
	        }
	    }, {
	        key: 'openNav',
	        value: function openNav() {
	            this.setState({
	                navOpen: !this.state.navOpen
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'header',
	                { id: 'topnav' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'topbar-main' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'container' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'topbar-left' },
	                            _react2.default.createElement(
	                                _reactRouter.Link,
	                                { to: _URLS2.default.home, className: 'logo' },
	                                _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    'Beeo',
	                                    _react2.default.createElement(
	                                        'span',
	                                        null,
	                                        'App '
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'navbar-custom navbar-left' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'menu-item' },
	                                _react2.default.createElement(
	                                    'a',
	                                    { className: 'navbar-toggle ' + (this.state.navOpen ? "open" : "") },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'lines', onClick: this.openNav.bind(this) },
	                                        _react2.default.createElement('span', null),
	                                        _react2.default.createElement('span', null),
	                                        _react2.default.createElement('span', null)
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { id: 'navigation', style: { display: this.state.navOpen ? "block" : "none" } },
	                                _react2.default.createElement(
	                                    'ul',
	                                    { className: 'navigation-menu' },
	                                    _react2.default.createElement(
	                                        'li',
	                                        { className: this.isActiveNav([_URLS2.default.home]) },
	                                        _react2.default.createElement(
	                                            _reactRouter.Link,
	                                            { to: _URLS2.default.home },
	                                            _react2.default.createElement(
	                                                'span',
	                                                null,
	                                                _react2.default.createElement(_reactFontawesome2.default, { name: 'dashboard' })
	                                            ),
	                                            _react2.default.createElement(
	                                                'span',
	                                                null,
	                                                ' Dashboard '
	                                            )
	                                        )
	                                    ),
	                                    this.props.user && !this.props.user.limited && _react2.default.createElement(
	                                        'li',
	                                        { className: this.isActiveNav([_URLS2.default.hives.index]) },
	                                        _react2.default.createElement(
	                                            _reactRouter.Link,
	                                            { to: _URLS2.default.hives.index },
	                                            _react2.default.createElement(
	                                                'span',
	                                                null,
	                                                _react2.default.createElement(_reactFontawesome2.default, { name: 'archive' })
	                                            ),
	                                            _react2.default.createElement(
	                                                'span',
	                                                null,
	                                                ' Ruches '
	                                            )
	                                        )
	                                    ),
	                                    this.props.user && !this.props.user.limited && _react2.default.createElement(
	                                        'li',
	                                        { className: this.isActiveNav([_URLS2.default.client.index]) },
	                                        _react2.default.createElement(
	                                            _reactRouter.Link,
	                                            { to: _URLS2.default.client.index },
	                                            _react2.default.createElement(
	                                                'span',
	                                                null,
	                                                _react2.default.createElement(_reactFontawesome2.default, { name: 'user' })
	                                            ),
	                                            _react2.default.createElement(
	                                                'span',
	                                                null,
	                                                ' Clients '
	                                            )
	                                        )
	                                    ),
	                                    this.props.user && !this.props.user.limited && _react2.default.createElement(
	                                        'li',
	                                        { className: this.isActiveNav([_URLS2.default.users.index]) },
	                                        _react2.default.createElement(
	                                            _reactRouter.Link,
	                                            { to: _URLS2.default.users.index },
	                                            _react2.default.createElement(
	                                                'span',
	                                                null,
	                                                _react2.default.createElement(_reactFontawesome2.default, { name: 'users' })
	                                            ),
	                                            _react2.default.createElement(
	                                                'span',
	                                                null,
	                                                ' Utilisateurs '
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'navbar-custom navbar-right' },
	                            _react2.default.createElement(
	                                'ul',
	                                { className: 'nav navbar-nav navbar-right pull-right' },
	                                _react2.default.createElement(
	                                    'li',
	                                    null,
	                                    _react2.default.createElement(
	                                        'a',
	                                        { onClick: this.props.logout },
	                                        _react2.default.createElement(
	                                            'span',
	                                            null,
	                                            _react2.default.createElement(_reactFontawesome2.default, { name: 'power-off' })
	                                        ),
	                                        _react2.default.createElement(
	                                            'span',
	                                            null,
	                                            ' Logout '
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	    return Header;
	}(_react.Component);
	
	exports.default = Header;

/***/ },

/***/ 944:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(593);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(620);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(621);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(625);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(670);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _reactRedux = __webpack_require__(557);
	
	var _react = __webpack_require__(503);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _UpdatePasswordForm = __webpack_require__(945);
	
	var _UpdatePasswordForm2 = _interopRequireDefault(_UpdatePasswordForm);
	
	var _actions = __webpack_require__(681);
	
	var _reactFontawesome = __webpack_require__(942);
	
	var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UpdatePassword = function (_Component) {
	    (0, _inherits3.default)(UpdatePassword, _Component);
	
	    function UpdatePassword() {
	        (0, _classCallCheck3.default)(this, UpdatePassword);
	        return (0, _possibleConstructorReturn3.default)(this, (UpdatePassword.__proto__ || (0, _getPrototypeOf2.default)(UpdatePassword)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(UpdatePassword, [{
	        key: 'submit',
	        value: function submit(payload, dispatch) {
	            dispatch(_actions.UpdatePasswordRequest.post.action({ payload: payload }));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'col-md-4 col-md-offset-4' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'text-center' },
	                    _react2.default.createElement(
	                        'h4',
	                        { className: 'text-uppercase font-bold m-b-0' },
	                        'Update your password'
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'panel-body' },
	                    this.props.session.updatePasswordProgress ? _react2.default.createElement(_reactFontawesome2.default, { name: 'cog', spin: true }) : _react2.default.createElement(_UpdatePasswordForm2.default, { onSubmit: this.submit })
	                )
	            );
	        }
	    }]);
	    return UpdatePassword;
	}(_react.Component);
	
	UpdatePassword.contextTypes = {
	    router: _react.PropTypes.object.isRequired,
	    store: _react.PropTypes.object.isRequired,
	    session: _react.PropTypes.object
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	    var session = state.session;
	
	    return {
	        session: session
	    };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(UpdatePassword);

/***/ },

/***/ 945:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(593);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(620);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(621);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(625);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(670);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _reduxForm = __webpack_require__(720);
	
	var _react = __webpack_require__(503);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _InputField = __webpack_require__(946);
	
	var _InputField2 = _interopRequireDefault(_InputField);
	
	var _REGEXP = __webpack_require__(936);
	
	var _REGEXP2 = _interopRequireDefault(_REGEXP);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var validate = function validate(values) {
	    var errors = {};
	    if (!values.password || !values.password[5]) errors.password = 'Min. 6 caractères';else if (values.password !== values.verification) errors.verification = 'Incorrect';
	    return errors;
	};
	
	var UpdatePasswordForm = function (_Component) {
	    (0, _inherits3.default)(UpdatePasswordForm, _Component);
	
	    function UpdatePasswordForm() {
	        (0, _classCallCheck3.default)(this, UpdatePasswordForm);
	        return (0, _possibleConstructorReturn3.default)(this, (UpdatePasswordForm.__proto__ || (0, _getPrototypeOf2.default)(UpdatePasswordForm)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(UpdatePasswordForm, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                handleSubmit = _props.handleSubmit,
	                pristine = _props.pristine,
	                submitting = _props.submitting,
	                error = _props.error;
	
	            return _react2.default.createElement(
	                'form',
	                { onSubmit: handleSubmit, className: 'form-horizontal m-t-10' },
	                _react2.default.createElement(_reduxForm.Field, { name: 'password', component: _InputField2.default, type: 'password', placeholder: 'Mot de passe...' }),
	                _react2.default.createElement(_reduxForm.Field, { name: 'verification', component: _InputField2.default, type: 'password', placeholder: 'Verification...' }),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'form-group text-center m-t-30' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-12' },
	                        _react2.default.createElement(
	                            'button',
	                            { className: 'btn btn-custom btn-bordred btn-block waves-effect waves-light text-uppercase', type: 'submit', disabled: pristine || submitting },
	                            'Enregistrer'
	                        )
	                    )
	                ),
	                error ? _react2.default.createElement(
	                    'p',
	                    { className: 'error', id: 'login-error' },
	                    error
	                ) : null
	            );
	        }
	    }]);
	    return UpdatePasswordForm;
	}(_react.Component);
	
	UpdatePasswordForm.propTypes = {
	    onSubmit: _react.PropTypes.func.isRequired,
	    handleSubmit: _react.PropTypes.func.isRequired,
	    reset: _react.PropTypes.func.isRequired,
	    invalid: _react.PropTypes.bool.isRequired,
	    pristine: _react.PropTypes.bool.isRequired,
	    valid: _react.PropTypes.bool.isRequired,
	    submitting: _react.PropTypes.bool.isRequired
	};
	
	exports.default = UpdatePasswordForm = (0, _reduxForm.reduxForm)({
	    form: 'UpdatePassword',
	    validate: validate
	})(UpdatePasswordForm);

/***/ },

/***/ 946:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(684);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(503);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*TODO: classes managements*/
	var InputField = function InputField(_ref) {
	    var input = _ref.input,
	        _ref$className = _ref.className,
	        className = _ref$className === undefined ? 'form-control' : _ref$className,
	        _ref$containerClassNa = _ref.containerClassName,
	        containerClassName = _ref$containerClassNa === undefined ? 'col-xs-12' : _ref$containerClassNa,
	        _ref$divClass = _ref.divClass,
	        divClass = _ref$divClass === undefined ? 'form-group' : _ref$divClass,
	        label = _ref.label,
	        defaultValue = _ref.defaultValue,
	        placeholder = _ref.placeholder,
	        type = _ref.type,
	        autoComplete = _ref.autoComplete,
	        _ref$meta = _ref.meta,
	        touched = _ref$meta.touched,
	        error = _ref$meta.error,
	        warning = _ref$meta.warning;
	    return _react2.default.createElement(
	        'div',
	        { className: divClass },
	        label ? _react2.default.createElement(
	            'label',
	            null,
	            label
	        ) : null,
	        _react2.default.createElement(
	            'div',
	            { className: containerClassName },
	            _react2.default.createElement('input', (0, _extends3.default)({}, input, { className: className, placeholder: placeholder, type: type, autoComplete: autoComplete, defaultValue: defaultValue })),
	            touched && (error && _react2.default.createElement(
	                'span',
	                { className: 'error' },
	                error
	            ) || warning && _react2.default.createElement(
	                'span',
	                null,
	                warning
	            ))
	        )
	    );
	};
	
	exports.default = InputField;

/***/ },

/***/ 947:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _keys = __webpack_require__(948);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _getPrototypeOf = __webpack_require__(593);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(620);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(621);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(625);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(670);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(503);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(501);
	
	var _reactRedux = __webpack_require__(557);
	
	var _actions = __webpack_require__(681);
	
	var _actions2 = __webpack_require__(951);
	
	var _Cut = __webpack_require__(952);
	
	var _Cut2 = _interopRequireDefault(_Cut);
	
	var _actions3 = __webpack_require__(953);
	
	var _lib = __webpack_require__(954);
	
	var _Filters = __webpack_require__(966);
	
	var _Filters2 = _interopRequireDefault(_Filters);
	
	var _DeleteReportModal = __webpack_require__(987);
	
	var _DeleteReportModal2 = _interopRequireDefault(_DeleteReportModal);
	
	var _URLS = __webpack_require__(678);
	
	var _URLS2 = _interopRequireDefault(_URLS);
	
	var _reactFontawesome = __webpack_require__(942);
	
	var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);
	
	var _underscore = __webpack_require__(715);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _moment = __webpack_require__(1156);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _api = __webpack_require__(902);
	
	var _reactDatepicker = __webpack_require__(1266);
	
	var _reactDatepicker2 = _interopRequireDefault(_reactDatepicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Home = function (_Component) {
	    (0, _inherits3.default)(Home, _Component);
	
	    function Home() {
	        (0, _classCallCheck3.default)(this, Home);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (Home.__proto__ || (0, _getPrototypeOf2.default)(Home)).call(this));
	
	        _this.export = _this.export.bind(_this);
	        _this.setFilters = _this.setFilters.bind(_this);
	        _this.updateDate = _this.updateDate.bind(_this);
	        _this.displayReportModal = _this.displayReportModal.bind(_this);
	        _this.deleteReport = _this.deleteReport.bind(_this);
	        _this.state = {
	            fullCurrentReport: null,
	            currentReport: null,
	            editDate: false,
	            showDeleteModal: false
	        };
	        return _this;
	    }
	
	    (0, _createClass3.default)(Home, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.props.dispatch(_actions3.ReportsRequest.get.action());
	            this.props.dispatch(_actions2.ClientsRequest.get.action());
	        }
	    }, {
	        key: 'displayReportModal',
	        value: function displayReportModal(report) {
	            this.setState({
	                fullCurrentReport: report,
	                showDeleteModal: !this.state.showDeleteModal
	            });
	        }
	    }, {
	        key: 'deleteReport',
	        value: function deleteReport() {}
	    }, {
	        key: 'logout',
	        value: function logout() {
	            _actions.LogoutRequest.get.action();
	        }
	    }, {
	        key: 'activeReport',
	        value: function activeReport(currentReport) {
	            if (this.state.currentReport === currentReport) currentReport = null;
	            this.setState({
	                currentReport: currentReport,
	                editDate: false
	            });
	        }
	    }, {
	        key: 'editDate',
	        value: function editDate() {
	            this.setState({
	                editDate: !this.state.editDate
	            });
	        }
	    }, {
	        key: 'updateDate',
	        value: function updateDate(date) {
	            var currentReport = this.state.currentReport;
	
	            this.props.dispatch(_actions3.ReportsRequest.put.action({
	                payload: {
	                    date: date,
	                    _id: currentReport
	                },
	                params: {
	                    _id: currentReport
	                }
	            }));
	            this.setState({
	                editDate: false
	            });
	        }
	    }, {
	        key: 'deleteReport',
	        value: function deleteReport() {
	            var currentReport = this.state.currentReport;
	
	            this.props.dispatch(_actions3.ReportsRequest.delete.action({
	                payload: {
	                    _id: currentReport
	                },
	                params: {
	                    _id: currentReport
	                }
	            }));
	            this.setState({
	                displayReportModal: false,
	                currentReport: null,
	                fullCurrentReport: null
	            });
	        }
	    }, {
	        key: 'export',
	        value: function _export() {
	            this.props.dispatch(_actions3.ExportReportsRequest.get.action({
	                payload: { filters: this.props.reports.filters }
	            }));
	        }
	    }, {
	        key: 'setFilters',
	        value: function setFilters(filters, dispatch) {
	            dispatch((0, _actions3.reportsFiltersChange)({ filters: filters }));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props$reports = this.props.reports,
	                filters = _props$reports.filters,
	                search = _props$reports.search;
	
	            var haveReports = (0, _lib.getSelectReportsOptions)(this.props.client.all, this.props.reports.all)[0] ? true : false;
	            if (!this.props.user) return _react2.default.createElement('div', null);
	            /*refactor: beuruUuUurk*/
	            var exportURL = _URLS2.default.reports.export + '?';
	            if (filters && filters.type && filters.type[0]) {
	                filters.type.forEach(function (type) {
	                    exportURL += 'type=' + type + '&';
	                });
	            }
	            if (filters && filters.states && filters.states[0]) {
	                filters.states.forEach(function (state) {
	                    exportURL += 'state=' + state + '&';
	                });
	            }
	            if (filters && filters.clientCountry && filters.clientCountry[0]) {
	                filters.clientCountry.forEach(function (country) {
	                    exportURL += 'country=' + country + '&';
	                });
	            }
	            /*Bueueueurk */
	            if (search && search.key && search.value) exportURL += search.key + '=' + search.value + '&';
	
	            if (!haveReports) exportURL = '#';
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'h3',
	                    { className: 'page-title' },
	                    'Report',
	                    !this.props.user.limited && _react2.default.createElement(
	                        'div',
	                        { className: 'pull-right m-t-25' },
	                        _react2.default.createElement(
	                            'a',
	                            { className: 'btn btn-primary waves-effect', href: exportURL, disabled: !haveReports, target: haveReports ? '_blank' : '_self' },
	                            _react2.default.createElement(_reactFontawesome2.default, { name: 'file-excel-o' }),
	                            '\xA0 Export Excel'
	                        )
	                    )
	                ),
	                this.state.fullCurrentReport && _react2.default.createElement(_DeleteReportModal2.default, {
	                    show: this.state.showDeleteModal,
	                    display: this.displayReportModal,
	                    deleteReport: this.deleteReport,
	                    report: this.state.fullCurrentReport
	                }),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'card-box' },
	                    _react2.default.createElement(_Filters2.default, { onSubmit: this.setFilters, clients: this.props.client.all, user: this.props.user }),
	                    _react2.default.createElement(
	                        'div',
	                        {
	                            style: { overflowY: "scroll" }
	                        },
	                        _react2.default.createElement(
	                            'table',
	                            { className: 'table table-striped m-0 header-fixed' },
	                            _react2.default.createElement(
	                                'thead',
	                                null,
	                                _react2.default.createElement(
	                                    'tr',
	                                    null,
	                                    _react2.default.createElement(
	                                        'th',
	                                        null,
	                                        '#'
	                                    ),
	                                    _react2.default.createElement(
	                                        'th',
	                                        { style: { width: '110px' } },
	                                        'Date'
	                                    ),
	                                    _react2.default.createElement(
	                                        'th',
	                                        null,
	                                        'Client'
	                                    ),
	                                    _react2.default.createElement(
	                                        'th',
	                                        { style: { width: '70px' } },
	                                        'Ruche'
	                                    ),
	                                    _react2.default.createElement(
	                                        'th',
	                                        { style: { width: '90px' } },
	                                        'Type'
	                                    ),
	                                    _react2.default.createElement(
	                                        'th',
	                                        null,
	                                        'Visit'
	                                    ),
	                                    _react2.default.createElement(
	                                        'th',
	                                        { style: { width: '40px' } },
	                                        'Nourris.'
	                                    ),
	                                    _react2.default.createElement(
	                                        'th',
	                                        { style: { width: '40px' } },
	                                        'Trait.'
	                                    ),
	                                    _react2.default.createElement(
	                                        'th',
	                                        { style: { width: '40px' } },
	                                        'Mat. m.'
	                                    ),
	                                    _react2.default.createElement(
	                                        'th',
	                                        { style: { width: '40px' } },
	                                        'To do'
	                                    ),
	                                    _react2.default.createElement(
	                                        'th',
	                                        { style: { width: '40px' } },
	                                        'Mal.'
	                                    ),
	                                    _react2.default.createElement(
	                                        'th',
	                                        { style: { width: '40px' } },
	                                        'Rei.'
	                                    ),
	                                    _react2.default.createElement(
	                                        'th',
	                                        { style: { width: '40px' } },
	                                        'Oeu.'
	                                    ),
	                                    _react2.default.createElement(
	                                        'th',
	                                        { style: { width: '40px' } },
	                                        'Pol.'
	                                    ),
	                                    _react2.default.createElement(
	                                        'th',
	                                        { style: { width: '40px' } },
	                                        'Miel'
	                                    ),
	                                    _react2.default.createElement(
	                                        'th',
	                                        { style: { width: '40px' } },
	                                        'Pr\xE9l.'
	                                    ),
	                                    _react2.default.createElement(
	                                        'th',
	                                        { style: { width: '40px' } },
	                                        'Cel. Roy.'
	                                    ),
	                                    _react2.default.createElement(
	                                        'th',
	                                        { style: { width: '40px' } },
	                                        'Ru. Peupl.'
	                                    ),
	                                    _react2.default.createElement(
	                                        'th',
	                                        { style: { width: '40px' } },
	                                        'Divi.'
	                                    ),
	                                    _react2.default.createElement(
	                                        'th',
	                                        { style: { width: '40px' } },
	                                        'Etat gen.'
	                                    )
	                                )
	                            ),
	                            (0, _lib.getReportsByFilters)(this.props.reports.all, this.props.reports.filters, this.props.reports.search).map(function (report) {
	                                return _react2.default.createElement(
	                                    'tbody',
	                                    { key: report._id },
	                                    _react2.default.createElement(
	                                        'tr',
	                                        { onClick: _this2.activeReport.bind(_this2, report._id), className: _this2.state.currentReport === report._id ? 'cursor-pointer active' : 'cursor-pointer' },
	                                        _react2.default.createElement(
	                                            'th',
	                                            { scope: 'row' },
	                                            report.visitNumber
	                                        ),
	                                        _react2.default.createElement(
	                                            'td',
	                                            { style: { width: '110px' } },
	                                            (0, _moment2.default)(report.created).format('DD/MM/YYYY')
	                                        ),
	                                        _react2.default.createElement(
	                                            'td',
	                                            null,
	                                            _react2.default.createElement(_Cut2.default, { string: report.client.name, cut: 14, more: '.' })
	                                        ),
	                                        _react2.default.createElement(
	                                            'td',
	                                            null,
	                                            report.hive.state === 'dead' && _react2.default.createElement(_reactFontawesome2.default, { name: 'exclamation' }),
	                                            report.hive.identifier
	                                        ),
	                                        _react2.default.createElement(
	                                            'td',
	                                            null,
	                                            _react2.default.createElement(_Cut2.default, { string: (0, _lib.getTypeLabel)(report.type, 'fr', true), cut: 10, more: '.' })
	                                        ),
	                                        _react2.default.createElement(
	                                            'td',
	                                            null,
	                                            report.type === 'dead' ? _react2.default.createElement(
	                                                'span',
	                                                null,
	                                                _react2.default.createElement(_reactFontawesome2.default, { name: 'warning', className: 'error' }),
	                                                '\xA0 Colonie morte'
	                                            ) : _react2.default.createElement(_Cut2.default, { string: (0, _lib.getDataLabel)('visit', report.visit), cut: 20, more: '.' })
	                                        ),
	                                        _react2.default.createElement(
	                                            'td',
	                                            null,
	                                            report.feeding_bak ? _react2.default.createElement(_Cut2.default, { string: (0, _lib.getDataLabel)('feeding_bak', report.feeding_bak), cut: 20, more: '.' }) : report.feeding_bak2 ? report.feeding_bak2 : _react2.default.createElement(_Cut2.default, { string: (0, _lib.getDataLabel)('feeding', report.feeding), cut: 20, more: '.' })
	                                        ),
	                                        _react2.default.createElement(
	                                            'td',
	                                            null,
	                                            report.treatment_bak ? _react2.default.createElement(_Cut2.default, { string: (0, _lib.getDataLabel)('treatment_bak', report.treatment_bak), cut: 20, more: '.' }) : report.treatment_bak2 ? report.treatment_bak_2 : _react2.default.createElement(_Cut2.default, { string: (0, _lib.getDataLabel)('treatment', report.treatment), cut: 20, more: '.' })
	                                        ),
	                                        _react2.default.createElement(
	                                            'td',
	                                            null,
	                                            (0, _lib.isForType)(report.type, 'missingMaterials') ? (0, _lib.multipleCount)(report.missingMaterials) : ''
	                                        ),
	                                        _react2.default.createElement(
	                                            'td',
	                                            null,
	                                            (0, _lib.isForType)(report.type, 'toDo') ? (0, _lib.multipleCount)(report.toDo) : ''
	                                        ),
	                                        _react2.default.createElement(
	                                            'td',
	                                            null,
	                                            (0, _lib.isForType)(report.type, 'maladies') ? (0, _lib.booleansCount)(report.maladies) : ''
	                                        ),
	                                        _react2.default.createElement(
	                                            'td',
	                                            null,
	                                            (0, _lib.isForType)(report.type, 'queen') ? report.queen ? _react2.default.createElement(_reactFontawesome2.default, { name: 'check' }) : _react2.default.createElement(_reactFontawesome2.default, { name: 'remove' }) : ''
	                                        ),
	                                        _react2.default.createElement(
	                                            'td',
	                                            null,
	                                            (0, _lib.isForType)(report.type, 'eggs') ? report.eggs ? _react2.default.createElement(_reactFontawesome2.default, { name: 'check' }) : _react2.default.createElement(_reactFontawesome2.default, { name: 'remove' }) : ''
	                                        ),
	                                        _react2.default.createElement(
	                                            'td',
	                                            null,
	                                            (0, _lib.isForType)(report.type, 'pollen') && report.pollenEval === undefined ? report.pollen ? _react2.default.createElement(_reactFontawesome2.default, { name: 'check' }) : _react2.default.createElement(_reactFontawesome2.default, { name: 'remove' }) : '',
	                                            (0, _lib.isForType)(report.type, 'pollenEval') ? _react2.default.createElement(_Cut2.default, { string: (0, _lib.getDataLabel)('pollenEval', report.pollenEval), cut: 4, more: '.' }) : ''
	                                        ),
	                                        _react2.default.createElement(
	                                            'td',
	                                            null,
	                                            (0, _lib.isForType)(report.type, 'honey') && report.honeyEval === undefined ? report.honey ? _react2.default.createElement(_reactFontawesome2.default, { name: 'check' }) : _react2.default.createElement(_reactFontawesome2.default, { name: 'remove' }) : '',
	                                            (0, _lib.isForType)(report.type, 'honeyEval') ? _react2.default.createElement(_Cut2.default, { string: (0, _lib.getDataLabel)('honeyEval', report.honeyEval), cut: 4, more: '.' }) : ''
	                                        ),
	                                        _react2.default.createElement(
	                                            'td',
	                                            null,
	                                            (0, _lib.isForType)(report.type, 'sample') ? _react2.default.createElement(
	                                                'span',
	                                                null,
	                                                _react2.default.createElement(
	                                                    'strong',
	                                                    null,
	                                                    report.sampleNumber
	                                                )
	                                            ) : ''
	                                        ),
	                                        _react2.default.createElement(
	                                            'td',
	                                            null,
	                                            (0, _lib.isForType)(report.type, 'royalCells') ? report.royalCells || report.royalCells_bak ? _react2.default.createElement(_reactFontawesome2.default, { name: 'check' }) : _react2.default.createElement(_reactFontawesome2.default, { name: 'remove' }) : ''
	                                        ),
	                                        _react2.default.createElement(
	                                            'td',
	                                            null,
	                                            (0, _lib.isForType)(report.type, 'populatedLanes') ? report.populatedLanes : '',
	                                            (0, _lib.isForType)(report.type, 'populatedLanesEval') ? _react2.default.createElement(_Cut2.default, { string: (0, _lib.getDataLabel)('populatedLanesEval', report.populatedLanesEval), cut: 4, more: '.' }) : ''
	                                        ),
	                                        _react2.default.createElement(
	                                            'td',
	                                            null,
	                                            (0, _lib.isForType)(report.type, 'division') ? report.division ? _react2.default.createElement(_reactFontawesome2.default, { name: 'check' }) : _react2.default.createElement(_reactFontawesome2.default, { name: 'remove' }) : ''
	                                        ),
	                                        _react2.default.createElement(
	                                            'td',
	                                            null,
	                                            (0, _lib.isForType)(report.type, 'hiveState') ? report.hiveState ? _react2.default.createElement(_reactFontawesome2.default, { name: 'check' }) : _react2.default.createElement(_reactFontawesome2.default, { name: 'remove' }) : ''
	                                        )
	                                    ),
	                                    _this2.state.currentReport === report._id ? _react2.default.createElement(
	                                        'tr',
	                                        null,
	                                        _react2.default.createElement(
	                                            'td',
	                                            { colSpan: '19' },
	                                            _react2.default.createElement(
	                                                'h4',
	                                                null,
	                                                (0, _lib.getDataLabel)('visit', report.visit),
	                                                ' ',
	                                                (0, _lib.getTypeLabel)(report.type),
	                                                '  -\xA0',
	                                                _this2.props.user.limited ? _react2.default.createElement(
	                                                    'span',
	                                                    null,
	                                                    report.client.name
	                                                ) : _react2.default.createElement(
	                                                    _reactRouter.Link,
	                                                    { to: (0, _api.makeEndpoint)(_URLS2.default.client.show, report.client) },
	                                                    report.client.name
	                                                ),
	                                                _react2.default.createElement(
	                                                    'a',
	                                                    { className: 'btn btn-danger btn-xs waves-effect pull-right', onClick: _this2.displayReportModal.bind(_this2, report) },
	                                                    'Supprimer'
	                                                )
	                                            ),
	                                            report.sample && _react2.default.createElement(
	                                                'p',
	                                                null,
	                                                'Pr\xE9l\xE8vement: ',
	                                                _react2.default.createElement(
	                                                    'strong',
	                                                    null,
	                                                    report.sampleNumber
	                                                ),
	                                                ' - ',
	                                                (0, _lib.getDataLabel)('sample', report.sample)
	                                            ),
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'row-fluid' },
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'col-md-8 col-xs-6' },
	                                                    _react2.default.createElement(
	                                                        'p',
	                                                        null,
	                                                        _react2.default.createElement(_reactFontawesome2.default, { name: 'user' }),
	                                                        '\xA0',
	                                                        _react2.default.createElement(
	                                                            'span',
	                                                            null,
	                                                            report.user.firstName,
	                                                            ' ',
	                                                            report.user.lastName,
	                                                            ' @\xA0',
	                                                            _react2.default.createElement(
	                                                                'span',
	                                                                null,
	                                                                _react2.default.createElement(_reactDatepicker2.default, {
	                                                                    selected: (0, _moment2.default)(report.created),
	                                                                    onChange: _this2.updateDate,
	                                                                    dateFormat: 'DD/MM/YYYY',
	                                                                    customInput: _react2.default.createElement(
	                                                                        'a',
	                                                                        { style: { cursor: 'pointer' } },
	                                                                        (0, _moment2.default)(report.created).format('DD/MM/YYYY')
	                                                                    )
	                                                                })
	                                                            )
	                                                        )
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'blockquote',
	                                                        null,
	                                                        report.comment
	                                                    ),
	                                                    _react2.default.createElement('hr', null),
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: 'row' },
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { className: 'col-md-6 col-xs-12' },
	                                                            _react2.default.createElement(
	                                                                'h5',
	                                                                null,
	                                                                'Mat\xE9riel manquant'
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'ul',
	                                                                null,
	                                                                report.missingMaterials.map(function (material) {
	                                                                    return _react2.default.createElement(
	                                                                        'li',
	                                                                        { key: material },
	                                                                        (0, _lib.getDataLabel)('missingMaterials', material, 'fr')
	                                                                    );
	                                                                })
	                                                            )
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { className: 'col-md-6 col-xs-12' },
	                                                            _react2.default.createElement(
	                                                                'h5',
	                                                                null,
	                                                                'A faire lors de la prochaine visite'
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'ul',
	                                                                null,
	                                                                report.toDo.map(function (task) {
	                                                                    return _react2.default.createElement(
	                                                                        'li',
	                                                                        { key: task },
	                                                                        (0, _lib.getDataLabel)('toDo', task, 'fr')
	                                                                    );
	                                                                })
	                                                            )
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { className: 'row' },
	                                                            _react2.default.createElement(
	                                                                'div',
	                                                                { className: 'col-md-6 col-xs-12' },
	                                                                _react2.default.createElement(
	                                                                    'h5',
	                                                                    null,
	                                                                    'Maladies'
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    'ul',
	                                                                    null,
	                                                                    (0, _keys2.default)(report.maladies).map(function (key) {
	                                                                        return report.maladies[key] ? _react2.default.createElement(
	                                                                            'li',
	                                                                            { key: key },
	                                                                            (0, _lib.getDataLabel)('maladies', key)
	                                                                        ) : null;
	                                                                    })
	                                                                )
	                                                            )
	                                                        )
	                                                    )
	                                                ),
	                                                (0, _lib.isForType)(report.type, 'frames') && _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'col-md-4 col-xs-12 m-b-8' },
	                                                    _react2.default.createElement(
	                                                        'table',
	                                                        { className: 'table m-0 header-fixed' },
	                                                        _react2.default.createElement(
	                                                            'thead',
	                                                            null,
	                                                            _react2.default.createElement(
	                                                                'tr',
	                                                                null,
	                                                                _react2.default.createElement(
	                                                                    'th',
	                                                                    null,
	                                                                    'Cadre'
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    'th',
	                                                                    null,
	                                                                    'Couvain'
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    'th',
	                                                                    null,
	                                                                    'Nectar'
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    'th',
	                                                                    null,
	                                                                    'Pollen'
	                                                                )
	                                                            )
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'tbody',
	                                                            null,
	                                                            report.frames.map(function (frame, index) {
	                                                                return _react2.default.createElement(
	                                                                    'tr',
	                                                                    { key: index },
	                                                                    _react2.default.createElement(
	                                                                        'th',
	                                                                        null,
	                                                                        index + 1
	                                                                    ),
	                                                                    _react2.default.createElement(
	                                                                        'td',
	                                                                        null,
	                                                                        frame && frame.brood ? frame.brood : '0'
	                                                                    ),
	                                                                    _react2.default.createElement(
	                                                                        'td',
	                                                                        null,
	                                                                        frame && frame.nectar ? frame.nectar : '0'
	                                                                    ),
	                                                                    _react2.default.createElement(
	                                                                        'td',
	                                                                        null,
	                                                                        frame && frame.pollen ? frame.pollen : '0'
	                                                                    )
	                                                                );
	                                                            }),
	                                                            _react2.default.createElement(
	                                                                'tr',
	                                                                null,
	                                                                _react2.default.createElement(
	                                                                    'th',
	                                                                    null,
	                                                                    'TOTAL'
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    'td',
	                                                                    null,
	                                                                    (0, _lib.getFrameCount)(report.frames, 'brood')
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    'td',
	                                                                    null,
	                                                                    (0, _lib.getFrameCount)(report.frames, 'nectar')
	                                                                ),
	                                                                _react2.default.createElement(
	                                                                    'td',
	                                                                    null,
	                                                                    (0, _lib.getFrameCount)(report.frames, 'pollen')
	                                                                )
	                                                            )
	                                                        )
	                                                    )
	                                                )
	                                            )
	                                        )
	                                    ) : null
	                                );
	                            })
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	    return Home;
	}(_react.Component);
	
	Home.contextTypes = {
	    router: _react.PropTypes.object.isRequired,
	    store: _react.PropTypes.object.isRequired,
	    user: _react.PropTypes.object
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	    var session = state.session,
	        reports = state.reports,
	        client = state.client;
	
	    return { user: session.user, reports: reports, client: client };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(Home);

/***/ },

/***/ 951:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.clientSearchChange = exports.CLIENT_SEARCH_CHANGE = exports.setCurrentClient = exports.SET_CURRENT_CLIENT = exports.HiveRequest = exports.ClientsRequest = undefined;
	
	var _RequestsActions = __webpack_require__(682);
	
	var _RequestsActions2 = _interopRequireDefault(_RequestsActions);
	
	var _actions = __webpack_require__(683);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ClientsRequest = exports.ClientsRequest = new _RequestsActions2.default('CLIENTS');
	var HiveRequest = exports.HiveRequest = new _RequestsActions2.default('HIVE');
	
	/*Set current*/
	var SET_CURRENT_CLIENT = exports.SET_CURRENT_CLIENT = 'SET_CURRENT_CLIENT';
	var setCurrentClient = exports.setCurrentClient = function setCurrentClient(_id) {
	  return (0, _actions.action)(SET_CURRENT_CLIENT, { _id: _id });
	};
	
	var CLIENT_SEARCH_CHANGE = exports.CLIENT_SEARCH_CHANGE = 'CLIENT_SEARCH_CHANGE';
	var clientSearchChange = exports.clientSearchChange = function clientSearchChange(payload) {
	  return (0, _actions.action)(CLIENT_SEARCH_CHANGE, { payload: payload });
	};

/***/ },

/***/ 952:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(593);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(620);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(621);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(625);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(670);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(503);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Cut = function (_Component) {
	    (0, _inherits3.default)(Cut, _Component);
	
	    function Cut() {
	        (0, _classCallCheck3.default)(this, Cut);
	        return (0, _possibleConstructorReturn3.default)(this, (Cut.__proto__ || (0, _getPrototypeOf2.default)(Cut)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(Cut, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                cut = _props.cut,
	                more = _props.more;
	            var string = this.props.string;
	
	            if (string && cut && string.length > cut) {
	                string = string.substring(0, cut);
	                if (more) string += more;
	            }
	            return _react2.default.createElement(
	                'span',
	                { className: this.props.className },
	                string
	            );
	        }
	    }]);
	    return Cut;
	}(_react.Component);
	
	exports.default = Cut;

/***/ },

/***/ 953:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.socketNewReport = exports.SOCKET_NEW_REPORT = exports.reportsSearchChange = exports.REPORTS_SEARCH_CHANGE = exports.reportsFiltersChange = exports.REPORTS_FILTERS_CHANGE = exports.ExportReportsRequest = exports.ReportsRequest = undefined;
	
	var _RequestsActions = __webpack_require__(682);
	
	var _RequestsActions2 = _interopRequireDefault(_RequestsActions);
	
	var _actions = __webpack_require__(683);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ReportsRequest = exports.ReportsRequest = new _RequestsActions2.default('REPORTS');
	var ExportReportsRequest = exports.ExportReportsRequest = new _RequestsActions2.default('EXPORT_REPORTS');
	
	var REPORTS_FILTERS_CHANGE = exports.REPORTS_FILTERS_CHANGE = 'REPORTS_FILTERS_CHANGE';
	var reportsFiltersChange = exports.reportsFiltersChange = function reportsFiltersChange(payload) {
	  return (0, _actions.action)(REPORTS_FILTERS_CHANGE, { payload: payload });
	};
	var REPORTS_SEARCH_CHANGE = exports.REPORTS_SEARCH_CHANGE = 'REPORTS_SEARCH_CHANGE';
	var reportsSearchChange = exports.reportsSearchChange = function reportsSearchChange(payload) {
	  return (0, _actions.action)(REPORTS_SEARCH_CHANGE, { payload: payload });
	};
	
	/*Socket connection*/
	var SOCKET_NEW_REPORT = exports.SOCKET_NEW_REPORT = 'SOCKET_NEW_REPORT';
	var socketNewReport = exports.socketNewReport = function socketNewReport(payload) {
	  return (0, _actions.action)(SOCKET_NEW_REPORT, payload);
	};

/***/ },

/***/ 954:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getSelectReportsOptions = exports.getReportsByFilters = exports.booleansCount = exports.getFrameCount = exports.multipleCount = exports.getUser = exports.getDataLabel = exports.getTypeLabel = exports.isForType = undefined;
	
	var _toConsumableArray2 = __webpack_require__(955);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _REPORT = __webpack_require__(960);
	
	var _REPORT2 = _interopRequireDefault(_REPORT);
	
	var _USERS = __webpack_require__(964);
	
	var _USERS2 = _interopRequireDefault(_USERS);
	
	var _underscore = __webpack_require__(715);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _lodash = __webpack_require__(965);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var REPORT = (0, _lodash.cloneDeep)(_REPORT2.default);
	
	var isForType = exports.isForType = function isForType(reportType, name) {
	    var field = _underscore2.default.findWhere(_REPORT2.default.fields, { name: name });
	    return field.applicableTypes.indexOf(reportType) !== -1;
	};
	
	var getTypeLabel = exports.getTypeLabel = function getTypeLabel(value) {
	    var lang = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'fr';
	    var short = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	    var type = _underscore2.default.findWhere(REPORT.types, { value: value });
	    if (short) return String(type.shortLabel[lang]);
	    return String(type.label[lang]);
	};
	
	var getDataLabel = exports.getDataLabel = function getDataLabel(name, value) {
	    var lang = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'fr';
	
	    var report = _underscore2.default.findWhere(REPORT.fields, { name: name });
	    var label = '';
	    if (!value && value !== 0 || !report) return label;
	    try {
	        label = String(_underscore2.default.findWhere(report.data, { value: value }).label[lang]);
	    } catch (err) {
	        //console.log(name, value)
	        //if (__SERVER)
	        //    console.error(err)
	        return label;
	    }
	    return label;
	};
	
	var getUser = exports.getUser = function getUser(_id) {
	    return _underscore2.default.findWhere(_USERS2.default, { _id: _id }) || {};
	};
	
	var multipleCount = exports.multipleCount = function multipleCount(data) {
	    var count = 0;
	    data.forEach(function (value) {
	        return value !== 'none' ? count += 1 : null;
	    });
	    return count;
	};
	
	var getFrameCount = exports.getFrameCount = function getFrameCount(frames, type) {
	    var result = 0;
	    frames.forEach(function (frame) {
	        if (frame && frame[type]) result += frame[type];
	    });
	    return result;
	};
	
	var booleansCount = exports.booleansCount = function booleansCount(data) {
	    var count = 0;
	    for (var i in data) {
	        if (data[i]) count += 1;
	    }
	    return count;
	};
	
	var getReportsByFilters = exports.getReportsByFilters = function getReportsByFilters(reports, filters, search) {
	    var sort = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'created';
	    var sortType = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : -1;
	
	    reports = _underscore2.default.sortBy(reports.filter(function (report) {
	        var match = true;
	        if (search && search.key === 'report' && search.value !== report._id) match = false;else if (search && search.key !== 'report' && report[search.key]._id !== search.value) match = false;
	        // else {
	        for (var i in filters) {
	            if (filters[i][0] && filters[i][0] !== undefined) {
	                /*TODO: Uniq method*/
	                if (i === 'states' && filters[i][0] && filters[i].indexOf(report.hive.state) === -1) match = false;else if (i === 'clientCountry' && filters[i][0] && filters[i].indexOf(report.client.country) === -1) match = false;else if (i !== 'states' && i !== 'clientCountry' && filters[i][0] !== undefined && filters[i].indexOf(report[i]) === -1) match = false;
	            }
	        }
	        return match;
	        //}
	    }), sort);
	    if (sortType === -1) reports = reports.reverse();
	    return reports;
	};
	
	var getSelectReportsOptions = exports.getSelectReportsOptions = function getSelectReportsOptions(clients, reports) {
	    var hives = [];
	    var samples = [];
	    clients.forEach(function (client) {
	        hives = hives.concat(client.hives.filter(function (hive) {
	            for (var i = 0; i < reports.length; i++) {
	                if (reports[i].hive && reports[i].hive._id === hive._id) return hive;
	            }
	        }).map(function (hive) {
	            return { value: hive._id, label: hive.identifier, key: 'hive' };
	        }));
	    });
	    reports.forEach(function (report) {
	        if (report.sample && report.sampleNumber) samples.push({
	            value: report._id,
	            label: report.hive.identifier + '-' + report.sampleNumber,
	            key: 'report'
	        });
	    });
	    return [].concat((0, _toConsumableArray3.default)(_underscore2.default.sortBy([].concat((0, _toConsumableArray3.default)(clients.filter(function (client) {
	        for (var i = 0; i < reports.length; i++) {
	            if (reports[i].client && reports[i].client._id === client._id) return client;
	        }
	    }).map(function (client) {
	        return { value: client._id, label: client.name, key: 'client' };
	    })), (0, _toConsumableArray3.default)(hives)), 'label')), samples);
	};

/***/ },

/***/ 960:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _freeze = __webpack_require__(961);
	
	var _freeze2 = _interopRequireDefault(_freeze);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var booleanData = function booleanData() {
	    return [{
	        value: true,
	        label: {
	            fr: 'Oui',
	            nl: 'Ya',
	            en: 'Yes'
	        }
	    }, {
	        value: false,
	        label: {
	            fr: 'Non',
	            nl: 'Nee',
	            en: 'No'
	        }
	    }];
	};
	
	var starsDefaultData = [{
	    value: 0,
	    label: {
	        en: "Too low",
	        fr: "Trop bas"
	    }
	}, {
	    value: 1,
	    label: {
	        en: "Very low",
	        fr: "Très faible"
	    }
	}, {
	    value: 2,
	    label: {
	        en: "Low",
	        fr: "Faible"
	    }
	}, {
	    value: 3,
	    label: {
	        en: "Satisfactory",
	        fr: "Satisfaisant"
	    }
	}, {
	    value: 4,
	    label: {
	        en: "Abundant",
	        fr: "Abondant"
	    }
	}, {
	    value: 5,
	    label: {
	        en: "Very abundant",
	        fr: "Très abondant"
	    }
	}];
	
	var REPORT = {
	    types: [{
	        value: 'beeomonitorée',
	        label: {
	            fr: 'Visite Beeomonitorée',
	            en: 'Beeomonitored visit'
	        },
	        shortLabel: {
	            fr: 'Beeomonitorée',
	            en: 'Beeomonitored'
	        }
	    }, {
	        value: 'non-beeomonitorée',
	        label: {
	            fr: 'Visite Non-beeomonitorée',
	            en: 'Non Beeomonitored visit'
	        },
	        shortLabel: {
	            fr: 'Non-beeomonitorée',
	            en: 'Non Beeomonitored'
	        }
	    }, {
	        value: 'dead',
	        label: {
	            fr: 'Colonie morte',
	            en: 'Dead colony'
	        },
	        shortLabel: {
	            fr: 'Morte',
	            en: 'Dead'
	        }
	    }, {
	        value: 'canceled',
	        label: {
	            fr: 'Visite annulée',
	            en: 'Cancelled Visit'
	        },
	        shortLabel: {
	            fr: 'Annulée',
	            en: 'Cancelled'
	        }
	    }, {
	        value: 'exceptional',
	        label: {
	            fr: 'Visite exceptionnelle',
	            en: 'Exceptional visit'
	        },
	        shortLabel: {
	            fr: 'Exceptio.',
	            en: 'Exceptional'
	        }
	    }],
	    states: [{
	        value: 'alive',
	        label: 'Ruche opérationnel',
	        shortLabel: 'Opérationnel'
	    }, {
	        value: 'dead',
	        label: 'Ruche morte',
	        shortLabel: 'Morte'
	    }],
	    fields: [{
	        name: 'created',
	        applicableTypes: ['beeomonitorée', 'non-beeomonitorée', 'dead', 'canceled', 'exceptional'],
	        optional: true,
	        label: {
	            fr: 'Date',
	            nl: '',
	            en: 'Date'
	        },
	        type: 'date'
	    }, {
	        name: 'visit',
	        applicableTypes: ['beeomonitorée', 'non-beeomonitorée'],
	        type: 'select',
	        multiple: false,
	        label: {
	            fr: 'Type de visite',
	            nl: '',
	            en: 'Kind of visit'
	        },
	        data: [
	        /*{
	            value: 'none',
	            label: {
	                fr: 'N/A',
	                nl: '',
	                en: ''
	            },
	            description: {
	                fr: '',
	                nl: '',
	                en: ''
	            }
	        },*/
	        {
	            value: 'winter',
	            label: {
	                fr: 'Visite d\'hivernage',
	                nl: '',
	                en: 'Wintering visit'
	            },
	            description: {
	                fr: 'Nous vérifions que les abeilles répondent à un stimulus durant leur hivernage.',
	                nl: '',
	                en: ''
	            },
	            email: 'hibernation period visit, to check whether the bees respond to a stimulus during hibernation.'
	        }, {
	            value: 'winter_outing',
	            label: {
	                fr: 'Visite de sortie d\'hivernage',
	                nl: '',
	                en: 'Wintering out visit'
	            },
	            description: {
	                fr: 'Nous vérifions l\'état de la colonies après l\'hiver et nous nous assurons que la ponte a redémarré ou va redémarrer rapidement.',
	                nl: '',
	                en: ''
	            },
	            email: 'end-of-hibernation visit, to check how the bees came through the winter and whether the queen has started or is about to start laying.'
	        }, {
	            value: 'routine',
	            label: {
	                fr: 'Visite de routine',
	                nl: '',
	                en: 'Day to day visit'
	            },
	            description: {
	                fr: 'Contrôle de l\'état sanitaire de la colonie, check des réserves de nourriture et de développement du couvain.',
	                nl: '',
	                en: ''
	            },
	            email: 'routine visit, to check the colony’s overall health, the food stores and to see how the brood is developing.',
	            emailBeeomonitored: 'routine Beeomonitored hive visit, to check the colony’s overall health, measure the honey and pollen stores in the hive and to see how the brood is developing. Data encoding.'
	        }, {
	            value: 'pre_winter',
	            label: {
	                fr: 'Visite de pré-hivernage',
	                nl: '',
	                en: 'Pre-wintering visit'
	            },
	            description: {
	                fr: 'Nous vérifions l\'état de la colonie avant l\'hiver et nous nous assurons que la nourriture est présente en quantité suffisante pour l\'hivernage.',
	                nl: '',
	                en: ''
	            },
	            email: 'pre-hibernation visit, to check the state of the hive before the onset of winter and to make sure that there is enough food in the hive to get the bees through the winter.'
	        }, {
	            value: 'control',
	            label: {
	                fr: 'Visite de contrôle de l\'essaimage et/ou division de la colonie',
	                nl: '',
	                en: 'Swarming control visit and/or division of the colony'
	            },
	            description: {
	                fr: '',
	                nl: '',
	                en: ''
	            },
	            email: 'visit to check swarming and/or colony division.'
	        }, {
	            value: 'exceptional',
	            label: {
	                fr: 'Visite exceptionnelle (suite à la visite précédente)',
	                nl: '',
	                en: 'Exceptional visit (following the previous visit)'
	            },
	            description: {
	                fr: '',
	                nl: '',
	                en: ''
	            },
	            email: 'exceptional visit (follow-up to an earlier visit).'
	        }]
	    }, {
	        name: 'populatedLanes',
	        applicableTypes: ['beeomonitorée'],
	        type: 'number',
	        label: {
	            fr: 'Ruelles peuplées',
	            nl: '',
	            en: 'Bee spaces full of bees'
	        },
	        min: 0,
	        max: 10,
	        step: 0.5,
	        more: false
	    }, {
	        name: 'populatedLanesEval',
	        applicableTypes: ['non-beeomonitorée'],
	        type: 'stars',
	        data: [].concat(starsDefaultData),
	        label: {
	            fr: 'Ruelles peuplées',
	            nl: '',
	            en: 'Bee spaces full of bees'
	        }
	    }, {
	        name: 'frames',
	        type: 'counter',
	        label: {
	            fr: 'Mesures sur cadres',
	            nl: '',
	            en: 'Frame measurements'
	        },
	        number: 10,
	        min: 0,
	        max: 8,
	        step: 0.5,
	        applicableTypes: ['beeomonitorée'],
	        data: [{
	            key: 'brood',
	            label: {
	                fr: 'Couvain (unité: quart de face)',
	                nl: '',
	                en: 'Brood  (unit:1/4 side of frame)'
	            }
	        }, {
	            key: 'nectar',
	            label: {
	                fr: 'Nectar (unité: quart de face)',
	                nl: '',
	                en: 'Nectar  (unit:1/4 side of frame)'
	            }
	        }, {
	            key: 'pollen',
	            label: {
	                fr: 'Pollen (unité: quart de face)',
	                nl: '',
	                en: 'Pollen (unit:1/4 side of frame)'
	            }
	        }]
	    }, {
	        name: 'honey',
	        applicableTypes: ['non-beeomonitorée'],
	        type: 'boolean',
	        label: {
	            fr: 'Nectar',
	            nl: '',
	            en: 'Nectar'
	        },
	        data: booleanData(),
	        disabled: true
	    }, {
	        name: 'honeyEval',
	        applicableTypes: ['non-beeomonitorée'],
	        type: 'stars',
	        label: {
	            fr: 'Nectar et/ou nourriture',
	            nl: '',
	            en: 'Nectar and/or bee feed'
	        },
	        data: [{
	            value: 0,
	            label: {
	                en: "Too low",
	                fr: "Trop faible"
	            }
	        }, {
	            value: 1,
	            label: {
	                en: "Very low",
	                fr: "Très faible"
	            }
	        }, {
	            value: 2,
	            label: {
	                en: "Low",
	                fr: "Faible"
	            }
	        }, {
	            value: 3,
	            label: {
	                en: "Satisfactory -",
	                fr: "Satisfaisant -"
	            }
	        }, {
	            value: 4,
	            label: {
	                en: "Satisfactory +",
	                fr: "Satisfaisant +"
	            }
	        }, {
	            value: 5,
	            label: {
	                en: "Abundant",
	                fr: "Abondant"
	            }
	        }]
	    }, {
	        name: 'broodEval',
	        applicableTypes: ['non-beeomonitorée'],
	        type: 'stars',
	        label: {
	            fr: 'Couvain',
	            nl: '',
	            en: 'Brood'
	        },
	        data: [].concat(starsDefaultData)
	    }, {
	        name: 'pollen',
	        applicableTypes: ['non-beeomonitorée'],
	        type: 'boolean',
	        label: {
	            fr: 'Pollen',
	            nl: '',
	            en: 'Pollen'
	        },
	        data: booleanData(),
	        disabled: true
	    }, {
	        name: 'pollenEval',
	        applicableTypes: ['non-beeomonitorée'],
	        type: 'stars',
	        label: {
	            fr: 'Pollen',
	            nl: '',
	            en: 'Pollen'
	        },
	        data: [].concat(starsDefaultData)
	    }, {
	        name: 'queen',
	        type: 'boolean',
	        applicableTypes: ['beeomonitorée', 'non-beeomonitorée'],
	        label: {
	            fr: 'Reine vue',
	            nl: '',
	            en: 'Queen seen'
	        },
	        data: booleanData()
	    }, {
	        name: 'eggs',
	        applicableTypes: ['beeomonitorée', 'non-beeomonitorée'],
	        type: 'boolean',
	        label: {
	            fr: 'Oeuf',
	            nl: '',
	            en: 'Eggs'
	        },
	        data: booleanData()
	    },
	    /*{
	        name: 'eggsEval',
	        applicableTypes: ['non-beeomonitorée'],
	        type: 'stars',
	        label: {
	            fr: 'Oeuf',
	            nl: '',
	            en: 'Eggs'
	        },
	        data: starsDefaultData
	    },*/
	    {
	        name: 'pollenTrap',
	        disabled: true,
	        applicableTypes: ['beeomonitorée'],
	        type: 'boolean',
	        label: {
	            fr: 'Trappe à pollen',
	            nl: '',
	            en: 'Pollen Trap'
	        },
	        data: booleanData()
	    }, {
	        name: 'sample',
	        applicableTypes: ['beeomonitorée', 'exceptional'],
	        type: 'select',
	        defaultValue: 'none',
	        label: {
	            fr: 'Prélèvement',
	            nl: '',
	            en: 'Sample taken inside the hive'
	        },
	        data: [{
	            value: 'pollenTrap',
	            label: {
	                fr: 'Trappe à Pollen',
	                nl: '',
	                en: 'Pollen trap'
	            }
	        }, {
	            value: 'none',
	            label: {
	                fr: 'Pas de prise d’échantillon',
	                nl: '',
	                en: 'No sampling'
	            }
	        }, {
	            value: 'not_available',
	            label: {
	                fr: 'Pas d’échantillon disponible',
	                nl: '',
	                en: 'No sample available'
	            }
	        }, {
	            value: 'insideHive',
	            label: {
	                fr: 'Intérieur de ruche',
	                nl: '',
	                en: 'Inside the hive'
	            }
	        }]
	    }, {
	        name: 'sample_bak',
	        disabled: true,
	        applicableTypes: ['beeomonitorée'],
	        type: 'boolean',
	        label: {
	            fr: 'Prélèvement',
	            nl: '',
	            en: 'Sample'
	        },
	        defaultValue: false,
	        data: booleanData()
	    }, {
	        name: 'maladies',
	        type: 'booleans',
	        applicableTypes: ['beeomonitorée', 'non-beeomonitorée'],
	        optional: true,
	        defaultValue: false,
	        label: {
	            fr: 'Maladies',
	            nl: '',
	            en: 'Diseases'
	        },
	        data: [{
	            value: '1',
	            label: {
	                fr: 'Du couvain en mosaïque avec des opercules percés',
	                nl: '',
	                en: 'Mosaic brood and capping with small holes'
	            }
	        }, {
	            value: '2',
	            label: {
	                fr: 'Des cellules royales mélanisées',
	                nl: '',
	                en: 'Dark queen cells'
	            }
	        }, {
	            value: '3',
	            label: {
	                fr: 'Des abeilles aux ailes déformées',
	                nl: '',
	                en: 'Bees with deformed wings'
	            }
	        }, {
	            value: '4',
	            label: {
	                fr: 'Des varroas',
	                nl: '',
	                en: 'Varroa mite'
	            }
	        }, {
	            value: '5',
	            label: {
	                fr: 'Des abeilles à l’abdomen noir, gonflé et glabre',
	                nl: '',
	                en: 'Bees with a black abdomen'
	            }
	        }, {
	            value: '6',
	            label: {
	                fr: 'Des déjections en quantité importante à l’intérieur de la colonie',
	                nl: '',
	                en: 'Large droppings inside the colony'
	            }
	        }, {
	            value: '7',
	            label: {
	                fr: 'Du couvain plâtré',
	                nl: '',
	                en: 'Chalkbrood'
	            }
	        }, {
	            value: '8',
	            label: {
	                fr: 'De la fausse-teigne (petite ou grande)',
	                nl: '',
	                en: 'Wax moth (small or big)'
	            }
	        }, {
	            value: '9',
	            label: {
	                fr: 'De l’aspergillose',
	                nl: '',
	                en: 'Aspergillosis'
	            }
	        }, {
	            value: '10',
	            label: {
	                fr: 'Du couvain visqueux et une odeur d’ammoniaque',
	                nl: '',
	                en: 'Sticky brood and a smell of ammonia'
	            }
	        }, {
	            value: '11',
	            label: {
	                fr: 'Du couvain en forme d’écaille difficilement détachable des cellules',
	                nl: '',
	                en: 'Brood in the form of scales difficult to detach from cells'
	            }
	        }, {
	            value: '12',
	            label: {
	                fr: 'Du couvain en forme d’écaille facilement détachable des cellules',
	                nl: '',
	                en: 'Brood in the form of scales easy to detach from cells'
	            }
	        }]
	    }, {
	        name: 'comment',
	        applicableTypes: ['beeomonitorée', 'non-beeomonitorée', 'dead', 'canceled', 'exceptional'],
	        optional: true,
	        defaultValue: '',
	        label: {
	            fr: 'Commentaire',
	            nl: '',
	            en: 'Comment'
	        },
	        type: 'text'
	    }, {
	        name: 'toDo',
	        type: 'select',
	        applicableTypes: ['beeomonitorée', 'non-beeomonitorée'],
	        multiple: true,
	        optional: true,
	        defaultValue: 'none',
	        label: {
	            fr: 'A faire lors de la prochaine visite',
	            nl: '',
	            en: 'To do during the next visit'
	        },
	        data: [{
	            value: 'none',
	            label: {
	                fr: 'N/A',
	                nl: '',
	                en: 'N/A'
	            }
	        }, {
	            value: 'feed',
	            label: {
	                fr: 'Nourrir',
	                nl: '',
	                en: 'Feed'
	            }
	        }, {
	            value: 'divide',
	            label: {
	                fr: 'Diviser',
	                nl: '',
	                en: 'Divide'
	            }
	        }, {
	            value: 'replace',
	            label: {
	                fr: 'Remplacer',
	                nl: '',
	                en: 'Replace'
	            }
	        }, {
	            value: 'cut',
	            label: {
	                fr: 'Taille / jardinage',
	                nl: '',
	                en: 'Pruning / gardening'
	            }
	        }, {
	            value: 'replace_materials',
	            label: {
	                fr: 'Remplacement matériel manquant',
	                nl: '',
	                en: 'Replacement of missing equipment'
	            }
	        }, {
	            value: 'nothing',
	            label: {
	                fr: 'Rien de spécial',
	                nl: '',
	                en: 'Nothing special'
	            }
	        }, {
	            value: 'replace_frames',
	            label: {
	                fr: 'Remplacement de cadres',
	                nl: '',
	                en: 'Replacement of frames'
	            }
	        }, {
	            value: 'reform',
	            label: {
	                fr: 'Ruche à réformer',
	                nl: '',
	                en: 'Hive to be reformed'
	            }
	        }]
	    }, {
	        name: 'rise',
	        applicableTypes: ['beeomonitorée', 'non-beeomonitorée'],
	        type: 'number',
	        optional: true,
	        defaultValue: 0,
	        label: {
	            fr: 'Poids de la hausse (kg)',
	            nl: '',
	            en: 'Weight of the honey storage (kg)'
	        },
	        min: 0,
	        max: 99,
	        step: 1,
	        more: true
	    }, {
	        name: 'missingMaterials',
	        type: 'select',
	        applicableTypes: ['beeomonitorée', 'non-beeomonitorée'],
	        multiple: true,
	        optional: true,
	        defaultValue: 'none',
	        label: {
	            fr: 'Matériel manquant',
	            nl: '',
	            en: 'Missing equipment'
	        },
	        data: [{
	            value: 'none',
	            label: {
	                fr: 'N/A',
	                nl: '',
	                en: 'N/A'
	            }
	        }, {
	            value: 'bodies_frame',
	            label: {
	                fr: 'Cadre de corps',
	                nl: '',
	                en: 'Body frame'
	            }
	        }, {
	            value: 'entrance',
	            label: {
	                fr: 'Entrée',
	                nl: '',
	                en: 'Entrance'
	            }
	        }, {
	            value: 'rise',
	            label: {
	                fr: 'Hausse',
	                nl: '',
	                en: 'Honey storage'
	            }
	        }, {
	            value: 'rise_frame',
	            label: {
	                fr: 'Cadre de hausse',
	                nl: '',
	                en: 'Honey storage frame'
	            }
	        }, {
	            value: 'roof',
	            label: {
	                fr: 'Toit',
	                nl: '',
	                en: 'Roof'
	            }
	        }, {
	            value: 'insulating',
	            label: {
	                fr: 'Isolant',
	                nl: '',
	                en: 'Insulation'
	            }
	        }, {
	            value: 'foot',
	            label: {
	                fr: 'Pied',
	                nl: '',
	                en: 'Foot'
	            }
	        }, {
	            value: 'dibbon_plate',
	            label: {
	                fr: 'Plaque Dibond',
	                nl: '',
	                en: 'Dibond plate'
	            }
	        }, {
	            value: 'strap',
	            label: {
	                fr: 'Sangle',
	                nl: '',
	                en: 'Strap'
	            }
	        }, {
	            value: 'frame_plate',
	            label: {
	                fr: 'Planche couvre cadre',
	                nl: '',
	                en: 'Frame covers'
	            }
	        }, {
	            value: 'ground',
	            label: {
	                fr: 'Sol',
	                nl: '',
	                en: 'Ground'
	            }
	        }, {
	            value: 'isolated_frame',
	            label: {
	                fr: 'Cadre isolé',
	                nl: '',
	                en: 'Isolated frame'
	            }
	        }, {
	            value: 'cover_plate',
	            label: {
	                fr: 'Planchette couvre cadre',
	                nl: '',
	                en: 'Frame covers'
	            }
	        }, {
	            value: 'queen_grid',
	            label: {
	                fr: 'Grille a reine',
	                nl: '',
	                en: 'Queen excluder'
	            }
	        }, {
	            value: 'feeder',
	            label: {
	                fr: 'Nourrisseur',
	                nl: '',
	                en: 'Feeder'
	            }
	        }, {
	            value: 'pollenTrap',
	            label: {
	                fr: 'Trappe à pollen',
	                nl: '',
	                en: 'Pollen trap'
	            }
	        }]
	    }, {
	        name: 'treatment',
	        type: 'select',
	        applicableTypes: ['beeomonitorée', 'non-beeomonitorée', 'exceptional'],
	        multiple: false,
	        optional: true,
	        //defaultValue: 'none',
	        label: {
	            fr: 'Traitement',
	            nl: '',
	            en: 'Treatment'
	        },
	        data: [{
	            value: 'none',
	            label: {
	                fr: 'N/A',
	                nl: '',
	                en: 'N/A'
	            }
	        }, {
	            value: 'adding',
	            label: {
	                fr: 'Ajout',
	                nl: '',
	                en: 'Adding'
	            }
	        }, {
	            value: 'withdrawal',
	            label: {
	                fr: 'Retrait',
	                nl: '',
	                en: 'Removing'
	            }
	        }]
	    },
	    /*{
	        name: 'food',
	        type: 'select',
	        applicableTypes: ['non-beeomonitorée'],
	        multiple: false,
	        optional: true,
	        //defaultValue: 'none',
	        label: {
	            fr: 'Nourriture',
	            nl: '',
	            en: 'Food'
	        },
	        data: [
	            {
	                value: 'none',
	                label: {
	                    fr: 'N/A',
	                    nl: '',
	                    en: 'N/A'
	                }
	            },
	            {
	                value: 'adding',
	                label: {
	                    fr: 'Ajout',
	                    nl: '',
	                    en: 'Adding'
	                },
	            },
	            {
	                value: 'withdrawal',
	                label: {
	                    fr: 'Retrait',
	                    nl: '',
	                    en: 'Removing'
	                }
	            },
	        ]
	    },*/
	    {
	        name: 'treatment_bak2',
	        disabled: true,
	        applicableTypes: ['beeomonitorée', 'non-beeomonitorée'],
	        type: 'number',
	        label: {
	            fr: 'Traitement',
	            nl: '',
	            en: ''
	        },
	        min: 0,
	        max: 10,
	        step: 1,
	        more: false,
	        defaultValue: 0,
	        optional: true
	    }, {
	        name: 'treatment_bak',
	        disabled: true,
	        type: 'select',
	        applicableTypes: ['beeomonitorée', 'non-beeomonitorée'],
	        multiple: false,
	        optional: true,
	        defaultValue: 'none',
	        label: {
	            fr: 'Traitement',
	            nl: '',
	            en: ''
	        },
	        data: [{
	            value: 'none',
	            label: {
	                fr: 'N/A',
	                nl: '',
	                en: 'N/A'
	            }
	        }, {
	            value: 'next_time',
	            label: {
	                fr: 'A placer prochaine fois',
	                nl: '',
	                en: ''
	            }
	        }, {
	            value: 'added_now',
	            label: {
	                fr: 'Placé lors de cette visite',
	                nl: '',
	                en: ''
	            }
	        }, {
	            value: 'retired_now',
	            label: {
	                fr: 'Retiré lors de cette visite',
	                nl: '',
	                en: ''
	            }
	        }]
	    }, {
	        name: 'feeding',
	        applicableTypes: ['beeomonitorée', 'non-beeomonitorée', 'exceptional'],
	        type: 'select',
	        multiple: false,
	        //defaultValue: 'none',
	        optional: true,
	        label: {
	            fr: 'Nourrissement',
	            nl: '',
	            en: 'Feeding'
	        },
	        data: [{
	            value: 'none',
	            label: {
	                fr: 'N/A',
	                nl: '',
	                en: 'N/A'
	            }
	        }, {
	            value: 'syrup',
	            label: {
	                fr: 'Sirop',
	                nl: '',
	                en: 'Syrup'
	            }
	        }, {
	            value: 'solidSugar',
	            label: {
	                fr: 'Sucre solide',
	                nl: '',
	                en: 'Solid sugar'
	            }
	        }]
	    }, {
	        name: 'feeding_bak2',
	        disabled: true,
	        applicableTypes: ['beeomonitorée', 'non-beeomonitorée'],
	        type: 'number',
	        label: {
	            fr: 'Nourrissement',
	            nl: '',
	            en: ''
	        },
	        min: 0,
	        max: 10,
	        step: 1,
	        optional: true,
	        defaultValue: 0,
	        more: false
	    }, {
	        name: 'feeding_bak',
	        disabled: true,
	        applicableTypes: ['beeomonitorée', 'non-beeomonitorée'],
	        type: 'select',
	        multiple: false,
	        defaultValue: 'none',
	        optional: true,
	        label: {
	            fr: 'Nourrissement',
	            nl: '',
	            en: ''
	        },
	        data: [{
	            value: 'none',
	            label: {
	                fr: 'N/A',
	                nl: '',
	                en: 'N/A'
	            }
	        }, {
	            value: 'not_necessary',
	            label: {
	                fr: 'Pas nécessaire - réserves suffisantes dans la ruche',
	                nl: '',
	                en: ''
	            }
	        }, {
	            value: 'half_can',
	            label: {
	                fr: 'Fait - un demi bidon',
	                nl: '',
	                en: ''
	            }
	        }, {
	            value: 'full_can',
	            label: {
	                fr: 'Fait - un bidon',
	                nl: '',
	                en: ''
	            }
	        }, {
	            value: 'sugar_bread',
	            label: {
	                fr: 'Fait - un pain de sucre solide',
	                nl: '',
	                en: ''
	            }
	        }]
	    }, {
	        name: 'royalCells',
	        applicableTypes: ['beeomonitorée', 'non-beeomonitorée'],
	        type: 'boolean',
	        optional: true,
	        defaultValue: false,
	        label: {
	            fr: 'Cellules Royales',
	            nl: '',
	            en: 'Queen cells'
	        },
	        data: booleanData()
	    }, {
	        name: 'royalCells_bak',
	        disabled: true,
	        applicableTypes: ['beeomonitorée', 'non-beeomonitorée'],
	        type: 'number',
	        optional: true,
	        defaultValue: 0,
	        label: {
	            fr: 'Cellules Royales',
	            nl: '',
	            en: ''
	        },
	        min: 0,
	        max: 11,
	        step: 1,
	        more: true
	    }, {
	        name: 'hiveState',
	        applicableTypes: ['beeomonitorée', 'non-beeomonitorée'],
	        type: 'boolean',
	        optional: true,
	        label: {
	            fr: 'Ruche en bon état',
	            nl: '',
	            en: 'Beehive in good condition'
	        },
	        data: booleanData()
	    }, {
	        name: 'division',
	        applicableTypes: ['beeomonitorée', 'non-beeomonitorée'],
	        type: 'boolean',
	        optional: true,
	        label: {
	            fr: 'Division',
	            nl: '',
	            en: 'Division'
	        },
	        data: booleanData()
	    }, {
	        name: 'state',
	        disabled: true,
	        applicableTypes: ['beeomonitorée', 'non-beeomonitorée'],
	        type: 'select',
	        optional: true,
	        defaultValue: 'good',
	        multiple: false,
	        label: {
	            fr: 'Etat général',
	            nl: '',
	            en: ''
	        },
	        data: [{
	            value: 'none',
	            label: {
	                fr: 'N/A',
	                nl: '',
	                en: 'N/A'
	            }
	        }, {
	            value: 'new',
	            label: {
	                fr: 'Nouvelle ruche',
	                nl: '',
	                en: ''
	            }
	        }, {
	            value: 'perfect',
	            label: {
	                fr: 'Parfait',
	                nl: '',
	                en: ''
	            }
	        }, {
	            value: 'good',
	            label: {
	                fr: 'Bon',
	                nl: '',
	                en: ''
	            }
	        }, {
	            value: 'to_monitor',
	            label: {
	                fr: 'A surveiller',
	                nl: '',
	                en: ''
	            }
	        }, {
	            value: 'dead',
	            label: {
	                fr: 'Morte',
	                nl: '',
	                en: ''
	            }
	        }, {
	            value: 'just_spread',
	            label: {
	                fr: 'Vient d\'essaimer',
	                nl: '',
	                en: ''
	            }
	        }, {
	            value: 'royal_cells',
	            label: {
	                fr: 'Présence de Cellules Royales',
	                nl: '',
	                en: ''
	            }
	        }, {
	            value: 'just_split',
	            label: {
	                fr: 'Vient d\'etre divisée',
	                nl: '',
	                en: ''
	            }
	        }]
	    }]
	};
	
	exports.default = (0, _freeze2.default)(REPORT);

/***/ },

/***/ 964:
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var USERS = [{
	    _id: '2',
	    firstName: 'Bart',
	    lastName: 'Lenaerts'
	}, {
	    _id: '1',
	    firstName: 'Benoît',
	    lastName: 'De Rese',
	    disabled: true
	}, {
	    _id: '0',
	    firstName: 'Sébastien',
	    lastName: 'Declève'
	}];
	
	exports.default = USERS;

/***/ },

/***/ 966:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(684);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _toConsumableArray2 = __webpack_require__(955);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _getPrototypeOf = __webpack_require__(593);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(620);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(621);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(625);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(670);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _reduxForm = __webpack_require__(720);
	
	var _react = __webpack_require__(503);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(557);
	
	var _InputField = __webpack_require__(946);
	
	var _InputField2 = _interopRequireDefault(_InputField);
	
	var _CheckboxesField = __webpack_require__(967);
	
	var _CheckboxesField2 = _interopRequireDefault(_CheckboxesField);
	
	var _actions = __webpack_require__(953);
	
	var _REPORT = __webpack_require__(960);
	
	var _REPORT2 = _interopRequireDefault(_REPORT);
	
	var _reactSelect = __webpack_require__(968);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _lib = __webpack_require__(954);
	
	var _underscore = __webpack_require__(715);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ReportsFilters = function (_Component) {
	    (0, _inherits3.default)(ReportsFilters, _Component);
	
	    function ReportsFilters() {
	        (0, _classCallCheck3.default)(this, ReportsFilters);
	        return (0, _possibleConstructorReturn3.default)(this, (ReportsFilters.__proto__ || (0, _getPrototypeOf2.default)(ReportsFilters)).call(this));
	    }
	
	    (0, _createClass3.default)(ReportsFilters, [{
	        key: 'handleSubmit',
	        value: function handleSubmit() {
	            var _this2 = this;
	
	            setTimeout(function () {
	                return _this2.props.submit();
	            }, 0);
	        }
	    }, {
	        key: 'search',
	        value: function search(data) {
	            this.props.dispatch((0, _actions.reportsSearchChange)({ search: data ? data : null }));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                handleSubmit = _props.handleSubmit,
	                valid = _props.valid,
	                submitting = _props.submitting,
	                error = _props.error,
	                pristine = _props.pristine,
	                reportsFilters = _props.reportsFilters;
	
	            var values = reportsFilters && reportsFilters.values ? reportsFilters.values : {};
	            var countries = [];
	            this.props.reports.all.forEach(function (report) {
	                var client = report.client;
	                if (client && client.country && !_underscore2.default.findWhere(countries, { value: client.country })) countries.push({ value: client.country, label: client.country });
	            });
	            return _react2.default.createElement(
	                'form',
	                { onSubmit: handleSubmit, onChange: handleSubmit },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row m-t-8' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-8' },
	                        _react2.default.createElement(
	                            'h5',
	                            null,
	                            'Filters'
	                        ),
	                        _react2.default.createElement(_reduxForm.Field, {
	                            component: _CheckboxesField2.default,
	                            fields: [].concat((0, _toConsumableArray3.default)(_REPORT2.default.types)).map(function (type) {
	                                return (0, _extends3.default)({}, type, {
	                                    label: type.label.fr
	                                });
	                            }),
	                            onChange: this.handleSubmit.bind(this),
	                            values: values.type,
	                            name: 'type',
	                            initialValues: this.props.initialValues.type,
	                            live: true
	                        }),
	                        _react2.default.createElement(_reduxForm.Field, {
	                            component: _CheckboxesField2.default,
	                            fields: countries,
	                            onChange: this.handleSubmit.bind(this),
	                            values: values.clientCountry,
	                            name: 'clientCountry',
	                            initialValues: this.props.initialValues.clientCountry,
	                            live: true
	                        }),
	                        _react2.default.createElement(_reduxForm.Field, {
	                            component: _CheckboxesField2.default,
	                            fields: _REPORT2.default.states,
	                            onChange: this.handleSubmit.bind(this),
	                            values: values.states,
	                            name: 'states',
	                            initialValues: this.props.initialValues.clientCountry,
	                            live: true
	                        })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-4' },
	                        !this.props.user.limited && _react2.default.createElement(
	                            'div',
	                            null,
	                            _react2.default.createElement(
	                                'h5',
	                                null,
	                                'Recherche'
	                            ),
	                            _react2.default.createElement(_reactSelect2.default, {
	                                className: 'm-b-12',
	                                name: 'form-field-name',
	                                label: 'Client',
	                                value: this.props.reports.search,
	                                placeholder: 'Search... (hives & clients)',
	                                options: (0, _lib.getSelectReportsOptions)(this.props.clients, this.props.reports.all),
	                                onChange: this.search.bind(this),
	                                noResultsText: 'Not found.'
	                            })
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	    return ReportsFilters;
	}(_react.Component);
	
	ReportsFilters.propTypes = {
	    onSubmit: _react.PropTypes.func.isRequired,
	    handleSubmit: _react.PropTypes.func.isRequired,
	    reset: _react.PropTypes.func.isRequired,
	    invalid: _react.PropTypes.bool.isRequired,
	    pristine: _react.PropTypes.bool.isRequired,
	    valid: _react.PropTypes.bool.isRequired,
	    submitting: _react.PropTypes.bool.isRequired
	};
	
	ReportsFilters = (0, _reduxForm.reduxForm)({
	    form: 'reportsFilters'
	})(ReportsFilters);
	
	var mapStateToProps = function mapStateToProps(state) {
	    var initialValues = state.reports.filters;
	    return {
	        reports: state.reports,
	        initialValues: initialValues,
	        clients: state.client.all,
	        reportsFilters: state.form.reportsFilters
	    };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(ReportsFilters);

/***/ },

/***/ 967:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(593);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(620);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(621);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(625);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(670);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(503);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CheckboxesField = function (_Component) {
	    (0, _inherits3.default)(CheckboxesField, _Component);
	
	    function CheckboxesField() {
	        (0, _classCallCheck3.default)(this, CheckboxesField);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (CheckboxesField.__proto__ || (0, _getPrototypeOf2.default)(CheckboxesField)).call(this));
	
	        _this.pictures = [];
	        _this.onClick = _this.onClick.bind(_this);
	        _this.all = _this.all.bind(_this);
	        return _this;
	    }
	
	    (0, _createClass3.default)(CheckboxesField, [{
	        key: 'onClick',
	        value: function onClick(value) {
	            var input = this.props.input;
	
	            var inputValue = input.value;
	            //if (inputValue && typeof(inputValue) !== 'Array') inputValue = [inputValue]
	            var indexOfValue = inputValue.indexOf(value);
	            if (!inputValue || inputValue[0] === undefined) {
	                if (this.props.onChange) this.props.onChange([value]);
	                return input.onChange(input.value = [value]);
	            }
	            if (indexOfValue === -1) inputValue.push(value);else inputValue.splice(indexOfValue, 1);
	            if (this.props.onChange) this.props.onChange(inputValue);
	            return input.onChange(input.value = inputValue);
	        }
	    }, {
	        key: 'all',
	        value: function all() {
	            var checked = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	            var refs = this.refs;
	
	            for (var i in refs) {
	                refs[i].checked = checked;
	            }
	            if (checked) return this.props.input.onChange(this.props.fields.map(function (field) {
	                return field.value;
	            }));
	            return this.props.input.onChange([]);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                label = _props.label,
	                name = _props.name,
	                input = _props.input,
	                fields = _props.fields,
	                initialValues = _props.initialValues,
	                values = _props.values,
	                _props$meta = _props.meta,
	                error = _props$meta.error,
	                touched = _props$meta.touched,
	                _props$className = _props.className,
	                className = _props$className === undefined ? 'checkbox-inline' : _props$className,
	                selectAll = _props.selectAll,
	                live = _props.live;
	
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-12' },
	                    label ? _react2.default.createElement(
	                        'h5',
	                        null,
	                        label,
	                        selectAll ? _react2.default.createElement(
	                            'span',
	                            { className: 'pull-right' },
	                            _react2.default.createElement(
	                                'a',
	                                { className: 'btn btn-xs btn-primary m-r-8', onClick: this.all.bind(this, false), style: { marginRight: 8 } },
	                                'Aucun'
	                            ),
	                            _react2.default.createElement(
	                                'a',
	                                { className: 'btn btn-xs btn-primary', onClick: this.all },
	                                'Tous'
	                            )
	                        ) : null
	                    ) : null,
	                    fields.map(function (field, index) {
	                        return _react2.default.createElement(
	                            'div',
	                            { className: className + ' checkbox-inline', key: 'checkbox-' + name + '-' + index },
	                            _react2.default.createElement(
	                                'label',
	                                null,
	                                _react2.default.createElement('input', {
	                                    type: 'checkbox',
	                                    ref: 'checkbox-' + index,
	                                    checked: !live ? undefined : values && values.indexOf(field.value) !== -1,
	                                    name: name,
	                                    value: field.value,
	                                    onClick: _this2.onClick.bind(_this2, field.value),
	                                    defaultChecked: live ? undefined : initialValues && initialValues.indexOf(field.value) !== -1
	                                }),
	                                field.label
	                            )
	                        );
	                    }),
	                    touched && error && _react2.default.createElement(
	                        'p',
	                        { className: 'error' },
	                        error
	                    )
	                )
	            );
	        }
	    }]);
	    return CheckboxesField;
	}(_react.Component);
	
	exports.default = CheckboxesField;

/***/ },

/***/ 987:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(503);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(988);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeleteHiveModal = function DeleteHiveModal(_ref) {
	    var deleteReport = _ref.deleteReport,
	        _ref$report = _ref.report,
	        report = _ref$report === undefined ? {} : _ref$report,
	        show = _ref.show,
	        display = _ref.display;
	    return _react2.default.createElement(
	        _lib.Modal,
	        { show: show, onHide: display },
	        _react2.default.createElement(
	            _lib.Modal.Header,
	            { closeButton: true },
	            _react2.default.createElement(
	                _lib.Modal.Title,
	                null,
	                'Supprimer un rapport.'
	            )
	        ),
	        _react2.default.createElement(
	            _lib.Modal.Body,
	            null,
	            _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-12' },
	                    '\xCAtes vous certain de vouloir supprimer ',
	                    _react2.default.createElement(
	                        'strong',
	                        null,
	                        'ce rapport'
	                    ),
	                    '?',
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'well m-t-12 m-b-4' },
	                        report && report.hive && report.visitNumber + ' - ' + report.hive.identifier + ' - ' + report.client.name
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(
	            _lib.Modal.Footer,
	            null,
	            _react2.default.createElement(
	                'a',
	                { className: 'btn btn-default', onClick: display },
	                'Annuler'
	            ),
	            _react2.default.createElement(
	                'button',
	                { name: 'submit-login', type: 'submit', className: 'btn btn-danger', onClick: report && deleteReport.bind(null, report._id) },
	                'Supprimer'
	            )
	        )
	    );
	};
	
	exports.default = DeleteHiveModal;

/***/ },

/***/ 1157:
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./af": 1158,
		"./af.js": 1158,
		"./ar": 1159,
		"./ar-dz": 1160,
		"./ar-dz.js": 1160,
		"./ar-ly": 1161,
		"./ar-ly.js": 1161,
		"./ar-ma": 1162,
		"./ar-ma.js": 1162,
		"./ar-sa": 1163,
		"./ar-sa.js": 1163,
		"./ar-tn": 1164,
		"./ar-tn.js": 1164,
		"./ar.js": 1159,
		"./az": 1165,
		"./az.js": 1165,
		"./be": 1166,
		"./be.js": 1166,
		"./bg": 1167,
		"./bg.js": 1167,
		"./bn": 1168,
		"./bn.js": 1168,
		"./bo": 1169,
		"./bo.js": 1169,
		"./br": 1170,
		"./br.js": 1170,
		"./bs": 1171,
		"./bs.js": 1171,
		"./ca": 1172,
		"./ca.js": 1172,
		"./cs": 1173,
		"./cs.js": 1173,
		"./cv": 1174,
		"./cv.js": 1174,
		"./cy": 1175,
		"./cy.js": 1175,
		"./da": 1176,
		"./da.js": 1176,
		"./de": 1177,
		"./de-at": 1178,
		"./de-at.js": 1178,
		"./de.js": 1177,
		"./dv": 1179,
		"./dv.js": 1179,
		"./el": 1180,
		"./el.js": 1180,
		"./en-au": 1181,
		"./en-au.js": 1181,
		"./en-ca": 1182,
		"./en-ca.js": 1182,
		"./en-gb": 1183,
		"./en-gb.js": 1183,
		"./en-ie": 1184,
		"./en-ie.js": 1184,
		"./en-nz": 1185,
		"./en-nz.js": 1185,
		"./eo": 1186,
		"./eo.js": 1186,
		"./es": 1187,
		"./es-do": 1188,
		"./es-do.js": 1188,
		"./es.js": 1187,
		"./et": 1189,
		"./et.js": 1189,
		"./eu": 1190,
		"./eu.js": 1190,
		"./fa": 1191,
		"./fa.js": 1191,
		"./fi": 1192,
		"./fi.js": 1192,
		"./fo": 1193,
		"./fo.js": 1193,
		"./fr": 1194,
		"./fr-ca": 1195,
		"./fr-ca.js": 1195,
		"./fr-ch": 1196,
		"./fr-ch.js": 1196,
		"./fr.js": 1194,
		"./fy": 1197,
		"./fy.js": 1197,
		"./gd": 1198,
		"./gd.js": 1198,
		"./gl": 1199,
		"./gl.js": 1199,
		"./he": 1200,
		"./he.js": 1200,
		"./hi": 1201,
		"./hi.js": 1201,
		"./hr": 1202,
		"./hr.js": 1202,
		"./hu": 1203,
		"./hu.js": 1203,
		"./hy-am": 1204,
		"./hy-am.js": 1204,
		"./id": 1205,
		"./id.js": 1205,
		"./is": 1206,
		"./is.js": 1206,
		"./it": 1207,
		"./it.js": 1207,
		"./ja": 1208,
		"./ja.js": 1208,
		"./jv": 1209,
		"./jv.js": 1209,
		"./ka": 1210,
		"./ka.js": 1210,
		"./kk": 1211,
		"./kk.js": 1211,
		"./km": 1212,
		"./km.js": 1212,
		"./ko": 1213,
		"./ko.js": 1213,
		"./ky": 1214,
		"./ky.js": 1214,
		"./lb": 1215,
		"./lb.js": 1215,
		"./lo": 1216,
		"./lo.js": 1216,
		"./lt": 1217,
		"./lt.js": 1217,
		"./lv": 1218,
		"./lv.js": 1218,
		"./me": 1219,
		"./me.js": 1219,
		"./mi": 1220,
		"./mi.js": 1220,
		"./mk": 1221,
		"./mk.js": 1221,
		"./ml": 1222,
		"./ml.js": 1222,
		"./mr": 1223,
		"./mr.js": 1223,
		"./ms": 1224,
		"./ms-my": 1225,
		"./ms-my.js": 1225,
		"./ms.js": 1224,
		"./my": 1226,
		"./my.js": 1226,
		"./nb": 1227,
		"./nb.js": 1227,
		"./ne": 1228,
		"./ne.js": 1228,
		"./nl": 1229,
		"./nl-be": 1230,
		"./nl-be.js": 1230,
		"./nl.js": 1229,
		"./nn": 1231,
		"./nn.js": 1231,
		"./pa-in": 1232,
		"./pa-in.js": 1232,
		"./pl": 1233,
		"./pl.js": 1233,
		"./pt": 1234,
		"./pt-br": 1235,
		"./pt-br.js": 1235,
		"./pt.js": 1234,
		"./ro": 1236,
		"./ro.js": 1236,
		"./ru": 1237,
		"./ru.js": 1237,
		"./se": 1238,
		"./se.js": 1238,
		"./si": 1239,
		"./si.js": 1239,
		"./sk": 1240,
		"./sk.js": 1240,
		"./sl": 1241,
		"./sl.js": 1241,
		"./sq": 1242,
		"./sq.js": 1242,
		"./sr": 1243,
		"./sr-cyrl": 1244,
		"./sr-cyrl.js": 1244,
		"./sr.js": 1243,
		"./ss": 1245,
		"./ss.js": 1245,
		"./sv": 1246,
		"./sv.js": 1246,
		"./sw": 1247,
		"./sw.js": 1247,
		"./ta": 1248,
		"./ta.js": 1248,
		"./te": 1249,
		"./te.js": 1249,
		"./tet": 1250,
		"./tet.js": 1250,
		"./th": 1251,
		"./th.js": 1251,
		"./tl-ph": 1252,
		"./tl-ph.js": 1252,
		"./tlh": 1253,
		"./tlh.js": 1253,
		"./tr": 1254,
		"./tr.js": 1254,
		"./tzl": 1255,
		"./tzl.js": 1255,
		"./tzm": 1256,
		"./tzm-latn": 1257,
		"./tzm-latn.js": 1257,
		"./tzm.js": 1256,
		"./uk": 1258,
		"./uk.js": 1258,
		"./uz": 1259,
		"./uz.js": 1259,
		"./vi": 1260,
		"./vi.js": 1260,
		"./x-pseudo": 1261,
		"./x-pseudo.js": 1261,
		"./yo": 1262,
		"./yo.js": 1262,
		"./zh-cn": 1263,
		"./zh-cn.js": 1263,
		"./zh-hk": 1264,
		"./zh-hk.js": 1264,
		"./zh-tw": 1265,
		"./zh-tw.js": 1265
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 1157;


/***/ },

/***/ 1270:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(593);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(620);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(621);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(625);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(670);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _reactRedux = __webpack_require__(557);
	
	var _reactRouter = __webpack_require__(501);
	
	var _react = __webpack_require__(503);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _LoginForm = __webpack_require__(1271);
	
	var _LoginForm2 = _interopRequireDefault(_LoginForm);
	
	var _MagicLoginForm = __webpack_require__(1272);
	
	var _MagicLoginForm2 = _interopRequireDefault(_MagicLoginForm);
	
	var _actions = __webpack_require__(681);
	
	var _reactFontawesome = __webpack_require__(942);
	
	var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);
	
	var _URLS = __webpack_require__(678);
	
	var _URLS2 = _interopRequireDefault(_URLS);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Login = function (_Component) {
	    (0, _inherits3.default)(Login, _Component);
	
	    function Login() {
	        (0, _classCallCheck3.default)(this, Login);
	        return (0, _possibleConstructorReturn3.default)(this, (Login.__proto__ || (0, _getPrototypeOf2.default)(Login)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(Login, [{
	        key: 'login',
	        value: function login(payload, dispatch) {
	            dispatch(_actions.LoginRequest.post.action({ payload: payload }));
	        }
	    }, {
	        key: 'magicLogin',
	        value: function magicLogin(payload, dispatch) {
	            dispatch(_actions.MagicLoginRequest.post.action({ payload: payload }));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'text-center' },
	                    _react2.default.createElement(
	                        'h4',
	                        { className: 'text-uppercase font-bold m-b-0' },
	                        'Sign In'
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'panel-body' },
	                    _react2.default.createElement(_LoginForm2.default, { onSubmit: this.login }),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'form-group m-t-30 m-b-0' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-sm-12' },
	                            _react2.default.createElement(
	                                _reactRouter.Link,
	                                { to: _URLS2.default.session.resetPassword, className: 'text-muted' },
	                                _react2.default.createElement(_reactFontawesome2.default, { name: 'lock' }),
	                                ' Forgot your password?'
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	    return Login;
	}(_react.Component);
	
	Login.contextTypes = {
	    router: _react.PropTypes.object.isRequired,
	    store: _react.PropTypes.object.isRequired,
	    session: _react.PropTypes.object
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	    var session = state.session;
	
	    return {
	        session: session
	    };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(Login);

/***/ },

/***/ 1271:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(593);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(620);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(621);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(625);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(670);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _reduxForm = __webpack_require__(720);
	
	var _react = __webpack_require__(503);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _InputField = __webpack_require__(946);
	
	var _InputField2 = _interopRequireDefault(_InputField);
	
	var _REGEXP = __webpack_require__(936);
	
	var _REGEXP2 = _interopRequireDefault(_REGEXP);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var validate = function validate(values) {
	    var errors = {};
	    if (!values.email) errors.email = 'Your email?';else if (!_REGEXP2.default.validations.email.test(values.email)) errors.email = 'Invalid format.';
	    if (!values.password) errors.password = 'Need a password.';
	    return errors;
	};
	
	var LoginForm = function (_Component) {
	    (0, _inherits3.default)(LoginForm, _Component);
	
	    function LoginForm() {
	        (0, _classCallCheck3.default)(this, LoginForm);
	        return (0, _possibleConstructorReturn3.default)(this, (LoginForm.__proto__ || (0, _getPrototypeOf2.default)(LoginForm)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(LoginForm, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                handleSubmit = _props.handleSubmit,
	                pristine = _props.pristine,
	                submitting = _props.submitting,
	                error = _props.error;
	
	            return _react2.default.createElement(
	                'form',
	                { onSubmit: handleSubmit, className: 'form-horizontal m-t-10' },
	                _react2.default.createElement(_reduxForm.Field, { name: 'email', component: _InputField2.default, type: 'email', placeholder: 'Email...' }),
	                _react2.default.createElement(_reduxForm.Field, { name: 'password', component: _InputField2.default, type: 'password', placeholder: 'Password...' }),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'form-group text-center m-t-30' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-12' },
	                        _react2.default.createElement(
	                            'button',
	                            { className: 'btn btn-custom btn-bordred btn-block waves-effect waves-light text-uppercase', type: 'submit', disabled: pristine || submitting },
	                            'Log In'
	                        )
	                    )
	                ),
	                error ? _react2.default.createElement(
	                    'p',
	                    { className: 'error', id: 'login-error' },
	                    error
	                ) : null
	            );
	        }
	    }]);
	    return LoginForm;
	}(_react.Component);
	
	LoginForm.propTypes = {
	    onSubmit: _react.PropTypes.func.isRequired,
	    handleSubmit: _react.PropTypes.func.isRequired,
	    reset: _react.PropTypes.func.isRequired,
	    invalid: _react.PropTypes.bool.isRequired,
	    pristine: _react.PropTypes.bool.isRequired,
	    valid: _react.PropTypes.bool.isRequired,
	    submitting: _react.PropTypes.bool.isRequired
	};
	
	exports.default = LoginForm = (0, _reduxForm.reduxForm)({
	    form: 'login',
	    validate: validate
	})(LoginForm);

/***/ },

/***/ 1272:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(593);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(620);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(621);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(625);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(670);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _reduxForm = __webpack_require__(720);
	
	var _react = __webpack_require__(503);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _InputField = __webpack_require__(946);
	
	var _InputField2 = _interopRequireDefault(_InputField);
	
	var _REGEXP = __webpack_require__(936);
	
	var _REGEXP2 = _interopRequireDefault(_REGEXP);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var validate = function validate(values) {
	    var errors = {};
	    if (!values.email) errors.email = 'Your email?';else if (!_REGEXP2.default.validations.email.test(values.email)) errors.email = 'Invalid format.';
	    return errors;
	};
	
	var MagicLoginForm = function (_Component) {
	    (0, _inherits3.default)(MagicLoginForm, _Component);
	
	    function MagicLoginForm() {
	        (0, _classCallCheck3.default)(this, MagicLoginForm);
	        return (0, _possibleConstructorReturn3.default)(this, (MagicLoginForm.__proto__ || (0, _getPrototypeOf2.default)(MagicLoginForm)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(MagicLoginForm, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                handleSubmit = _props.handleSubmit,
	                pristine = _props.pristine,
	                submitting = _props.submitting,
	                error = _props.error;
	
	            return _react2.default.createElement(
	                'form',
	                { onSubmit: handleSubmit },
	                _react2.default.createElement(_reduxForm.Field, { name: 'email', component: _InputField2.default, type: 'email', placeholder: 'Email...', label: 'Email' }),
	                _react2.default.createElement(
	                    'button',
	                    { name: 'submit-login', type: 'submit', disabled: pristine || submitting },
	                    'Login'
	                ),
	                error ? _react2.default.createElement(
	                    'p',
	                    { className: 'error', id: 'login-error' },
	                    error
	                ) : null
	            );
	        }
	    }]);
	    return MagicLoginForm;
	}(_react.Component);
	
	MagicLoginForm.propTypes = {
	    onSubmit: _react.PropTypes.func.isRequired,
	    handleSubmit: _react.PropTypes.func.isRequired,
	    reset: _react.PropTypes.func.isRequired,
	    invalid: _react.PropTypes.bool.isRequired,
	    pristine: _react.PropTypes.bool.isRequired,
	    valid: _react.PropTypes.bool.isRequired,
	    submitting: _react.PropTypes.bool.isRequired
	};
	
	exports.default = MagicLoginForm = (0, _reduxForm.reduxForm)({
	    form: 'magicLogin',
	    validate: validate
	})(MagicLoginForm);

/***/ },

/***/ 1273:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(593);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(620);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(621);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(625);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(670);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _reactRedux = __webpack_require__(557);
	
	var _react = __webpack_require__(503);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ResetPasswordForm = __webpack_require__(1274);
	
	var _ResetPasswordForm2 = _interopRequireDefault(_ResetPasswordForm);
	
	var _actions = __webpack_require__(681);
	
	var _reactFontawesome = __webpack_require__(942);
	
	var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ResetPassword = function (_Component) {
	    (0, _inherits3.default)(ResetPassword, _Component);
	
	    function ResetPassword() {
	        (0, _classCallCheck3.default)(this, ResetPassword);
	        return (0, _possibleConstructorReturn3.default)(this, (ResetPassword.__proto__ || (0, _getPrototypeOf2.default)(ResetPassword)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(ResetPassword, [{
	        key: 'submit',
	        value: function submit(payload, dispatch) {
	            dispatch(_actions.ResetPasswordRequest.post.action({ payload: payload }));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'text-center' },
	                    _react2.default.createElement(
	                        'h4',
	                        { className: 'text-uppercase font-bold m-b-0' },
	                        'Demande nouveau mot de passe'
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'panel-body' },
	                    this.props.session.resetPasswordProgress ? _react2.default.createElement(_reactFontawesome2.default, { name: 'cog', spin: true }) : this.props.session.resetPasswordSubmited ? _react2.default.createElement(
	                        'p',
	                        null,
	                        'Un email de v\xE9rification vous a \xE9t\xE9 envoy\xE9.'
	                    ) : _react2.default.createElement(_ResetPasswordForm2.default, { onSubmit: this.submit }),
	                    this.props.session.resetPasswordFailure ? _react2.default.createElement(
	                        'p',
	                        { className: 'error' },
	                        'Email inconnu.'
	                    ) : null
	                )
	            );
	        }
	    }]);
	    return ResetPassword;
	}(_react.Component);
	
	ResetPassword.contextTypes = {
	    router: _react.PropTypes.object.isRequired,
	    store: _react.PropTypes.object.isRequired,
	    session: _react.PropTypes.object
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	    var session = state.session;
	
	    return {
	        session: session
	    };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(ResetPassword);

/***/ },

/***/ 1274:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(593);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(620);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(621);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(625);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(670);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _reduxForm = __webpack_require__(720);
	
	var _react = __webpack_require__(503);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _InputField = __webpack_require__(946);
	
	var _InputField2 = _interopRequireDefault(_InputField);
	
	var _REGEXP = __webpack_require__(936);
	
	var _REGEXP2 = _interopRequireDefault(_REGEXP);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var validate = function validate(values) {
	    var errors = {};
	    if (!values.email) errors.email = 'Your email?';else if (!_REGEXP2.default.validations.email.test(values.email)) errors.email = 'Invalid format.';
	    return errors;
	};
	
	var ResetPasswordForm = function (_Component) {
	    (0, _inherits3.default)(ResetPasswordForm, _Component);
	
	    function ResetPasswordForm() {
	        (0, _classCallCheck3.default)(this, ResetPasswordForm);
	        return (0, _possibleConstructorReturn3.default)(this, (ResetPasswordForm.__proto__ || (0, _getPrototypeOf2.default)(ResetPasswordForm)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(ResetPasswordForm, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                handleSubmit = _props.handleSubmit,
	                pristine = _props.pristine,
	                submitting = _props.submitting,
	                error = _props.error;
	
	            return _react2.default.createElement(
	                'form',
	                { onSubmit: handleSubmit, className: 'form-horizontal m-t-10' },
	                _react2.default.createElement(_reduxForm.Field, { name: 'email', component: _InputField2.default, type: 'email', placeholder: 'Email...' }),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'form-group text-center m-t-30' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-12' },
	                        _react2.default.createElement(
	                            'button',
	                            { className: 'btn btn-custom btn-bordred btn-block waves-effect waves-light text-uppercase', type: 'submit', disabled: pristine || submitting },
	                            'Demander'
	                        )
	                    )
	                ),
	                error ? _react2.default.createElement(
	                    'p',
	                    { className: 'error', id: 'login-error' },
	                    error
	                ) : null
	            );
	        }
	    }]);
	    return ResetPasswordForm;
	}(_react.Component);
	
	ResetPasswordForm.propTypes = {
	    onSubmit: _react.PropTypes.func.isRequired,
	    handleSubmit: _react.PropTypes.func.isRequired,
	    reset: _react.PropTypes.func.isRequired,
	    invalid: _react.PropTypes.bool.isRequired,
	    pristine: _react.PropTypes.bool.isRequired,
	    valid: _react.PropTypes.bool.isRequired,
	    submitting: _react.PropTypes.bool.isRequired
	};
	
	exports.default = ResetPasswordForm = (0, _reduxForm.reduxForm)({
	    form: 'resetPassword',
	    validate: validate
	})(ResetPasswordForm);

/***/ },

/***/ 1275:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(684);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(593);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(620);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(621);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(625);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(670);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _reactRedux = __webpack_require__(557);
	
	var _react = __webpack_require__(503);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _UpdatePasswordForm = __webpack_require__(945);
	
	var _UpdatePasswordForm2 = _interopRequireDefault(_UpdatePasswordForm);
	
	var _actions = __webpack_require__(681);
	
	var _reactFontawesome = __webpack_require__(942);
	
	var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SetPassword = function (_Component) {
	    (0, _inherits3.default)(SetPassword, _Component);
	
	    function SetPassword() {
	        (0, _classCallCheck3.default)(this, SetPassword);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (SetPassword.__proto__ || (0, _getPrototypeOf2.default)(SetPassword)).call(this));
	
	        _this.submit = _this.submit.bind(_this);
	        return _this;
	    }
	
	    (0, _createClass3.default)(SetPassword, [{
	        key: 'submit',
	        value: function submit(payload, dispatch) {
	            dispatch(_actions.SetPasswordRequest.post.action({ payload: (0, _extends3.default)({}, payload, { token: this.props.params.token }) }));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'text-center' },
	                    _react2.default.createElement(
	                        'h4',
	                        { className: 'text-uppercase font-bold m-b-0' },
	                        'Modification de mot de passe'
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'panel-body' },
	                    this.props.session.setPasswordProgress ? _react2.default.createElement(_reactFontawesome2.default, { name: 'cog', spin: true }) : this.props.session.setPasswordSubmited ? _react2.default.createElement(
	                        'p',
	                        null,
	                        'Vous pouvez maintenant utiliser ce nouveau mot de passe dans l\'application mobile Beeoapp.'
	                    ) : _react2.default.createElement(_UpdatePasswordForm2.default, { onSubmit: this.submit }),
	                    this.props.session.setPasswordFailure ? _react2.default.createElement(
	                        'p',
	                        { className: 'error' },
	                        'Ce lien n\'est plus valide, merci de recommencer la demande.'
	                    ) : null
	                )
	            );
	        }
	    }]);
	    return SetPassword;
	}(_react.Component);
	
	SetPassword.contextTypes = {
	    router: _react.PropTypes.object.isRequired,
	    store: _react.PropTypes.object.isRequired,
	    session: _react.PropTypes.object
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	    var session = state.session;
	
	    return {
	        session: session
	    };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(SetPassword);

/***/ },

/***/ 1276:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(684);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(593);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(620);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(621);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(625);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(670);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _reactRedux = __webpack_require__(557);
	
	var _react = __webpack_require__(503);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _UpdatePasswordForm = __webpack_require__(945);
	
	var _UpdatePasswordForm2 = _interopRequireDefault(_UpdatePasswordForm);
	
	var _actions = __webpack_require__(681);
	
	var _reactFontawesome = __webpack_require__(942);
	
	var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SetPassword = function (_Component) {
	    (0, _inherits3.default)(SetPassword, _Component);
	
	    function SetPassword() {
	        (0, _classCallCheck3.default)(this, SetPassword);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (SetPassword.__proto__ || (0, _getPrototypeOf2.default)(SetPassword)).call(this));
	
	        _this.submit = _this.submit.bind(_this);
	        return _this;
	    }
	
	    (0, _createClass3.default)(SetPassword, [{
	        key: 'submit',
	        value: function submit(payload, dispatch) {
	            dispatch(_actions.SetPasswordRequest.post.action({ payload: (0, _extends3.default)({}, payload, { token: this.props.location.query.token }) }));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'text-center' },
	                    _react2.default.createElement(
	                        'h4',
	                        { className: 'text-uppercase font-bold m-b-0' },
	                        'Enregistrer son mot de passe'
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'panel-body' },
	                    this.props.session.setPasswordProgress ? _react2.default.createElement(_reactFontawesome2.default, { name: 'cog', spin: true }) : this.props.session.setPasswordSubmited ? _react2.default.createElement(
	                        'p',
	                        null,
	                        'Vous pouvez maintenant vous connecter dans l\'application mobile Beeoapp.'
	                    ) : _react2.default.createElement(_UpdatePasswordForm2.default, { onSubmit: this.submit }),
	                    this.props.session.setPasswordFailure ? _react2.default.createElement(
	                        'p',
	                        { className: 'error' },
	                        'Ce lien n\'est plus valide, merci de nous contacter pour en savoir plus.'
	                    ) : null
	                )
	            );
	        }
	    }]);
	    return SetPassword;
	}(_react.Component);
	
	SetPassword.contextTypes = {
	    router: _react.PropTypes.object.isRequired,
	    store: _react.PropTypes.object.isRequired,
	    session: _react.PropTypes.object
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	    var session = state.session;
	
	    return {
	        session: session
	    };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(SetPassword);

/***/ },

/***/ 1277:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(593);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(620);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(621);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(625);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(670);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(503);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(501);
	
	var _reactRedux = __webpack_require__(557);
	
	var _actions = __webpack_require__(951);
	
	var _sagas = __webpack_require__(1278);
	
	var _ClientPreview = __webpack_require__(1279);
	
	var _ClientPreview2 = _interopRequireDefault(_ClientPreview);
	
	var _api = __webpack_require__(902);
	
	var _URLS = __webpack_require__(678);
	
	var _URLS2 = _interopRequireDefault(_URLS);
	
	var _classnames = __webpack_require__(974);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactFontawesome = __webpack_require__(942);
	
	var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);
	
	var _underscore = __webpack_require__(715);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _reactSelect = __webpack_require__(968);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _lib = __webpack_require__(1281);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Client = function Client(_ref) {
	    var client = _ref.client,
	        redirect = _ref.redirect,
	        active = _ref.active;
	    return _react2.default.createElement(
	        'tr',
	        { className: (0, _classnames2.default)({ active: active }) },
	        _react2.default.createElement(
	            'th',
	            { scope: 'row' },
	            _react2.default.createElement(
	                'a',
	                { onClick: redirect.bind(null, client), className: true },
	                client.name
	            )
	        ),
	        _react2.default.createElement(
	            'td',
	            null,
	            client.street && _react2.default.createElement(_reactFontawesome2.default, { name: 'check' })
	        ),
	        _react2.default.createElement(
	            'td',
	            null,
	            client.email && _react2.default.createElement(_reactFontawesome2.default, { name: 'check' })
	        ),
	        _react2.default.createElement(
	            'td',
	            { className: 'text-right' },
	            client.hives && client.hives.some(function (hive) {
	                return hive.state === 'dead';
	            }) && _react2.default.createElement(
	                'span',
	                { className: 'text-danger' },
	                _react2.default.createElement(_reactFontawesome2.default, { name: 'warning' }),
	                ' '
	            ),
	            client.hives.length
	        )
	    );
	};
	
	var Clients = function (_Component) {
	    (0, _inherits3.default)(Clients, _Component);
	
	    function Clients() {
	        (0, _classCallCheck3.default)(this, Clients);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (Clients.__proto__ || (0, _getPrototypeOf2.default)(Clients)).call(this));
	
	        _this.newClient = _this.newClient.bind(_this);
	        _this.redirect = _this.redirect.bind(_this);
	        return _this;
	    }
	
	    (0, _createClass3.default)(Clients, [{
	        key: 'newClient',
	        value: function newClient() {
	            this.props.dispatch(_actions.ClientsRequest.post.action());
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.props.dispatch(_actions.ClientsRequest.get.action());
	            if (this.props.user && this.props.user.limited) window.location = "/";
	        }
	    }, {
	        key: 'redirect',
	        value: function redirect(client) {
	            this.props.dispatch((0, _actions.setCurrentClient)(client._id));
	            _reactRouter.browserHistory.push((0, _api.makeEndpoint)(_URLS2.default.client.show, client));
	        }
	    }, {
	        key: '_isActiveClient',
	        value: function _isActiveClient(client) {
	            return this.props.params.id && this.props.client.current && client._id === this.props.client.current._id;
	        }
	    }, {
	        key: 'updateClient',
	        value: function updateClient(values, dispatch) {
	            console.log(values);
	        }
	    }, {
	        key: 'search',
	        value: function search(data) {
	            if (data && data.value) {
	                this.props.dispatch((0, _actions.setCurrentClient)(data.value));
	                _reactRouter.browserHistory.push((0, _api.makeEndpoint)(_URLS2.default.client.show, { id: data.value }));
	            } else {
	
	                _reactRouter.browserHistory.push((0, _api.makeEndpoint)(_URLS2.default.client.index));
	            }
	            this.props.dispatch((0, _actions.clientSearchChange)({ search: data ? data : null }));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-12' },
	                        _react2.default.createElement(
	                            'h4',
	                            { className: 'page-title' },
	                            'Clients',
	                            _react2.default.createElement(
	                                'small',
	                                null,
	                                ' Gestion des clients et des ruches'
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'pull-right m-t-25' },
	                                _react2.default.createElement(
	                                    'a',
	                                    { className: 'btn btn-success waves-effect', onClick: this.newClient },
	                                    'Nouveau client'
	                                )
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-4 col-sm-4' },
	                        _react2.default.createElement(_reactSelect2.default, {
	                            className: 'm-b-10',
	                            name: 'search',
	                            value: this.props.client.search,
	                            placeholder: 'Search...',
	                            options: (0, _lib.getSelectReportsOptions)(this.props.client.all),
	                            onChange: this.search.bind(this),
	                            noResultsText: 'Not found.'
	                        }),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'card-box table-list' },
	                            _react2.default.createElement(
	                                'table',
	                                { className: 'table table-striped m-0 header-fixed' },
	                                _react2.default.createElement(
	                                    'thead',
	                                    null,
	                                    _react2.default.createElement(
	                                        'tr',
	                                        null,
	                                        _react2.default.createElement(
	                                            'th',
	                                            null,
	                                            'Nom'
	                                        ),
	                                        _react2.default.createElement(
	                                            'th',
	                                            { style: { width: '30px' } },
	                                            'Adresse'
	                                        ),
	                                        _react2.default.createElement(
	                                            'th',
	                                            { style: { width: '30px' } },
	                                            'Email'
	                                        ),
	                                        _react2.default.createElement(
	                                            'th',
	                                            { className: 'text-right', style: { width: '50px' } },
	                                            'Ru.'
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'tbody',
	                                    null,
	                                    (0, _lib.getClientsByFilters)(this.props.client.all, this.props.client.search ? this.props.client.search.value : null).map(function (client) {
	                                        return _react2.default.createElement(Client, {
	                                            client: client,
	                                            key: client._id,
	                                            redirect: _this2.redirect,
	                                            active: _this2._isActiveClient(client)
	                                        });
	                                    })
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-8 col-sm-8' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'card-box' },
	                            this.props.children
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	    return Clients;
	}(_react.Component);
	
	Clients.preload = function () {
	    return [[_sagas.getClientsSaga.start]];
	};
	
	Clients.contextTypes = {
	    router: _react.PropTypes.object.isRequired,
	    store: _react.PropTypes.object.isRequired,
	    user: _react.PropTypes.object
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	    var client = state.client,
	        session = state.session;
	
	    return {
	        client: client,
	        user: session.user
	    };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(Clients);

/***/ },

/***/ 1278:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.deleteHiveSaga = exports.putHiveSaga = exports.postHiveSaga = exports.deleteClientsSaga = exports.putClientsSaga = exports.postClientsSaga = exports.getClientsSaga = undefined;
	
	var _regenerator = __webpack_require__(717);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _actions = __webpack_require__(951);
	
	var _effects = __webpack_require__(706);
	
	var _RequestSagas = __webpack_require__(901);
	
	var _RequestSagas2 = _interopRequireDefault(_RequestSagas);
	
	var _URLS = __webpack_require__(678);
	
	var _URLS2 = _interopRequireDefault(_URLS);
	
	var _reactRouter = __webpack_require__(501);
	
	var _api = __webpack_require__(902);
	
	var _actions2 = __webpack_require__(900);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*Fetch clients*/
	var getClientsSaga = exports.getClientsSaga = new _RequestSagas2.default(_actions.ClientsRequest.get, { method: 'GET', endpoint: _URLS2.default.client.get });
	getClientsSaga.success = /*#__PURE__*/_regenerator2.default.mark(function _callee(action) {
	    return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	            switch (_context.prev = _context.next) {
	                case 0:
	                case 'end':
	                    return _context.stop();
	            }
	        }
	    }, _callee, this);
	});
	getClientsSaga.failure = /*#__PURE__*/_regenerator2.default.mark(function _callee2(action) {
	    return _regenerator2.default.wrap(function _callee2$(_context2) {
	        while (1) {
	            switch (_context2.prev = _context2.next) {
	                case 0:
	                case 'end':
	                    return _context2.stop();
	            }
	        }
	    }, _callee2, this);
	});
	
	/*New client*/
	var postClientsSaga = exports.postClientsSaga = new _RequestSagas2.default(_actions.ClientsRequest.post, { method: 'POST', endpoint: _URLS2.default.client.new });
	postClientsSaga.success = /*#__PURE__*/_regenerator2.default.mark(function _callee3(action) {
	    return _regenerator2.default.wrap(function _callee3$(_context3) {
	        while (1) {
	            switch (_context3.prev = _context3.next) {
	                case 0:
	                    _reactRouter.browserHistory.push((0, _api.makeEndpoint)(_URLS2.default.client.show, action.payload.client));
	
	                case 1:
	                case 'end':
	                    return _context3.stop();
	            }
	        }
	    }, _callee3, this);
	});
	postClientsSaga.failure = /*#__PURE__*/_regenerator2.default.mark(function _callee4(action) {
	    return _regenerator2.default.wrap(function _callee4$(_context4) {
	        while (1) {
	            switch (_context4.prev = _context4.next) {
	                case 0:
	                case 'end':
	                    return _context4.stop();
	            }
	        }
	    }, _callee4, this);
	});
	
	/*Update client*/
	var putClientsSaga = exports.putClientsSaga = new _RequestSagas2.default(_actions.ClientsRequest.put, { method: 'PUT', endpoint: _URLS2.default.client.update });
	putClientsSaga.success = /*#__PURE__*/_regenerator2.default.mark(function _callee5(action) {
	    return _regenerator2.default.wrap(function _callee5$(_context5) {
	        while (1) {
	            switch (_context5.prev = _context5.next) {
	                case 0:
	                    _context5.next = 2;
	                    return (0, _effects.put)((0, _actions2.flash)({ content: {
	                            type: 'success',
	                            title: 'Client modifié.'
	                        } }));
	
	                case 2:
	                case 'end':
	                    return _context5.stop();
	            }
	        }
	    }, _callee5, this);
	});
	putClientsSaga.failure = /*#__PURE__*/_regenerator2.default.mark(function _callee6(action) {
	    return _regenerator2.default.wrap(function _callee6$(_context6) {
	        while (1) {
	            switch (_context6.prev = _context6.next) {
	                case 0:
	                case 'end':
	                    return _context6.stop();
	            }
	        }
	    }, _callee6, this);
	});
	
	/*Delete client*/
	var deleteClientsSaga = exports.deleteClientsSaga = new _RequestSagas2.default(_actions.ClientsRequest.delete, { method: 'DELETE', endpoint: _URLS2.default.client.update });
	deleteClientsSaga.success = /*#__PURE__*/_regenerator2.default.mark(function _callee7(action) {
	    return _regenerator2.default.wrap(function _callee7$(_context7) {
	        while (1) {
	            switch (_context7.prev = _context7.next) {
	                case 0:
	                    _context7.next = 2;
	                    return (0, _effects.put)(_actions.ClientsRequest.get.action());
	
	                case 2:
	                case 'end':
	                    return _context7.stop();
	            }
	        }
	    }, _callee7, this);
	});
	deleteClientsSaga.failure = /*#__PURE__*/_regenerator2.default.mark(function _callee8(action) {
	    return _regenerator2.default.wrap(function _callee8$(_context8) {
	        while (1) {
	            switch (_context8.prev = _context8.next) {
	                case 0:
	                case 'end':
	                    return _context8.stop();
	            }
	        }
	    }, _callee8, this);
	});
	/*New hive*/
	var postHiveSaga = exports.postHiveSaga = new _RequestSagas2.default(_actions.HiveRequest.post, { method: 'POST', endpoint: _URLS2.default.client.newHive });
	postHiveSaga.success = /*#__PURE__*/_regenerator2.default.mark(function _callee9(action) {
	    return _regenerator2.default.wrap(function _callee9$(_context9) {
	        while (1) {
	            switch (_context9.prev = _context9.next) {
	                case 0:
	                case 'end':
	                    return _context9.stop();
	            }
	        }
	    }, _callee9, this);
	});
	postHiveSaga.failure = /*#__PURE__*/_regenerator2.default.mark(function _callee10(action) {
	    return _regenerator2.default.wrap(function _callee10$(_context10) {
	        while (1) {
	            switch (_context10.prev = _context10.next) {
	                case 0:
	                case 'end':
	                    return _context10.stop();
	            }
	        }
	    }, _callee10, this);
	});
	/*Update hive*/
	var putHiveSaga = exports.putHiveSaga = new _RequestSagas2.default(_actions.HiveRequest.put, { method: 'PUT', endpoint: _URLS2.default.client.updateHive });
	putHiveSaga.success = /*#__PURE__*/_regenerator2.default.mark(function _callee11(action) {
	    return _regenerator2.default.wrap(function _callee11$(_context11) {
	        while (1) {
	            switch (_context11.prev = _context11.next) {
	                case 0:
	                    _context11.next = 2;
	                    return (0, _effects.put)((0, _actions2.flash)({ content: {
	                            type: 'success',
	                            title: 'Ruche modifiée.'
	                        } }));
	
	                case 2:
	                case 'end':
	                    return _context11.stop();
	            }
	        }
	    }, _callee11, this);
	});
	putHiveSaga.failure = /*#__PURE__*/_regenerator2.default.mark(function _callee12(action) {
	    return _regenerator2.default.wrap(function _callee12$(_context12) {
	        while (1) {
	            switch (_context12.prev = _context12.next) {
	                case 0:
	                case 'end':
	                    return _context12.stop();
	            }
	        }
	    }, _callee12, this);
	});
	
	var deleteHiveSaga = exports.deleteHiveSaga = new _RequestSagas2.default(_actions.HiveRequest.delete, { method: 'DELETE', endpoint: _URLS2.default.client.updateHive });
	deleteHiveSaga.success = /*#__PURE__*/_regenerator2.default.mark(function _callee13(action) {
	    return _regenerator2.default.wrap(function _callee13$(_context13) {
	        while (1) {
	            switch (_context13.prev = _context13.next) {
	                case 0:
	                    _context13.next = 2;
	                    return (0, _effects.put)(_actions.ClientsRequest.get.action());
	
	                case 2:
	                    _context13.next = 4;
	                    return (0, _effects.put)((0, _actions2.flash)({ content: {
	                            type: 'success',
	                            title: 'Ruche supprimée.'
	                        } }));
	
	                case 4:
	                case 'end':
	                    return _context13.stop();
	            }
	        }
	    }, _callee13, this);
	});
	deleteHiveSaga.failure = /*#__PURE__*/_regenerator2.default.mark(function _callee14(action) {
	    return _regenerator2.default.wrap(function _callee14$(_context14) {
	        while (1) {
	            switch (_context14.prev = _context14.next) {
	                case 0:
	                case 'end':
	                    return _context14.stop();
	            }
	        }
	    }, _callee14, this);
	});
	
	/*Export watchers sagas*/
	var sagas = [(0, _effects.fork)(getClientsSaga.saga), (0, _effects.fork)(postClientsSaga.saga), (0, _effects.fork)(putClientsSaga.saga), (0, _effects.fork)(postHiveSaga.saga), (0, _effects.fork)(putHiveSaga.saga), (0, _effects.fork)(deleteClientsSaga.saga), (0, _effects.fork)(deleteHiveSaga.saga)];
	
	exports.default = sagas;

/***/ },

/***/ 1279:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(503);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _helpers = __webpack_require__(1280);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ClientPreview = function ClientPreview(_ref) {
	    var client = _ref.client,
	        redirect = _ref.redirect,
	        active = _ref.active;
	
	    var onClick = function onClick() {
	        redirect(client);
	    };
	    var className = 'card-box widget-user list-item';
	    if (active) className += ' active';
	    return _react2.default.createElement(
	        'div',
	        { className: 'col-xs-12', onClick: onClick },
	        _react2.default.createElement(
	            'div',
	            { className: className },
	            _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'h4',
	                    { className: 'm-t-0 m-b-5' },
	                    client.name
	                ),
	                _react2.default.createElement(
	                    'small',
	                    { className: 'text-custom' },
	                    _react2.default.createElement(
	                        'b',
	                        null,
	                        (0, _helpers.formatAddress)(client)
	                    )
	                ),
	                _react2.default.createElement(
	                    'p',
	                    { className: 'text-muted m-b-5 font-13' },
	                    'Hives: ',
	                    client.hives.length
	                )
	            )
	        )
	    );
	};
	
	exports.default = ClientPreview;

/***/ },

/***/ 1280:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.formatAddress = exports.getGMAPAddressComponents = undefined;
	
	var _underscore = __webpack_require__(715);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getGMAPAddressComponents = exports.getGMAPAddressComponents = function getGMAPAddressComponents(addressComponents) {
	    if (!addressComponents) return null;
	    var result = {};
	    addressComponents.forEach(function (entry) {
	        if (_underscore2.default.contains(entry.types, 'locality')) result.locality = entry.long_name;
	        if (_underscore2.default.contains(entry.types, 'postal_code')) result.zip = entry.long_name;
	        if (_underscore2.default.contains(entry.types, 'street_number')) result.streetNumber = entry.long_name;
	        if (_underscore2.default.contains(entry.types, 'route')) result.street = entry.long_name;
	        if (_underscore2.default.contains(entry.types, 'country') && entry.short_name) result.country = entry.short_name.toLowerCase();
	    });
	    return result;
	};
	
	var formatAddress = exports.formatAddress = function formatAddress(data) {
	    if (!data.street) return '';
	    var address = data.street;
	    if (data.streetNumber) address += ' ' + data.streetNumber;
	    if (data.locality || data.zip) address += ', ';
	    if (data.locality) address += data.locality + ' ';
	    if (data.zip) address += data.zip;
	    return address;
	};

/***/ },

/***/ 1281:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getSelectReportsOptions = exports.getClientsByFilters = undefined;
	
	var _underscore = __webpack_require__(715);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getClientsByFilters = exports.getClientsByFilters = function getClientsByFilters(clients, search) {
	    return _underscore2.default.sortBy(clients, function (e) {
	        return e.name.toLowerCase();
	    }).filter(function (client) {
	        if (!search || search && search === client._id) return client;
	    });
	};
	
	var getSelectReportsOptions = exports.getSelectReportsOptions = function getSelectReportsOptions(clients) {
	    return _underscore2.default.sortBy(clients.map(function (client) {
	        return { value: client._id, label: client.name, key: '_id' };
	    }), 'name');
	};

/***/ },

/***/ 1282:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(684);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(593);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(620);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(621);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(625);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(670);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(503);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(501);
	
	var _reactRedux = __webpack_require__(557);
	
	var _sagas = __webpack_require__(1278);
	
	var _actions = __webpack_require__(951);
	
	var _URLS = __webpack_require__(678);
	
	var _URLS2 = _interopRequireDefault(_URLS);
	
	var _reactFontawesome = __webpack_require__(942);
	
	var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);
	
	var _ClientName = __webpack_require__(1283);
	
	var _ClientName2 = _interopRequireDefault(_ClientName);
	
	var _ClientForm = __webpack_require__(1284);
	
	var _ClientForm2 = _interopRequireDefault(_ClientForm);
	
	var _ClientAddress = __webpack_require__(1292);
	
	var _ClientAddress2 = _interopRequireDefault(_ClientAddress);
	
	var _DeleteClientModal = __webpack_require__(1293);
	
	var _DeleteClientModal2 = _interopRequireDefault(_DeleteClientModal);
	
	var _DeleteHiveModal = __webpack_require__(1294);
	
	var _DeleteHiveModal2 = _interopRequireDefault(_DeleteHiveModal);
	
	var _Hive = __webpack_require__(1295);
	
	var _Hive2 = _interopRequireDefault(_Hive);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Client = function (_Component) {
	    (0, _inherits3.default)(Client, _Component);
	
	    function Client() {
	        (0, _classCallCheck3.default)(this, Client);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (Client.__proto__ || (0, _getPrototypeOf2.default)(Client)).call(this));
	
	        _this.deleteClient = _this.deleteClient.bind(_this);
	        _this.deleteHive = _this.deleteHive.bind(_this);
	        _this.updateClient = _this.updateClient.bind(_this);
	        _this.updateHive = _this.updateHive.bind(_this);
	        _this.displayDeleteClientModal = _this.displayDeleteClientModal.bind(_this);
	        _this.displayDeleteHiveModal = _this.displayDeleteHiveModal.bind(_this);
	        _this.newHive = _this.newHive.bind(_this);
	        _this.state = {
	            showDeleteClientModal: false
	        };
	        return _this;
	    }
	
	    (0, _createClass3.default)(Client, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var currentId = this.props.params.id;
	            this.props.dispatch((0, _actions.setCurrentClient)(currentId));
	        }
	    }, {
	        key: 'deleteClient',
	        value: function deleteClient() {
	            this.props.dispatch(_actions.ClientsRequest.delete.action({ params: { id: this.props.params.id } }));
	            this.setState({
	                showDeleteClientModal: false
	            });
	        }
	    }, {
	        key: 'deleteHive',
	        value: function deleteHive(hive) {
	            this.props.dispatch(_actions.HiveRequest.delete.action({ payload: { hive: hive }, params: { id: this.props.params.id, hive: hive } }));
	            this.setState({
	                showDeleteHiveModal: false
	            });
	        }
	    }, {
	        key: 'newHive',
	        value: function newHive() {
	            this.props.dispatch(_actions.HiveRequest.post.action({ params: { id: this.props.params.id } }));
	        }
	    }, {
	        key: 'updateClient',
	        value: function updateClient(payload) {
	            var emails = [];
	            for (var key in payload) {
	                if (key.match('email') && payload[key] && key !== 'email' && key !== 'emails') emails.push(payload[key]);
	            }
	            payload.emails = emails;
	            if (payload.address) {
	                payload = (0, _extends3.default)({}, payload, payload.address);
	                delete payload.address;
	            }
	            this.props.dispatch(_actions.ClientsRequest.put.action({ payload: payload, params: { id: this.props.params.id } }));
	        }
	    }, {
	        key: 'updateHive',
	        value: function updateHive(payload) {
	            payload.active === true ? null : payload.active = false;
	            this.props.dispatch(_actions.HiveRequest.put.action({ payload: payload, params: { id: this.props.params.id, hive: payload._id } }));
	        }
	    }, {
	        key: 'renderHives',
	        value: function renderHives() {
	            var _this2 = this;
	
	            if (!this.props.client || !this.props.client.hives) return;
	            return this.props.client.hives.filter(function (hive) {
	                return !hive.deleted;
	            }).map(function (hive) {
	                return _react2.default.createElement(_Hive2.default, {
	                    initialValues: hive,
	                    hive: hive,
	                    key: hive._id,
	                    onSubmit: _this2.updateHive,
	                    name: 'hive-' + hive._id,
	                    deleteHive: _this2.displayDeleteHiveModal
	                });
	            });
	        }
	    }, {
	        key: 'displayDeleteClientModal',
	        value: function displayDeleteClientModal() {
	            this.setState({
	                showDeleteClientModal: !this.state.showDeleteClientModal
	            });
	        }
	    }, {
	        key: 'displayDeleteHiveModal',
	        value: function displayDeleteHiveModal(currentHive) {
	            this.setState({
	                showDeleteHiveModal: !this.state.showDeleteHiveModal,
	                currentHive: currentHive
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var client = this.props.client;
	
	            if (!client) return _react2.default.createElement('div', null);
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-12' },
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'pull-right' },
	                            _react2.default.createElement(
	                                'a',
	                                { className: 'btn btn-danger btn-xs waves-effect', onClick: this.displayDeleteClientModal },
	                                'Supprimer'
	                            )
	                        ),
	                        _react2.default.createElement(_DeleteClientModal2.default, {
	                            show: this.state.showDeleteClientModal,
	                            display: this.displayDeleteClientModal,
	                            deleteClient: this.deleteClient,
	                            client: client
	                        }),
	                        _react2.default.createElement(_DeleteHiveModal2.default, {
	                            show: this.state.showDeleteHiveModal,
	                            display: this.displayDeleteHiveModal,
	                            deleteHive: this.deleteHive,
	                            hive: this.state.currentHive
	                        }),
	                        _react2.default.createElement(_ClientForm2.default, {
	                            onSubmit: this.updateClient
	                        }),
	                        _react2.default.createElement('hr', null),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'row' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-md-12' },
	                                _react2.default.createElement(
	                                    'h4',
	                                    null,
	                                    'Hives',
	                                    _react2.default.createElement(
	                                        'span',
	                                        { className: 'pull-right' },
	                                        _react2.default.createElement(
	                                            'a',
	                                            { className: 'btn btn-success btn-xs waves-effect', onClick: this.newHive },
	                                            'Ajouter une ruche'
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'table',
	                                    { className: 'table table-striped m-0' },
	                                    _react2.default.createElement(
	                                        'thead',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                { style: { width: 120 } },
	                                                'ID'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Visible ',
	                                                _react2.default.createElement('br', null),
	                                                'dans l\'app'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Morte'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                { className: 'text-right' },
	                                                'Sauver'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                { className: 'text-right' },
	                                                'Delete'
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        this.renderHives()
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	    return Client;
	}(_react.Component);
	
	Client.contextTypes = {
	    router: _react.PropTypes.object.isRequired,
	    store: _react.PropTypes.object.isRequired,
	    user: _react.PropTypes.object
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	    var client = state.client;
	
	    return {
	        client: client.current
	    };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(Client);

/***/ },

/***/ 1283:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(593);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(620);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(621);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(625);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(670);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _reduxForm = __webpack_require__(720);
	
	var _react = __webpack_require__(503);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _InputField = __webpack_require__(946);
	
	var _InputField2 = _interopRequireDefault(_InputField);
	
	var _reactRedux = __webpack_require__(557);
	
	var _REGEXP = __webpack_require__(936);
	
	var _REGEXP2 = _interopRequireDefault(_REGEXP);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var validate = function validate(values) {
	    var errors = {};
	    if (!values.name) errors.name = 'Name required';
	    return errors;
	};
	
	var ClientName = function (_Component) {
	    (0, _inherits3.default)(ClientName, _Component);
	
	    function ClientName() {
	        (0, _classCallCheck3.default)(this, ClientName);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (ClientName.__proto__ || (0, _getPrototypeOf2.default)(ClientName)).call(this));
	
	        _this.onChange = _this.onChange.bind(_this);
	        _this.submit = _this.submit.bind(_this);
	        _this.state = {
	            lastChange: null
	        };
	        return _this;
	    }
	
	    (0, _createClass3.default)(ClientName, [{
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.props.initialValues._id !== nextProps.initialValues._id) this.props.initialize(nextProps.initialValues);
	        }
	    }, {
	        key: 'onChange',
	        value: function onChange() {
	            var _this2 = this;
	
	            var now = new Date().getTime();
	            this.setState({ lastChange: now });
	            setTimeout(function () {
	                return _this2.state.lastChange && _this2.state.lastChange === now ? _this2.submit() : null;
	            }, 1000);
	        }
	    }, {
	        key: 'submit',
	        value: function submit() {
	            this.setState({ lastChange: null });
	            this.props.submit();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var handleSubmit = this.props.handleSubmit;
	
	            return _react2.default.createElement(
	                'form',
	                { onSubmit: handleSubmit, className: 'inline-block m-b-0', style: { width: '80%' }, onChange: this.onChange },
	                _react2.default.createElement(_reduxForm.Field, { name: 'name', component: _InputField2.default, type: 'text', placeholder: 'Name...', className: 'content-editable', containerClassName: 'ce', divClass: 'ce', autoComplete: 'off' })
	            );
	        }
	    }]);
	    return ClientName;
	}(_react.Component);
	
	ClientName.propTypes = {
	    onSubmit: _react.PropTypes.func.isRequired,
	    handleSubmit: _react.PropTypes.func.isRequired,
	    reset: _react.PropTypes.func.isRequired,
	    invalid: _react.PropTypes.bool.isRequired,
	    pristine: _react.PropTypes.bool.isRequired,
	    valid: _react.PropTypes.bool.isRequired,
	    submitting: _react.PropTypes.bool.isRequired
	};
	
	ClientName = (0, _reduxForm.reduxForm)({
	    form: 'clientName',
	    validate: validate
	})(ClientName);
	
	var mapStateToProps = function mapStateToProps(state) {
	    var initialValues = state.client.current;
	    return {
	        initialValues: initialValues
	    };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(ClientName);

/***/ },

/***/ 1284:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(955);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _extends2 = __webpack_require__(684);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(593);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(620);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(621);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(625);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(670);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _reduxForm = __webpack_require__(720);
	
	var _react = __webpack_require__(503);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _InputField = __webpack_require__(946);
	
	var _InputField2 = _interopRequireDefault(_InputField);
	
	var _reactRedux = __webpack_require__(557);
	
	var _REGEXP = __webpack_require__(936);
	
	var _REGEXP2 = _interopRequireDefault(_REGEXP);
	
	var _reactFontawesome = __webpack_require__(942);
	
	var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);
	
	var _reactPlacesAutocomplete = __webpack_require__(1285);
	
	var _reactPlacesAutocomplete2 = _interopRequireDefault(_reactPlacesAutocomplete);
	
	var _helpers = __webpack_require__(1280);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var validate = function validate(values) {
	    var errors = {};
	    if (values.email && !_REGEXP2.default.validations.email.test(values.email)) errors.email = 'Need a valid email.';
	
	    for (var key in values) {
	        if (key.match('email') && values[key] && !_REGEXP2.default.validations.email.test(values[key])) errors[key] = 'Need a valid email.';
	    }
	    return errors;
	};
	
	var ClientEmail = function (_Component) {
	    (0, _inherits3.default)(ClientEmail, _Component);
	
	    function ClientEmail(props) {
	        (0, _classCallCheck3.default)(this, ClientEmail);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (ClientEmail.__proto__ || (0, _getPrototypeOf2.default)(ClientEmail)).call(this, props));
	
	        _this.state = {
	            address: (0, _helpers.formatAddress)(props.client),
	            client: props.client._id,
	            center: {
	                lat: null,
	                lng: null
	            },
	            emails: props.client.emails && props.client.emails[0] ? props.client.emails : ['']
	        };
	        _this.onAddressChange = _this.onAddressChange.bind(_this);
	        _this.onAddressSelect = _this.onAddressSelect.bind(_this);
	        _this.addEmail = _this.addEmail.bind(_this);
	        return _this;
	    }
	
	    (0, _createClass3.default)(ClientEmail, [{
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.client._id !== this.props.client._id) {
	                var initialValues = (0, _extends3.default)({}, nextProps.client);
	                nextProps.client.emails && nextProps.client.emails.forEach(function (email, index) {
	                    initialValues['email' + index] = email;
	                });
	                this.props.dispatch((0, _reduxForm.initialize)('client', initialValues));
	                var emails = nextProps.client.emails && nextProps.client.emails[0] ? nextProps.client.emails : [''];
	                this.setState({ emails: emails });
	            }
	        }
	    }, {
	        key: 'onAddressChange',
	        value: function onAddressChange(address) {
	            this.setState({ address: address });
	        }
	    }, {
	        key: 'onAddressSelect',
	        value: function onAddressSelect(address) {
	            var _this2 = this;
	
	            (0, _reactPlacesAutocomplete.geocodeByAddress)(address, function (err, center, results) {
	                if (err) return;
	                _this2.setState({ center: center });
	                var location = results && results[0] ? (0, _helpers.getGMAPAddressComponents)(results[0].address_components) : {};
	                location.lat = center.lat;
	                location.lng = center.lng;
	                _this2.props.change('address', location);
	                _this2.setState({ address: address });
	            });
	        }
	    }, {
	        key: 'addEmail',
	        value: function addEmail() {
	            this.setState({ emails: [].concat((0, _toConsumableArray3.default)(this.state.emails), ['']) });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var handleSubmit = this.props.handleSubmit;
	
	            var classNames = {
	                input: 'content-editable',
	                root: 'inline-block input'
	            };
	            console.log(this.state.emails);
	            return _react2.default.createElement(
	                'form',
	                {
	                    onSubmit: handleSubmit,
	                    className: 'inline-block m-b-0',
	                    style: { width: '90%' },
	                    autoComplete: 'off'
	                },
	                _react2.default.createElement(
	                    'button',
	                    { className: 'btn btn-success btn-xs waves-effect pull-right', type: 'submit', disabled: this.props.pristine },
	                    'Sauver'
	                ),
	                _react2.default.createElement(
	                    'h2',
	                    { className: 'page-title', style: { lineHeight: '20px' } },
	                    _react2.default.createElement(_reduxForm.Field, {
	                        name: 'name',
	                        component: _InputField2.default,
	                        type: 'text',
	                        placeholder: 'Name...',
	                        className: 'content-editable',
	                        containerClassName: 'ce',
	                        divClass: 'ce',
	                        autoComplete: 'off'
	                    })
	                ),
	                this.state.emails.map(function (email, index) {
	                    return _react2.default.createElement(
	                        'div',
	                        {
	                            key: index
	                        },
	                        _react2.default.createElement(_reactFontawesome2.default, { name: 'envelope-o' }),
	                        _react2.default.createElement(_reduxForm.Field, {
	                            name: 'email' + index,
	                            component: _InputField2.default,
	                            type: 'text',
	                            placeholder: 'Email...',
	                            className: 'content-editable',
	                            divClass: 'inline-flex input',
	                            autoComplete: 'off',
	                            defaultValue: email
	                        })
	                    );
	                }),
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                        'small',
	                        null,
	                        _react2.default.createElement(
	                            'a',
	                            {
	                                onClick: this.addEmail
	                            },
	                            _react2.default.createElement(_reactFontawesome2.default, { name: 'plus' }),
	                            ' Ajouter un email'
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'relative h5' },
	                    _react2.default.createElement(_reactFontawesome2.default, { name: 'map-marker', style: { marginRight: 15 } }),
	                    _react2.default.createElement(_reactPlacesAutocomplete2.default, {
	                        onChange: this.onAddressChange.bind(this),
	                        onSelect: this.onAddressSelect.bind(this),
	                        value: this.state.address,
	                        classNames: classNames,
	                        autoComplete: false
	                    })
	                )
	            );
	        }
	    }]);
	    return ClientEmail;
	}(_react.Component);
	
	ClientEmail.propTypes = {
	    onSubmit: _react.PropTypes.func.isRequired,
	    handleSubmit: _react.PropTypes.func.isRequired,
	    reset: _react.PropTypes.func.isRequired,
	    invalid: _react.PropTypes.bool.isRequired,
	    pristine: _react.PropTypes.bool.isRequired,
	    valid: _react.PropTypes.bool.isRequired,
	    submitting: _react.PropTypes.bool.isRequired
	};
	
	ClientEmail = (0, _reduxForm.reduxForm)({
	    form: 'client',
	    validate: validate
	})(ClientEmail);
	
	var mapStateToProps = function mapStateToProps(state, props) {
	    var initialValues = state.client.current;
	    state.client.current.emails && state.client.current.emails.forEach(function (email, index) {
	        initialValues['email' + index] = email;
	    });
	    return {
	        initialValues: initialValues,
	        client: state.client.current
	    };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(ClientEmail);

/***/ },

/***/ 1292:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(593);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(620);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(621);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(625);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(670);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(503);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactPlacesAutocomplete = __webpack_require__(1285);
	
	var _reactPlacesAutocomplete2 = _interopRequireDefault(_reactPlacesAutocomplete);
	
	var _helpers = __webpack_require__(1280);
	
	var _reactFontawesome = __webpack_require__(942);
	
	var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ClientAddress = function (_Component) {
	    (0, _inherits3.default)(ClientAddress, _Component);
	
	    function ClientAddress(props) {
	        (0, _classCallCheck3.default)(this, ClientAddress);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (ClientAddress.__proto__ || (0, _getPrototypeOf2.default)(ClientAddress)).call(this));
	
	        _this.state = {
	            lastUpdated: null,
	            address: (0, _helpers.formatAddress)(props.client),
	            client: props.client._id,
	            center: {
	                lat: null,
	                lng: null
	            }
	        };
	        return _this;
	    }
	
	    (0, _createClass3.default)(ClientAddress, [{
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.props.client._id !== nextProps.client._id) this.setState({ address: (0, _helpers.formatAddress)(nextProps.client) });
	        }
	    }, {
	        key: 'onChange',
	        value: function onChange(address) {
	            this.setState({ address: address });
	            /*geocodeByAddress(address, (err, center, results) => {
	                if (err) return
	                const now = new Date().getTime()
	                this.setState({ center, lastUpdated: now })
	                const location = results && results[0] ? getGMAPAddressComponents(results[0].address_components) : {}
	                location.lat = center.lat
	                location.lng = center.lng
	                if (location.street) {
	                    setTimeout(() => {
	                        if (this.state.lastUpdated === now)
	                            this.props.onSubmit(location)
	                    }, 1000)
	                }
	            })*/
	        }
	    }, {
	        key: 'onSelect',
	        value: function onSelect(address) {
	            var _this2 = this;
	
	            (0, _reactPlacesAutocomplete.geocodeByAddress)(address, function (err, center, results) {
	                if (err) return;
	                _this2.setState({ center: center });
	                var location = results && results[0] ? (0, _helpers.getGMAPAddressComponents)(results[0].address_components) : {};
	                location.lat = center.lat;
	                location.lng = center.lng;
	                if (location.street) _this2.props.onSubmit(location);
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var client = this.props.client;
	
	            var classNames = {
	                input: 'content-editable',
	                root: 'inline-block input'
	            };
	            if (!client) return _react2.default.createElement('div', null);
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'relative h5' },
	                    _react2.default.createElement(_reactFontawesome2.default, { name: 'map-marker', style: { marginRight: 15 } }),
	                    _react2.default.createElement(_reactPlacesAutocomplete2.default, { onChange: this.onChange.bind(this), onSelect: this.onSelect.bind(this), value: this.state.address, classNames: classNames })
	                )
	            );
	        }
	    }]);
	    return ClientAddress;
	}(_react.Component);
	
	exports.default = ClientAddress;

/***/ },

/***/ 1293:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(503);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(988);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeleteClientModal = function DeleteClientModal(_ref) {
	    var deleteClient = _ref.deleteClient,
	        _ref$client = _ref.client,
	        client = _ref$client === undefined ? {} : _ref$client,
	        show = _ref.show,
	        display = _ref.display;
	    return _react2.default.createElement(
	        _lib.Modal,
	        { show: show, onHide: display },
	        _react2.default.createElement(
	            _lib.Modal.Header,
	            { closeButton: true },
	            _react2.default.createElement(
	                _lib.Modal.Title,
	                null,
	                'Delete client.'
	            )
	        ),
	        _react2.default.createElement(
	            _lib.Modal.Body,
	            null,
	            _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-12' },
	                    'Are you sure you want to ',
	                    _react2.default.createElement(
	                        'strong',
	                        null,
	                        'delete this client'
	                    ),
	                    '?',
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'well m-t-12 m-b-4' },
	                        client.name
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(
	            _lib.Modal.Footer,
	            null,
	            _react2.default.createElement(
	                'a',
	                { className: 'btn btn-default', onClick: display },
	                'Cancel'
	            ),
	            _react2.default.createElement(
	                'button',
	                { name: 'submit-login', type: 'submit', className: 'btn btn-danger', onClick: deleteClient },
	                'Supprimer'
	            )
	        )
	    );
	};
	
	exports.default = DeleteClientModal;

/***/ },

/***/ 1294:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(503);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(988);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeleteHiveModal = function DeleteHiveModal(_ref) {
	    var deleteHive = _ref.deleteHive,
	        _ref$hive = _ref.hive,
	        hive = _ref$hive === undefined ? {} : _ref$hive,
	        show = _ref.show,
	        display = _ref.display;
	    return _react2.default.createElement(
	        _lib.Modal,
	        { show: show, onHide: display },
	        _react2.default.createElement(
	            _lib.Modal.Header,
	            { closeButton: true },
	            _react2.default.createElement(
	                _lib.Modal.Title,
	                null,
	                'Delete client.'
	            )
	        ),
	        _react2.default.createElement(
	            _lib.Modal.Body,
	            null,
	            _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-12' },
	                    'Are you sure you want to ',
	                    _react2.default.createElement(
	                        'strong',
	                        null,
	                        'delete this hive'
	                    ),
	                    '?',
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'well m-t-12 m-b-4' },
	                        hive ? hive.identifier : null
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(
	            _lib.Modal.Footer,
	            null,
	            _react2.default.createElement(
	                'a',
	                { className: 'btn btn-default', onClick: display },
	                'Cancel'
	            ),
	            _react2.default.createElement(
	                'button',
	                { name: 'submit-login', type: 'submit', className: 'btn btn-danger', onClick: deleteHive.bind(null, hive._id) },
	                'Supprimer'
	            )
	        )
	    );
	};
	
	exports.default = DeleteHiveModal;

/***/ },

/***/ 1295:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(593);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(620);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(621);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(625);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(670);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _reduxForm = __webpack_require__(720);
	
	var _react = __webpack_require__(503);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _InputField = __webpack_require__(946);
	
	var _InputField2 = _interopRequireDefault(_InputField);
	
	var _CheckboxField = __webpack_require__(1296);
	
	var _CheckboxField2 = _interopRequireDefault(_CheckboxField);
	
	var _reactRedux = __webpack_require__(557);
	
	var _reactFontawesome = __webpack_require__(942);
	
	var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var validate = function validate(values) {
	    var errors = {};
	    if (!values.name) errors.name = 'Name required';
	    return errors;
	};
	
	var Hive = function (_Component) {
	    (0, _inherits3.default)(Hive, _Component);
	
	    function Hive() {
	        (0, _classCallCheck3.default)(this, Hive);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (Hive.__proto__ || (0, _getPrototypeOf2.default)(Hive)).call(this));
	
	        _this.onChange = _this.onChange.bind(_this);
	        _this.submit = _this.submit.bind(_this);
	        _this.state = {
	            lastChange: null
	        };
	        return _this;
	    }
	
	    (0, _createClass3.default)(Hive, [{
	        key: 'onChange',
	        value: function onChange() {
	            var _this2 = this;
	
	            var now = new Date().getTime();
	            this.setState({ lastChange: now });
	            setTimeout(function () {
	                return _this2.state.lastChange && _this2.state.lastChange === now ? _this2.submit() : null;
	            }, 1000);
	        }
	    }, {
	        key: 'submit',
	        value: function submit() {
	            this.setState({ lastChange: null });
	            this.props.submit();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                handleSubmit = _props.handleSubmit,
	                initialValues = _props.initialValues,
	                hive = _props.hive;
	
	            if (hive.deleted) return _react2.default.createElement('tr', null);
	            return _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                    'td',
	                    null,
	                    _react2.default.createElement(_reduxForm.Field, { name: 'identifier', component: _InputField2.default, type: 'text', placeholder: 'Id...', className: 'content-editable', containerClassName: 'ce', divClass: 'ce', autocomplete: 'off' })
	                ),
	                _react2.default.createElement(
	                    'td',
	                    null,
	                    _react2.default.createElement(_reduxForm.Field, { name: 'active', component: _CheckboxField2.default, initialValues: initialValues.active, boolean: true })
	                ),
	                _react2.default.createElement(
	                    'td',
	                    null,
	                    hive.state === 'dead' && _react2.default.createElement(
	                        'span',
	                        null,
	                        _react2.default.createElement(_reactFontawesome2.default, { name: 'warning' }),
	                        ' '
	                    )
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: 'text-right' },
	                    _react2.default.createElement(
	                        'a',
	                        { className: 'btn btn-success btn-xs waves-effect', onClick: handleSubmit, disabled: this.props.pristine },
	                        'Sauver'
	                    )
	                ),
	                _react2.default.createElement(
	                    'td',
	                    { className: 'text-right' },
	                    _react2.default.createElement(
	                        'a',
	                        { className: 'btn btn-danger btn-xs waves-effect', onClick: this.props.deleteHive.bind(null, this.props.hive) },
	                        'Supprimer'
	                    )
	                )
	            );
	        }
	    }]);
	    return Hive;
	}(_react.Component);
	
	Hive = (0, _reduxForm.reduxForm)({
	    form: 'hive-' + Math.random().toString(36).substring(7),
	    validate: validate
	})(Hive);
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	    return {
	        form: ownProps.name
	    };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(Hive);

/***/ },

/***/ 1296:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(684);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(593);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(620);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(621);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(625);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(670);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(503);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CheckboxField = function (_Component) {
	    (0, _inherits3.default)(CheckboxField, _Component);
	
	    function CheckboxField() {
	        (0, _classCallCheck3.default)(this, CheckboxField);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (CheckboxField.__proto__ || (0, _getPrototypeOf2.default)(CheckboxField)).call(this));
	
	        _this.onClick = _this.onClick.bind(_this);
	        return _this;
	    }
	
	    (0, _createClass3.default)(CheckboxField, [{
	        key: 'onClick',
	        value: function onClick(value) {
	            return this.props.input.onChange(this.props.input.value = this.refs.input.checked);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                label = _props.label,
	                name = _props.name,
	                input = _props.input,
	                initialValues = _props.initialValues,
	                _props$meta = _props.meta,
	                error = _props$meta.error,
	                touched = _props$meta.touched,
	                _props$className = _props.className,
	                className = _props$className === undefined ? 'checkbox-inline' : _props$className,
	                selectAll = _props.selectAll;
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-12' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: className + ' checkbox-inline' },
	                        _react2.default.createElement(
	                            'label',
	                            null,
	                            _react2.default.createElement('input', (0, _extends3.default)({}, input, {
	                                type: 'checkbox',
	                                ref: 'input',
	                                name: name,
	                                value: true,
	                                onClick: this.onClick.bind(this, true),
	                                defaultChecked: initialValues && initialValues === true
	                            })),
	                            label
	                        )
	                    ),
	                    touched && error && _react2.default.createElement(
	                        'p',
	                        { className: 'error' },
	                        error
	                    )
	                )
	            );
	        }
	    }]);
	    return CheckboxField;
	}(_react.Component);
	
	exports.default = CheckboxField;

/***/ },

/***/ 1297:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(684);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(593);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(620);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(621);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(625);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(670);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(503);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(501);
	
	var _reactRedux = __webpack_require__(557);
	
	var _actions = __webpack_require__(681);
	
	var _actions2 = __webpack_require__(951);
	
	var _Cut = __webpack_require__(952);
	
	var _Cut2 = _interopRequireDefault(_Cut);
	
	var _actions3 = __webpack_require__(953);
	
	var _lib = __webpack_require__(954);
	
	var _Filters = __webpack_require__(966);
	
	var _Filters2 = _interopRequireDefault(_Filters);
	
	var _DeleteReportModal = __webpack_require__(987);
	
	var _DeleteReportModal2 = _interopRequireDefault(_DeleteReportModal);
	
	var _URLS = __webpack_require__(678);
	
	var _URLS2 = _interopRequireDefault(_URLS);
	
	var _reactFontawesome = __webpack_require__(942);
	
	var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);
	
	var _underscore = __webpack_require__(715);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _moment = __webpack_require__(1156);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _api = __webpack_require__(902);
	
	var _reactDatepicker = __webpack_require__(1266);
	
	var _reactDatepicker2 = _interopRequireDefault(_reactDatepicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Home = function (_Component) {
	    (0, _inherits3.default)(Home, _Component);
	
	    function Home() {
	        (0, _classCallCheck3.default)(this, Home);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (Home.__proto__ || (0, _getPrototypeOf2.default)(Home)).call(this));
	
	        _this.export = _this.export.bind(_this);
	        _this.setFilters = _this.setFilters.bind(_this);
	        _this.updateDate = _this.updateDate.bind(_this);
	        _this.displayReportModal = _this.displayReportModal.bind(_this);
	        _this.deleteReport = _this.deleteReport.bind(_this);
	        _this.state = {
	            fullCurrentReport: null,
	            currentReport: null,
	            editDate: false,
	            showDeleteModal: false
	        };
	        return _this;
	    }
	
	    (0, _createClass3.default)(Home, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.props.dispatch(_actions3.ReportsRequest.get.action());
	            this.props.dispatch(_actions2.ClientsRequest.get.action());
	            if (this.props.user && this.props.user.limited) window.location = "/";
	        }
	    }, {
	        key: 'displayReportModal',
	        value: function displayReportModal(report) {
	            this.setState({
	                fullCurrentReport: report,
	                showDeleteModal: !this.state.showDeleteModal
	            });
	        }
	    }, {
	        key: 'deleteReport',
	        value: function deleteReport() {}
	    }, {
	        key: 'logout',
	        value: function logout() {
	            _actions.LogoutRequest.get.action();
	        }
	    }, {
	        key: 'activeReport',
	        value: function activeReport(currentReport) {
	            if (this.state.currentReport === currentReport) currentReport = null;
	            this.setState({
	                currentReport: currentReport,
	                editDate: false
	            });
	        }
	    }, {
	        key: 'editDate',
	        value: function editDate() {
	            this.setState({
	                editDate: !this.state.editDate
	            });
	        }
	    }, {
	        key: 'updateDate',
	        value: function updateDate(date) {
	            var currentReport = this.state.currentReport;
	
	            this.props.dispatch(_actions3.ReportsRequest.put.action({
	                payload: {
	                    date: date,
	                    _id: currentReport
	                },
	                params: {
	                    _id: currentReport
	                }
	            }));
	            this.setState({
	                editDate: false
	            });
	        }
	    }, {
	        key: 'deleteReport',
	        value: function deleteReport() {
	            var currentReport = this.state.currentReport;
	
	            this.props.dispatch(_actions3.ReportsRequest.delete.action({
	                payload: {
	                    _id: currentReport
	                },
	                params: {
	                    _id: currentReport
	                }
	            }));
	            this.setState({
	                displayReportModal: false,
	                currentReport: null,
	                fullCurrentReport: null
	            });
	        }
	    }, {
	        key: 'export',
	        value: function _export() {
	            this.props.dispatch(_actions3.ExportReportsRequest.get.action({
	                payload: { filters: this.props.reports.filters }
	            }));
	        }
	    }, {
	        key: 'setFilters',
	        value: function setFilters(filters, dispatch) {
	            dispatch((0, _actions3.reportsFiltersChange)({ filters: filters }));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props$reports = this.props.reports,
	                filters = _props$reports.filters,
	                search = _props$reports.search;
	
	            var hives = [];
	            this.props.client.all.filter(function (client) {
	                return !client.disabled;
	            }).forEach(function (client) {
	                return hives = hives.concat(client.hives.map(function (hive) {
	                    return (0, _extends3.default)({}, hive, { client: client });
	                }));
	            });
	            hives = _underscore2.default.sortBy(hives, 'identifier');
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'h3',
	                    { className: 'page-title' },
	                    'Hives'
	                ),
	                this.state.fullCurrentReport && _react2.default.createElement(_DeleteReportModal2.default, {
	                    show: this.state.showDeleteModal,
	                    display: this.displayReportModal,
	                    deleteReport: this.deleteReport,
	                    report: this.state.fullCurrentReport
	                }),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'card-box' },
	                    _react2.default.createElement(
	                        'table',
	                        { className: 'table table-striped m-0 header-fixed' },
	                        _react2.default.createElement(
	                            'thead',
	                            null,
	                            _react2.default.createElement(
	                                'tr',
	                                null,
	                                _react2.default.createElement(
	                                    'th',
	                                    null,
	                                    '#'
	                                ),
	                                _react2.default.createElement(
	                                    'th',
	                                    null,
	                                    'Etat'
	                                ),
	                                _react2.default.createElement(
	                                    'th',
	                                    null,
	                                    'Client'
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tbody',
	                            null,
	                            hives.filter(function (hive) {
	                                return !hive.deleted;
	                            }).map(function (hive) {
	                                return _react2.default.createElement(
	                                    'tr',
	                                    { key: hive._id },
	                                    _react2.default.createElement(
	                                        'td',
	                                        null,
	                                        hive.identifier
	                                    ),
	                                    _react2.default.createElement(
	                                        'td',
	                                        null,
	                                        hive.state === 'dead' && _react2.default.createElement(
	                                            'span',
	                                            null,
	                                            _react2.default.createElement(_reactFontawesome2.default, { name: 'warning' }),
	                                            ' '
	                                        ),
	                                        hive.state === 'dead' ? 'Morte' : 'Vivante'
	                                    ),
	                                    _react2.default.createElement(
	                                        'td',
	                                        null,
	                                        _react2.default.createElement(
	                                            _reactRouter.Link,
	                                            { to: (0, _api.makeEndpoint)(_URLS2.default.client.show, hive.client) },
	                                            hive.client && hive.client.name
	                                        )
	                                    )
	                                );
	                            })
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	    return Home;
	}(_react.Component);
	
	Home.contextTypes = {
	    router: _react.PropTypes.object.isRequired,
	    store: _react.PropTypes.object.isRequired,
	    user: _react.PropTypes.object
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	    var session = state.session,
	        reports = state.reports,
	        client = state.client;
	
	    return { user: session.user, reports: reports, client: client };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(Home);

/***/ },

/***/ 1298:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(593);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(620);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(621);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(625);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(670);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(503);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(557);
	
	var _reactFontawesome = __webpack_require__(942);
	
	var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);
	
	var _reactRouter = __webpack_require__(501);
	
	var _classnames = __webpack_require__(974);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _api = __webpack_require__(902);
	
	var _actions = __webpack_require__(1299);
	
	var _actions2 = __webpack_require__(951);
	
	var _underscore = __webpack_require__(715);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _lib = __webpack_require__(1300);
	
	var _URLS = __webpack_require__(678);
	
	var _URLS2 = _interopRequireDefault(_URLS);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var User = function User(_ref) {
	    var user = _ref.user,
	        onClick = _ref.onClick,
	        current = _ref.current;
	    return _react2.default.createElement(
	        'tr',
	        { className: (0, _classnames2.default)({ active: current === user._id }) },
	        _react2.default.createElement(
	            'th',
	            { scope: 'row' },
	            user.disabled && _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(_reactFontawesome2.default, { name: 'ban' }),
	                ' '
	            ),
	            _react2.default.createElement(
	                _reactRouter.Link,
	                { to: (0, _api.makeEndpoint)(_URLS2.default.users.show, user) },
	                user.firstName,
	                ' ',
	                user.lastName
	            )
	        ),
	        _react2.default.createElement(
	            'td',
	            null,
	            !user.disabled && user.admin && _react2.default.createElement(_reactFontawesome2.default, { name: 'check' })
	        ),
	        _react2.default.createElement(
	            'td',
	            null,
	            !user.disabled && user.limited && _react2.default.createElement(_reactFontawesome2.default, { name: 'check' })
	        )
	    );
	};
	
	var Users = function (_Component) {
	    (0, _inherits3.default)(Users, _Component);
	
	    function Users() {
	        (0, _classCallCheck3.default)(this, Users);
	        return (0, _possibleConstructorReturn3.default)(this, (Users.__proto__ || (0, _getPrototypeOf2.default)(Users)).call(this));
	    }
	
	    (0, _createClass3.default)(Users, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.props.dispatch(_actions.UsersRequest.get.action());
	            this.props.dispatch(_actions2.ClientsRequest.get.action());
	            if (this.props.user && this.props.user.limited) window.location = "/";
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'h3',
	                    { className: 'page-title' },
	                    'Utilisateurs',
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'pull-right m-t-25' },
	                        _react2.default.createElement(
	                            _reactRouter.Link,
	                            { className: 'btn btn-primary waves-effect', to: _URLS2.default.users.new },
	                            _react2.default.createElement(_reactFontawesome2.default, { name: 'plus' }),
	                            '\xA0 Nouveau'
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-4 col-sm-4' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'card-box table-list' },
	                            _react2.default.createElement(
	                                'table',
	                                { className: 'table table-striped m-0 header-fixed' },
	                                _react2.default.createElement(
	                                    'thead',
	                                    null,
	                                    _react2.default.createElement(
	                                        'tr',
	                                        null,
	                                        _react2.default.createElement(
	                                            'th',
	                                            null,
	                                            'Nom'
	                                        ),
	                                        _react2.default.createElement(
	                                            'th',
	                                            { style: { width: '40px' } },
	                                            'Logiciel'
	                                        ),
	                                        _react2.default.createElement(
	                                            'th',
	                                            { style: { width: '40px' } },
	                                            'Limit\xE9'
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'tbody',
	                                    null,
	                                    (0, _lib.sortUsers)(this.props.users.all).filter(function (user) {
	                                        return !user.disabled;
	                                    }).map(function (user) {
	                                        return _react2.default.createElement(User, { user: user, key: user._id, current: _this2.props.params.id });
	                                    }),
	                                    (0, _lib.sortUsers)(this.props.users.all).filter(function (user) {
	                                        return user.disabled;
	                                    }).map(function (user) {
	                                        return _react2.default.createElement(User, { user: user, key: user._id, current: _this2.props.params.id });
	                                    })
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-8' },
	                        this.props.children
	                    )
	                )
	            );
	        }
	    }]);
	    return Users;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    var session = state.session,
	        users = state.users;
	
	    return { user: session.user, users: users };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(Users);

/***/ },

/***/ 1299:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setCurrentUser = exports.SET_CURRENT_USER = exports.UsersRequest = undefined;
	
	var _RequestsActions = __webpack_require__(682);
	
	var _RequestsActions2 = _interopRequireDefault(_RequestsActions);
	
	var _actions = __webpack_require__(683);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UsersRequest = exports.UsersRequest = new _RequestsActions2.default('USERS');
	
	/*Set current*/
	var SET_CURRENT_USER = exports.SET_CURRENT_USER = 'SET_CURRENT_USER';
	var setCurrentUser = exports.setCurrentUser = function setCurrentUser(_id) {
	  return (0, _actions.action)(SET_CURRENT_USER, { _id: _id });
	};

/***/ },

/***/ 1300:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.sortUsers = undefined;
	
	var _underscore = __webpack_require__(715);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var sortUsers = exports.sortUsers = function sortUsers(users) {
	  return _underscore2.default.sortBy(users, function (i) {
	    return i.firstName.toLowerCase();
	  });
	};

/***/ },

/***/ 1301:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(684);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(593);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(620);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(621);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(625);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(670);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(503);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(557);
	
	var _actions = __webpack_require__(1299);
	
	var _UserForm = __webpack_require__(1302);
	
	var _UserForm2 = _interopRequireDefault(_UserForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var User = function (_Component) {
	    (0, _inherits3.default)(User, _Component);
	
	    function User(props) {
	        (0, _classCallCheck3.default)(this, User);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (User.__proto__ || (0, _getPrototypeOf2.default)(User)).call(this, props));
	
	        _this.submitUser = _this.submitUser.bind(_this);
	        _this.sendInvitation = _this.sendInvitation.bind(_this);
	        return _this;
	    }
	
	    (0, _createClass3.default)(User, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.props.dispatch((0, _actions.setCurrentUser)(this.props.params.id));
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            var _this2 = this;
	
	            if (this.props.user && this.props.user !== this.props.params.id) {
	                this.props.dispatch((0, _actions.setCurrentUser)(null));
	                setTimeout(function () {
	                    _this2.props.dispatch((0, _actions.setCurrentUser)(_this2.props.params.id));
	                }, 10);
	                this.forceUpdate();
	            }
	        }
	    }, {
	        key: 'submitUser',
	        value: function submitUser(payload, dispatch) {
	            if (!payload.new) dispatch(_actions.UsersRequest.put.action({ payload: payload, params: this.props.params }));else dispatch(_actions.UsersRequest.post.action({ payload: payload }));
	        }
	    }, {
	        key: 'sendInvitation',
	        value: function sendInvitation() {
	            this.props.dispatch(_actions.UsersRequest.put.action({ payload: { invite: true }, params: this.props.params }));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            var user = this.props.users.all.find(function (user) {
	                return user._id === _this3.props.user;
	            }) || {};
	            if (this.props.params.id === 'new') user = { new: true };
	            return _react2.default.createElement(
	                'div',
	                { className: 'card-box' },
	                _react2.default.createElement(_UserForm2.default, {
	                    initialValues: (0, _extends3.default)({}, user),
	                    user: user,
	                    name: 'user-' + this.props.user,
	                    onSubmit: this.submitUser,
	                    sendInvitation: this.sendInvitation
	                })
	            );
	        }
	    }]);
	    return User;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    var session = state.session,
	        users = state.users;
	
	    return { user: users.current, users: users };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(User);

/***/ },

/***/ 1302:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(684);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _keys = __webpack_require__(948);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _getPrototypeOf = __webpack_require__(593);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(620);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(621);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(625);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(670);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _reduxForm = __webpack_require__(720);
	
	var _react = __webpack_require__(503);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(557);
	
	var _InputField = __webpack_require__(946);
	
	var _InputField2 = _interopRequireDefault(_InputField);
	
	var _CheckboxField = __webpack_require__(1296);
	
	var _CheckboxField2 = _interopRequireDefault(_CheckboxField);
	
	var _CheckboxesField = __webpack_require__(967);
	
	var _CheckboxesField2 = _interopRequireDefault(_CheckboxesField);
	
	var _RadiosField = __webpack_require__(1303);
	
	var _RadiosField2 = _interopRequireDefault(_RadiosField);
	
	var _REGEXP = __webpack_require__(936);
	
	var _REGEXP2 = _interopRequireDefault(_REGEXP);
	
	var _REPORT = __webpack_require__(960);
	
	var _REPORT2 = _interopRequireDefault(_REPORT);
	
	var _lodash = __webpack_require__(965);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var validate = function validate() {
	    var values = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var errors = {};
	    if (!values.email) errors.email = 'Champ requis';else if (!_REGEXP2.default.validations.email.test(values.email)) errors.email = 'Invalid format.';
	    if (!values.firstName) errors.firstName = 'Champ requis';
	    if (!values.lastName) errors.lastName = 'Champ requis';
	
	    return errors;
	};
	
	var UserForm = function (_Component) {
	    (0, _inherits3.default)(UserForm, _Component);
	
	    function UserForm() {
	        (0, _classCallCheck3.default)(this, UserForm);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (UserForm.__proto__ || (0, _getPrototypeOf2.default)(UserForm)).call(this));
	
	        _this.state = { showHive: true };
	        return _this;
	    }
	
	    (0, _createClass3.default)(UserForm, [{
	        key: 'unSelectHives',
	        value: function unSelectHives() {}
	    }, {
	        key: 'setHive',
	        value: function setHive(values) {
	            this.props.change('limitedHives', values);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                handleSubmit = _props.handleSubmit,
	                pristine = _props.pristine,
	                submitting = _props.submitting,
	                error = _props.error,
	                initialValues = _props.initialValues,
	                formValues = _props.formValues,
	                user = _props.user,
	                sendInvitation = _props.sendInvitation;
	
	
	            return _react2.default.createElement(
	                'form',
	                { onSubmit: handleSubmit, className: 'form-horizontal m-t-10' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-6 col-sm-6' },
	                        user.firstName,
	                        ' ',
	                        user.lastName
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-6 col-sm-6 text-right', style: { marginTop: -22 } },
	                        !user.new && !user.validated && user.email && _react2.default.createElement(
	                            'button',
	                            {
	                                className: 'btn btn-custom btn-bordred waves-effect waves-light text-uppercase',
	                                type: 'button',
	                                disabled: submitting,
	                                style: { marginRight: 8 },
	                                onClick: sendInvitation
	                            },
	                            'R\xE9-envoyer invitation'
	                        ),
	                        _react2.default.createElement(
	                            'button',
	                            { className: 'btn btn-custom btn-bordred waves-effect waves-light text-uppercase', type: 'submit', disabled: submitting },
	                            'Sauver'
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-6 col-sm-6' },
	                        _react2.default.createElement(_reduxForm.Field, { name: 'firstName', component: _InputField2.default, placeholder: 'Pr\xE9nom...' })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-6 col-sm-6' },
	                        _react2.default.createElement(_reduxForm.Field, { name: 'lastName', component: _InputField2.default, placeholder: 'Nom...' })
	                    )
	                ),
	                _react2.default.createElement(_reduxForm.Field, { name: 'email', component: _InputField2.default, type: 'email', placeholder: 'Email...' }),
	                initialValues && (0, _keys2.default)(initialValues)[1] && _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-md-12', style: { marginBottom: 12 } },
	                            _react2.default.createElement(_reduxForm.Field, {
	                                name: 'language',
	                                component: _RadiosField2.default,
	                                fields: [{
	                                    value: 'fr',
	                                    label: 'Français'
	                                }, {
	                                    value: 'en',
	                                    label: 'Anglais'
	                                }],
	                                initialValue: this.props.user.language || 'fr'
	                            })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-md-4 col-sm-4' },
	                            _react2.default.createElement(_reduxForm.Field, { name: 'weeklyReports', component: _CheckboxField2.default, initialValues: this.props.user.weeklyReports, boolean: true, label: 'Rapports email hebdomadaires' })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-md-4 col-sm-4' },
	                            _react2.default.createElement(_reduxForm.Field, { name: 'directReports', component: _CheckboxField2.default, initialValues: this.props.user.directReports, boolean: true, label: 'Rapport email \xE0 chaque visite' })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-md-4 col-sm-4' },
	                            _react2.default.createElement(_reduxForm.Field, { name: 'admin', component: _CheckboxField2.default, initialValues: this.props.user.admin, boolean: true, label: 'Logiciel' })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-md-4 col-sm-4' },
	                            _react2.default.createElement(_reduxForm.Field, { name: 'disabled', component: _CheckboxField2.default, initialValues: this.props.user.disabled, boolean: true, label: 'D\xE9sactiv\xE9' })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-md-4 col-sm-4' },
	                            _react2.default.createElement(_reduxForm.Field, { name: 'limited', component: _CheckboxField2.default, initialValues: this.props.user.limited, boolean: true, label: 'Limit\xE9' })
	                        )
	                    )
	                ),
	                initialValues && (0, _keys2.default)(initialValues)[0] && formValues.limited && _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                        'h5',
	                        null,
	                        'Limiter les types de visite'
	                    ),
	                    _react2.default.createElement(_reduxForm.Field, {
	                        component: _CheckboxesField2.default,
	                        fields: _REPORT2.default.types.map(function (type) {
	                            return (0, _extends3.default)({}, type, {
	                                label: type.label.fr
	                            });
	                        }),
	                        name: 'limitedTypes',
	                        initialValues: this.props.initialValues.limitedTypes
	                    }),
	                    _react2.default.createElement(
	                        'h5',
	                        { style: { marginTop: 22 } },
	                        'Limiter les ruches'
	                    ),
	                    this.props.clients && _lodash2.default.sortBy(this.props.clients.all, 'name').filter(function (client) {
	                        return client.hives && client.hives[0];
	                    }).map(function (client) {
	                        return _react2.default.createElement(
	                            'div',
	                            { key: client._id, className: 'well' },
	                            client.name,
	                            _react2.default.createElement(_reduxForm.Field, {
	                                component: _CheckboxesField2.default,
	                                fields: client.hives.map(function (hive) {
	                                    return (0, _extends3.default)({}, hive, { value: hive._id, label: hive.identifier });
	                                }),
	                                name: 'limitedHives',
	                                initialValues: _this2.props.initialValues.limitedHives,
	                                selectAll: false,
	                                label: ' '
	                            })
	                        );
	                    })
	                ),
	                error ? _react2.default.createElement(
	                    'p',
	                    { className: 'error', id: 'login-error' },
	                    error
	                ) : null
	            );
	        }
	    }]);
	    return UserForm;
	}(_react.Component);
	
	var selector = (0, _reduxForm.formValueSelector)('user');
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	    return {
	        //form: ownProps.name,
	        formValues: {
	            admin: selector(state, 'admin'),
	            disabled: selector(state, 'disabled'),
	            limited: selector(state, 'limited'),
	            limitedHives: selector(state, 'limitedHives')
	        },
	        clients: state.client
	    };
	};
	
	UserForm = (0, _reduxForm.reduxForm)({
	    form: 'user',
	    validate: validate,
	    enableReinitialize: true
	})(UserForm);
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(UserForm);

/***/ },

/***/ 1303:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(503);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactFontawesome = __webpack_require__(942);
	
	var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RadiosField = function RadiosField(field) {
	    var label = field.label,
	        name = field.name,
	        input = field.input,
	        _field$fields = field.fields,
	        fields = _field$fields === undefined ? [] : _field$fields,
	        initialValue = field.initialValue,
	        hideError = field.hideError,
	        _field$meta = field.meta,
	        error = _field$meta.error,
	        touched = _field$meta.touched,
	        _field$labelClassName = field.labelClassName,
	        labelClassName = _field$labelClassName === undefined ? 'radio inline' : _field$labelClassName;
	
	    var onClick = function onClick(value, field) {
	        if (field.onChange) field.onChange(value);
	        return input.onChange(input.value = value);
	    };
	    return _react2.default.createElement(
	        'span',
	        null,
	        label ? _react2.default.createElement(
	            'h5',
	            null,
	            label
	        ) : null,
	        fields.map(function (field, index) {
	            return _react2.default.createElement(
	                'label',
	                { className: labelClassName, key: 'radio-' + name + '-' + index },
	                _react2.default.createElement('input', {
	                    type: 'radio',
	                    name: input.name,
	                    value: field.value,
	                    onClick: onClick.bind(undefined, field.value, field),
	                    defaultChecked: initialValue === field.value
	                }),
	                field.icon && _react2.default.createElement(
	                    'span',
	                    null,
	                    _react2.default.createElement(_reactFontawesome2.default, { name: field.icon }),
	                    '\xA0'
	                ),
	                _react2.default.createElement(
	                    'span',
	                    null,
	                    field.label
	                ),
	                field.small ? _react2.default.createElement(
	                    'div',
	                    { className: 'radio-field-small' },
	                    _react2.default.createElement(
	                        'small',
	                        null,
	                        field.small
	                    )
	                ) : null
	            );
	        }),
	        !hideError && touched && error && _react2.default.createElement(
	            'p',
	            { className: 'error' },
	            error
	        )
	    );
	};
	
	exports.default = RadiosField;

/***/ },

/***/ 1304:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(684);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.default = initStore;
	
	var _redux = __webpack_require__(566);
	
	var _reduxSaga = __webpack_require__(693);
	
	var _reduxSaga2 = _interopRequireDefault(_reduxSaga);
	
	var _sagas = __webpack_require__(1305);
	
	var _reducers = __webpack_require__(1360);
	
	var _reducers2 = _interopRequireDefault(_reducers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = {};
	var sagaMiddleware = (0, _reduxSaga2.default)();
	var middleware = [sagaMiddleware];
	
	function initStore(defaultStoreState) {
	    var store = void 0;
	    var state = (0, _extends3.default)({}, initialState, defaultStoreState);
	
	    if (true) {
	        store = (0, _redux.createStore)(_reducers2.default, state, (0, _redux.compose)(_redux.applyMiddleware.apply(undefined, middleware), window.devToolsExtension && window.__ENV !== 'production' ? window.devToolsExtension() : function (f) {
	            return f;
	        }));
	
	        if (false) {
	            module.hot.accept(function () {
	                var nextRootReducer = require('../client/core/reducers').default; // eslint-disable-line global-require
	                store.replaceReducer(nextRootReducer);
	            });
	        }
	    } else {
	        store = (0, _redux.createStore)(_reducers2.default, state, (0, _redux.compose)(_redux.applyMiddleware.apply(undefined, middleware)));
	    }
	
	    store.runSaga = sagaMiddleware.run;
	    sagaMiddleware.run(_sagas.root);
	
	    return store;
	}

/***/ },

/***/ 1305:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.waitAll = exports.root = undefined;
	
	var _slicedToArray2 = __webpack_require__(1306);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _regenerator = __webpack_require__(717);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _toConsumableArray2 = __webpack_require__(955);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _effects = __webpack_require__(706);
	
	var _reduxSagaSc = __webpack_require__(689);
	
	var _sagas = __webpack_require__(1313);
	
	var _sagas2 = _interopRequireDefault(_sagas);
	
	var _sagas3 = __webpack_require__(716);
	
	var _sagas4 = _interopRequireDefault(_sagas3);
	
	var _sagas5 = __webpack_require__(1278);
	
	var _sagas6 = _interopRequireDefault(_sagas5);
	
	var _sagas7 = __webpack_require__(1314);
	
	var _sagas8 = _interopRequireDefault(_sagas7);
	
	var _sagas9 = __webpack_require__(1315);
	
	var _sagas10 = _interopRequireDefault(_sagas9);
	
	var _socket = __webpack_require__(1316);
	
	var _socket2 = _interopRequireDefault(_socket);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var root = /*#__PURE__*/exports.root = _regenerator2.default.mark(function root() {
	    var sagas;
	    return _regenerator2.default.wrap(function root$(_context) {
	        while (1) {
	            switch (_context.prev = _context.next) {
	                case 0:
	                    sagas = [].concat((0, _toConsumableArray3.default)(_sagas4.default), (0, _toConsumableArray3.default)(_sagas6.default), (0, _toConsumableArray3.default)(_sagas2.default), (0, _toConsumableArray3.default)(_sagas8.default), (0, _toConsumableArray3.default)(_sagas10.default));
	
	                    if (true) {
	                        sagas.push((0, _reduxSagaSc.watchRemote)(_socket2.default));
	                        sagas.push((0, _reduxSagaSc.watchRequests)(_socket2.default));
	                        sagas.push((0, _reduxSagaSc.watchEmits)(_socket2.default));
	                    }
	                    _context.next = 4;
	                    return sagas;
	
	                case 4:
	                case 'end':
	                    return _context.stop();
	            }
	        }
	    }, root, this);
	});
	
	var waitAll = exports.waitAll = function waitAll(sagas, req) {
	    return (/*#__PURE__*/_regenerator2.default.mark(function genTasks() {
	            var tasks;
	            return _regenerator2.default.wrap(function genTasks$(_context2) {
	                while (1) {
	                    switch (_context2.prev = _context2.next) {
	                        case 0:
	                            _context2.next = 2;
	                            return sagas.map(function (_ref) {
	                                var _ref2 = (0, _slicedToArray3.default)(_ref, 1),
	                                    saga = _ref2[0];
	
	                                return (0, _effects.fork)(saga, req);
	                            });
	
	                        case 2:
	                            tasks = _context2.sent;
	                            _context2.next = 5;
	                            return tasks.map(_effects.join);
	
	                        case 5:
	                        case 'end':
	                            return _context2.stop();
	                    }
	                }
	            }, genTasks, this);
	        })
	    );
	};

/***/ },

/***/ 1313:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(717);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.flash = flash;
	
	var _effects = __webpack_require__(706);
	
	var _reduxSaga = __webpack_require__(693);
	
	var _actions = __webpack_require__(900);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(flash),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(flashesSaga);
	
	function flash(action) {
	    var content;
	    return _regenerator2.default.wrap(function flash$(_context) {
	        while (1) {
	            switch (_context.prev = _context.next) {
	                case 0:
	                    if (true) {
	                        _context.next = 2;
	                        break;
	                    }
	
	                    return _context.abrupt('return');
	
	                case 2:
	                    content = action.content;
	
	                    content.date = new Date();
	                    _context.next = 6;
	                    return (0, _effects.put)(_actions.flashes.add(content));
	
	                case 6:
	                    _context.next = 8;
	                    return (0, _effects.call)(_reduxSaga.delay, 3000);
	
	                case 8:
	                    _context.next = 10;
	                    return (0, _effects.put)(_actions.flashes.hide(content));
	
	                case 10:
	                case 'end':
	                    return _context.stop();
	            }
	        }
	    }, _marked, this);
	}
	
	function flashesSaga() {
	    return _regenerator2.default.wrap(function flashesSaga$(_context2) {
	        while (1) {
	            switch (_context2.prev = _context2.next) {
	                case 0:
	                    _context2.next = 2;
	                    return (0, _effects.takeEvery)(_actions.FLASH, flash);
	
	                case 2:
	                case 'end':
	                    return _context2.stop();
	            }
	        }
	    }, _marked2, this);
	}
	
	/*Export watchers sagas*/
	var sagas = [(0, _effects.fork)(flashesSaga)];
	
	exports.default = sagas;

/***/ },

/***/ 1314:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getExportReportsSaga = exports.deleteReportsSaga = exports.putReportsSaga = exports.getReportsSaga = undefined;
	
	var _regenerator = __webpack_require__(717);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _actions = __webpack_require__(953);
	
	var _effects = __webpack_require__(706);
	
	var _RequestSagas = __webpack_require__(901);
	
	var _RequestSagas2 = _interopRequireDefault(_RequestSagas);
	
	var _URLS = __webpack_require__(678);
	
	var _URLS2 = _interopRequireDefault(_URLS);
	
	var _reactRouter = __webpack_require__(501);
	
	var _actions2 = __webpack_require__(900);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*Fetch reports*/
	var getReportsSaga = exports.getReportsSaga = new _RequestSagas2.default(_actions.ReportsRequest.get, { method: 'GET', endpoint: _URLS2.default.reports.get });
	getReportsSaga.success = /*#__PURE__*/_regenerator2.default.mark(function _callee(action) {
	    return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	            switch (_context.prev = _context.next) {
	                case 0:
	                case 'end':
	                    return _context.stop();
	            }
	        }
	    }, _callee, this);
	});
	getReportsSaga.failure = /*#__PURE__*/_regenerator2.default.mark(function _callee2(action) {
	    return _regenerator2.default.wrap(function _callee2$(_context2) {
	        while (1) {
	            switch (_context2.prev = _context2.next) {
	                case 0:
	                case 'end':
	                    return _context2.stop();
	            }
	        }
	    }, _callee2, this);
	});
	
	/*Update reports*/
	var putReportsSaga = exports.putReportsSaga = new _RequestSagas2.default(_actions.ReportsRequest.put, { method: 'PUT', endpoint: _URLS2.default.reports.get });
	putReportsSaga.success = /*#__PURE__*/_regenerator2.default.mark(function _callee3(action) {
	    return _regenerator2.default.wrap(function _callee3$(_context3) {
	        while (1) {
	            switch (_context3.prev = _context3.next) {
	                case 0:
	                    _context3.next = 2;
	                    return (0, _effects.put)(_actions.ReportsRequest.get.action());
	
	                case 2:
	                case 'end':
	                    return _context3.stop();
	            }
	        }
	    }, _callee3, this);
	});
	putReportsSaga.failure = /*#__PURE__*/_regenerator2.default.mark(function _callee4(action) {
	    return _regenerator2.default.wrap(function _callee4$(_context4) {
	        while (1) {
	            switch (_context4.prev = _context4.next) {
	                case 0:
	                case 'end':
	                    return _context4.stop();
	            }
	        }
	    }, _callee4, this);
	});
	
	/*Delete reports*/
	var deleteReportsSaga = exports.deleteReportsSaga = new _RequestSagas2.default(_actions.ReportsRequest.delete, { method: 'delete', endpoint: _URLS2.default.reports.get });
	deleteReportsSaga.success = /*#__PURE__*/_regenerator2.default.mark(function _callee5(action) {
	    return _regenerator2.default.wrap(function _callee5$(_context5) {
	        while (1) {
	            switch (_context5.prev = _context5.next) {
	                case 0:
	                    _context5.next = 2;
	                    return (0, _effects.put)((0, _actions2.flash)({ content: {
	                            type: 'success',
	                            title: 'Rapport supprimé.'
	                        } }));
	
	                case 2:
	                    _context5.next = 4;
	                    return (0, _effects.put)(_actions.ReportsRequest.get.action());
	
	                case 4:
	                case 'end':
	                    return _context5.stop();
	            }
	        }
	    }, _callee5, this);
	});
	deleteReportsSaga.failure = /*#__PURE__*/_regenerator2.default.mark(function _callee6(action) {
	    return _regenerator2.default.wrap(function _callee6$(_context6) {
	        while (1) {
	            switch (_context6.prev = _context6.next) {
	                case 0:
	                case 'end':
	                    return _context6.stop();
	            }
	        }
	    }, _callee6, this);
	});
	
	/*Fetch export*/
	var getExportReportsSaga = exports.getExportReportsSaga = new _RequestSagas2.default(_actions.ExportReportsRequest.get, { method: 'GET', endpoint: _URLS2.default.reports.export });
	getExportReportsSaga.success = /*#__PURE__*/_regenerator2.default.mark(function _callee7(action) {
	    return _regenerator2.default.wrap(function _callee7$(_context7) {
	        while (1) {
	            switch (_context7.prev = _context7.next) {
	                case 0:
	                case 'end':
	                    return _context7.stop();
	            }
	        }
	    }, _callee7, this);
	});
	
	/*Export watchers sagas*/
	var sagas = [(0, _effects.fork)(getReportsSaga.saga), (0, _effects.fork)(putReportsSaga.saga), (0, _effects.fork)(getExportReportsSaga.saga), (0, _effects.fork)(deleteReportsSaga.saga)];
	
	exports.default = sagas;

/***/ },

/***/ 1315:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.putUsersSaga = exports.postUsersSaga = exports.getUsersSaga = undefined;
	
	var _regenerator = __webpack_require__(717);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _actions = __webpack_require__(1299);
	
	var UsersActions = _interopRequireWildcard(_actions);
	
	var _RequestSagas = __webpack_require__(901);
	
	var _RequestSagas2 = _interopRequireDefault(_RequestSagas);
	
	var _effects = __webpack_require__(706);
	
	var _URLS = __webpack_require__(678);
	
	var _URLS2 = _interopRequireDefault(_URLS);
	
	var _reactRouter = __webpack_require__(501);
	
	var _api = __webpack_require__(902);
	
	var _actions2 = __webpack_require__(900);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getUsersSaga = exports.getUsersSaga = new _RequestSagas2.default(UsersActions.UsersRequest.get, { method: 'GET', endpoint: _URLS2.default.users.get });
	getUsersSaga.success = /*#__PURE__*/_regenerator2.default.mark(function _callee(action) {
	    return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	            switch (_context.prev = _context.next) {
	                case 0:
	                case 'end':
	                    return _context.stop();
	            }
	        }
	    }, _callee, this);
	});
	getUsersSaga.failure = /*#__PURE__*/_regenerator2.default.mark(function _callee2(action) {
	    return _regenerator2.default.wrap(function _callee2$(_context2) {
	        while (1) {
	            switch (_context2.prev = _context2.next) {
	                case 0:
	                case 'end':
	                    return _context2.stop();
	            }
	        }
	    }, _callee2, this);
	});
	
	var postUsersSaga = exports.postUsersSaga = new _RequestSagas2.default(UsersActions.UsersRequest.post, { method: 'POST', endpoint: _URLS2.default.users.get });
	postUsersSaga.success = /*#__PURE__*/_regenerator2.default.mark(function _callee3(action) {
	    return _regenerator2.default.wrap(function _callee3$(_context3) {
	        while (1) {
	            switch (_context3.prev = _context3.next) {
	                case 0:
	                    _context3.next = 2;
	                    return (0, _effects.put)(UsersActions.UsersRequest.get.action());
	
	                case 2:
	                    _reactRouter.browserHistory.push((0, _api.makeEndpoint)(_URLS2.default.users.show, action.payload.user));
	                    _context3.next = 5;
	                    return (0, _effects.put)((0, _actions2.flash)({ content: {
	                            type: 'success',
	                            title: 'Utilisateur créé.'
	                        } }));
	
	                case 5:
	                case 'end':
	                    return _context3.stop();
	            }
	        }
	    }, _callee3, this);
	});
	postUsersSaga.failure = /*#__PURE__*/_regenerator2.default.mark(function _callee4(action) {
	    return _regenerator2.default.wrap(function _callee4$(_context4) {
	        while (1) {
	            switch (_context4.prev = _context4.next) {
	                case 0:
	                    _context4.next = 2;
	                    return (0, _effects.put)((0, _actions2.flash)({ content: {
	                            type: 'error',
	                            title: 'Addresse email déjà utilisée.'
	                        } }));
	
	                case 2:
	                case 'end':
	                    return _context4.stop();
	            }
	        }
	    }, _callee4, this);
	});
	
	var putUsersSaga = exports.putUsersSaga = new _RequestSagas2.default(UsersActions.UsersRequest.put, { method: 'PUT', endpoint: _URLS2.default.users.put });
	putUsersSaga.success = /*#__PURE__*/_regenerator2.default.mark(function _callee5(action) {
	    return _regenerator2.default.wrap(function _callee5$(_context5) {
	        while (1) {
	            switch (_context5.prev = _context5.next) {
	                case 0:
	                    if (!action.payload.invite) {
	                        _context5.next = 5;
	                        break;
	                    }
	
	                    _context5.next = 3;
	                    return (0, _effects.put)((0, _actions2.flash)({ content: {
	                            type: 'success',
	                            title: 'Client ré-invité.'
	                        } }));
	
	                case 3:
	                    _context5.next = 7;
	                    break;
	
	                case 5:
	                    _context5.next = 7;
	                    return (0, _effects.put)((0, _actions2.flash)({ content: {
	                            type: 'success',
	                            title: 'Utilisateur modifié.'
	                        } }));
	
	                case 7:
	                    _context5.next = 9;
	                    return (0, _effects.put)(UsersActions.UsersRequest.get.action());
	
	                case 9:
	                case 'end':
	                    return _context5.stop();
	            }
	        }
	    }, _callee5, this);
	});
	putUsersSaga.failure = /*#__PURE__*/_regenerator2.default.mark(function _callee6(action) {
	    return _regenerator2.default.wrap(function _callee6$(_context6) {
	        while (1) {
	            switch (_context6.prev = _context6.next) {
	                case 0:
	                case 'end':
	                    return _context6.stop();
	            }
	        }
	    }, _callee6, this);
	});
	
	/*Export watchers sagas*/
	var sagas = [(0, _effects.fork)(getUsersSaga.saga), (0, _effects.fork)(postUsersSaga.saga), (0, _effects.fork)(putUsersSaga.saga)];
	
	exports.default = sagas;

/***/ },

/***/ 1316:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _socket = __webpack_require__(1317);
	
	var _socket2 = _interopRequireDefault(_socket);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var socket =  true ? (0, _socket2.default)({
	    autoReconnect: true,
	    ackTimeout: 10000
	}) : null;
	
	exports.default = socket;

/***/ },

/***/ 1352:
/***/ function(module, exports) {

	/* (ignored) */

/***/ },

/***/ 1360:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _redux = __webpack_require__(566);
	
	var _reducers = __webpack_require__(1361);
	
	var _reducers2 = _interopRequireDefault(_reducers);
	
	var _reducers3 = __webpack_require__(1362);
	
	var _reducers4 = _interopRequireDefault(_reducers3);
	
	var _reducers5 = __webpack_require__(1363);
	
	var _reducers6 = _interopRequireDefault(_reducers5);
	
	var _reducers7 = __webpack_require__(1364);
	
	var _reducers8 = _interopRequireDefault(_reducers7);
	
	var _reducers9 = __webpack_require__(1365);
	
	var _reducers10 = _interopRequireDefault(_reducers9);
	
	var _reducers11 = __webpack_require__(1366);
	
	var _reducers12 = _interopRequireDefault(_reducers11);
	
	var _reducers13 = __webpack_require__(1367);
	
	var _reducers14 = _interopRequireDefault(_reducers13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var rootReducer = (0, _redux.combineReducers)({
	    session: _reducers6.default,
	    client: _reducers8.default,
	    reports: _reducers10.default,
	    flashes: _reducers2.default,
	    users: _reducers12.default,
	    progressBar: _reducers14.default,
	    form: _reducers4.default
	});
	
	exports.default = rootReducer;

/***/ },

/***/ 1361:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(955);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _extends2 = __webpack_require__(684);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _assign = __webpack_require__(685);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	exports.default = flashes;
	
	var _actions = __webpack_require__(900);
	
	var ActionTypes = _interopRequireWildcard(_actions);
	
	var _underscore = __webpack_require__(715);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = {
	    all: []
	};
	
	var initializeState = function initializeState() {
	    return (0, _assign2.default)({}, initialState);
	};
	
	function flashes() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initializeState();
	    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    switch (action.type) {
	
	        case ActionTypes.NEW_FLASH:
	            return (0, _extends3.default)({}, state, { all: [].concat((0, _toConsumableArray3.default)(state.all), [action.flash]) });
	
	        case ActionTypes.HIDE_FLASH:
	            return (0, _extends3.default)({}, state, { all: _underscore2.default.without(state.all, _underscore2.default.findWhere(state.all, { date: action.flash.date })) });
	
	        default:
	            return state;
	    }
	}

/***/ },

/***/ 1362:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(684);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _actions = __webpack_require__(681);
	
	var _reduxForm = __webpack_require__(720);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var reducer = _reduxForm.reducer.plugin({
	    login: function login(state, action) {
	        switch (action.type) {
	
	            case _actions.LoginRequest.post.TYPES.FAILURE:
	                return (0, _extends3.default)({}, state, { error: action.payload.error });
	
	            default:
	                return state;
	        }
	    }
	});
	
	exports.default = reducer;

/***/ },

/***/ 1363:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(684);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _assign = __webpack_require__(685);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	exports.default = session;
	
	var _actions = __webpack_require__(681);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = {
	    user: {},
	    loaded: false,
	    loggingIn: false,
	    error: null,
	    resetPasswordSubmited: false
	};
	
	var initializeState = function initializeState() {
	    return (0, _assign2.default)({}, initialState);
	};
	
	function session() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initializeState();
	    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    switch (action.type) {
	
	        case _actions.IsAuthRequest.get.TYPES.SUCCESS:
	            return (0, _extends3.default)({}, state, { loggingIn: true, user: action.payload.user, loaded: true, error: null });
	
	        case _actions.IsAuthRequest.get.TYPES.FAILURE:
	            return (0, _extends3.default)({}, state, { loggingIn: false, user: null, loaded: true, error: null });
	
	        case _actions.LoginRequest.post.TYPES.SUCCESS:
	            return (0, _extends3.default)({}, state, { loggingIn: true, user: action.payload.user, loaded: true, error: null });
	
	        case _actions.LoginRequest.post.TYPES.FAILURE:
	            return (0, _extends3.default)({}, state, { loggingIn: false, user: null, loaded: true, error: action.payload.error });
	
	        case _actions.MagicLoginRequest.post.TYPES.FAILURE:
	            return (0, _extends3.default)({}, state, { loggingIn: false, user: null, loaded: true, error: action.payload.error });
	
	        case _actions.MagicLoginRequest.post.TYPES.SUCCESS:
	            return (0, _extends3.default)({}, state, { loggingIn: false, user: null, loaded: true, error: null });
	
	        case _actions.LogoutRequest.get.TYPES.SUCCESS:
	            return (0, _extends3.default)({}, state, { loggingIn: false, user: null, loaded: true, error: null });
	
	        case _actions.CurrentUserRequest.put.TYPES.SUCCESS:
	            return (0, _extends3.default)({}, state, { user: action.payload.user });
	
	        case _actions.ResetPasswordRequest.post.TYPES.REQUEST:
	            return (0, _extends3.default)({}, state, { resetPasswordSubmited: false, resetPasswordProgress: true, resetPasswordFailure: false });
	
	        case _actions.ResetPasswordRequest.post.TYPES.FAILURE:
	            return (0, _extends3.default)({}, state, { resetPasswordFailure: true, resetPasswordProgress: false });
	
	        case _actions.ResetPasswordRequest.post.TYPES.SUCCESS:
	            return (0, _extends3.default)({}, state, { resetPasswordSubmited: true, resetPasswordProgress: false });
	
	        case _actions.SOCKET_CONNECTION:
	            return (0, _extends3.default)({}, state, { socket: { id: action.payload.id } });
	
	        case _actions.SetPasswordRequest.post.TYPES.REQUEST:
	            return (0, _extends3.default)({}, state, { setPasswordSubmited: false, setPasswordProgress: true, setPasswordFailure: false });
	
	        case _actions.SetPasswordRequest.post.TYPES.FAILURE:
	            return (0, _extends3.default)({}, state, { setPasswordFailure: true, setPasswordProgress: false });
	
	        case _actions.SetPasswordRequest.post.TYPES.SUCCESS:
	            return (0, _extends3.default)({}, state, { setPasswordSubmited: true, setPasswordProgress: false });
	
	        default:
	            return state;
	    }
	}

/***/ },

/***/ 1364:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(955);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _extends2 = __webpack_require__(684);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _assign = __webpack_require__(685);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	exports.default = client;
	
	var _actions = __webpack_require__(951);
	
	var ClientActions = _interopRequireWildcard(_actions);
	
	var _underscore = __webpack_require__(715);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = {
	    all: [],
	    current: null,
	    search: null
	};
	
	var initializeState = function initializeState() {
	    return (0, _assign2.default)({}, initialState);
	};
	
	function client() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initializeState();
	    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    var all = state.all;
	    var indexOfIssue = void 0;
	    switch (action.type) {
	
	        case ClientActions.ClientsRequest.get.TYPES.SUCCESS:
	            return (0, _extends3.default)({}, state, { all: action.payload.clients });
	
	        case ClientActions.ClientsRequest.post.TYPES.SUCCESS:
	            return (0, _extends3.default)({}, state, { all: [].concat((0, _toConsumableArray3.default)(all), [action.payload.client]), current: action.payload.client });
	
	        case ClientActions.ClientsRequest.delete.TYPES.SUCCESS:
	            return (0, _extends3.default)({}, state, { current: null });
	
	        case ClientActions.SET_CURRENT_CLIENT:
	            if (!action._id) return (0, _extends3.default)({}, state, { current: null });
	            return (0, _extends3.default)({}, state, { current: _underscore2.default.findWhere(state.all, { _id: action._id }) });
	
	        case ClientActions.HiveRequest.post.TYPES.SUCCESS:
	            indexOfIssue = _underscore2.default.findLastIndex(state.all, { _id: action.payload.client._id });
	            all[indexOfIssue] = action.payload.client;
	            return (0, _extends3.default)({}, state, { current: action.payload.client, all: all });
	
	        case ClientActions.HiveRequest.put.TYPES.SUCCESS:
	            indexOfIssue = _underscore2.default.findLastIndex(state.all, { _id: action.payload.client._id });
	            all[indexOfIssue] = action.payload.client;
	            return (0, _extends3.default)({}, state, { all: all });
	
	        case ClientActions.HiveRequest.delete.TYPES.SUCCESS:
	            indexOfIssue = _underscore2.default.findLastIndex(state.all, { _id: action.payload.client._id });
	            all[indexOfIssue] = action.payload.client;
	            return (0, _extends3.default)({}, state, { all: all, current: action.payload.client });
	
	        case ClientActions.ClientsRequest.put.TYPES.SUCCESS:
	            var index = _underscore2.default.findIndex(all, { _id: action.payload.client._id });
	            if (index !== -1) all[index] = action.payload.client;
	            return (0, _extends3.default)({}, state, { current: action.payload.client, all: all });
	
	        case ClientActions.CLIENT_SEARCH_CHANGE:
	            return (0, _extends3.default)({}, state, { search: action.payload.search });
	
	        default:
	            return state;
	    }
	}

/***/ },

/***/ 1365:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(955);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _extends2 = __webpack_require__(684);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _assign = __webpack_require__(685);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	exports.default = reports;
	
	var _actions = __webpack_require__(953);
	
	var ReportsActions = _interopRequireWildcard(_actions);
	
	var _underscore = __webpack_require__(715);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = {
	    all: [],
	    current: null,
	    filters: {},
	    search: null
	};
	
	var initializeState = function initializeState() {
	    return (0, _assign2.default)({}, initialState);
	};
	
	function reports() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initializeState();
	    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    switch (action.type) {
	
	        case ReportsActions.ReportsRequest.get.TYPES.SUCCESS:
	            return (0, _extends3.default)({}, state, { all: action.payload.reports });
	
	        case ReportsActions.REPORTS_FILTERS_CHANGE:
	            return (0, _extends3.default)({}, state, { filters: action.payload.filters });
	
	        case ReportsActions.REPORTS_SEARCH_CHANGE:
	            return (0, _extends3.default)({}, state, { search: action.payload.search });
	
	        case ReportsActions.SOCKET_NEW_REPORT:
	            return (0, _extends3.default)({}, state, { all: [].concat((0, _toConsumableArray3.default)(state.all), [action.payload.report]) });
	
	        default:
	            return state;
	    }
	}

/***/ },

/***/ 1366:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(684);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _assign = __webpack_require__(685);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	exports.default = reports;
	
	var _actions = __webpack_require__(1299);
	
	var UsersActions = _interopRequireWildcard(_actions);
	
	var _underscore = __webpack_require__(715);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = {
	    all: [],
	    current: null
	};
	
	var initializeState = function initializeState() {
	    return (0, _assign2.default)({}, initialState);
	};
	
	function reports() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initializeState();
	    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    switch (action.type) {
	
	        case UsersActions.UsersRequest.get.TYPES.SUCCESS:
	            return (0, _extends3.default)({}, state, { all: action.payload.users });
	
	        case UsersActions.SET_CURRENT_USER:
	            return (0, _extends3.default)({}, state, { current: action._id });
	
	        default:
	            return state;
	    }
	}

/***/ },

/***/ 1367:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _assign = __webpack_require__(685);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	exports.default = progressBar;
	
	var _underscore = __webpack_require__(715);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = {
	    progress: 0,
	    active: false
	};
	
	var initializeState = function initializeState() {
	    return (0, _assign2.default)({}, initialState);
	};
	
	function progressBar() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initializeState();
	    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    switch (action.type) {
	
	        /*case IssuesActionTypes.IssuesRequest.post.TYPES.PROGRESS:
	            return { ...state, active: true, percent: action.payload.percent || 0 }
	        case IssuesActionTypes.IssuesRequest.post.TYPES.SUCCESS:
	        case IssuesActionTypes.IssuesRequest.post.TYPES.FAILURE:
	            return { ...state, active: false }*/
	
	        default:
	            return state;
	    }
	}

/***/ }

});


// WEBPACK FOOTER //
// bundle.59826b0c9e0c220d725e.js